const SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
const TYPE_ID = 213;
/**
 * Encoding Schema field operations.
 */
var OPERATION;
(function (OPERATION) {
    OPERATION[OPERATION["ADD"] = 128] = "ADD";
    OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
    OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
    OPERATION[OPERATION["DELETE_AND_MOVE"] = 96] = "DELETE_AND_MOVE";
    OPERATION[OPERATION["MOVE_AND_ADD"] = 160] = "MOVE_AND_ADD";
    OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
    /**
     * Collection operations
     */
    OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
    /**
     * ArraySchema operations
     */
    OPERATION[OPERATION["REVERSE"] = 15] = "REVERSE";
    OPERATION[OPERATION["MOVE"] = 32] = "MOVE";
    OPERATION[OPERATION["DELETE_BY_REFID"] = 33] = "DELETE_BY_REFID";
    OPERATION[OPERATION["ADD_BY_REFID"] = 129] = "ADD_BY_REFID";
})(OPERATION || (OPERATION = {}));

Symbol.metadata ??= Symbol.for("Symbol.metadata");

const _g = (function () {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof global !== "undefined")
        return global;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    return {};
})();
if (typeof Symbol === "function" && typeof Symbol.for !== "function") {
    const REGISTRY_KEY = "colyseus.symbolRegistry";
    const registry = _g[REGISTRY_KEY] || (_g[REGISTRY_KEY] = Object.create(null));
    Symbol.for = function (key) {
        return registry[key] || (registry[key] = Symbol(key));
    };
    Symbol.keyFor = function (sym) {
        for (const k in registry)
            if (registry[k] === sym)
                return k;
        return undefined;
    };
}
const $refId = Symbol.for("$refId");
const $track = "~track";
const $encoder = "~encoder";
const $decoder = "~decoder";
const $filter = "~filter";
const $getByIndex = "~getByIndex";
const $deleteByIndex = "~deleteByIndex";
/**
 * Resync-sweep hook (see decoder/Resync.ts): prune every entry the rejoin
 * snapshot did not visit. Each collection owns its storage-specific
 * bookkeeping (journal pruning, compaction, item indexes); the generic
 * DELETE/ref/callback bookkeeping arrives via the `prune`/`keep` callbacks.
 */
const $resyncPrune = "~resyncPrune";
/**
 * Used to hold ChangeTree instances whitin the structures.
 *
 * Real JS Symbol — see the `$values` comment for rationale.
 */
const $changes = Symbol.for("$changes");
/**
 * Used to keep track of the type of the child elements of a collection
 * (MapSchema, ArraySchema, etc.). Real Symbol — same rationale as $values.
 */
const $childType = Symbol.for("$childType");
/**
 * Self-reference an instance sets on `this` so its own methods can recover
 * the underlying object even when `this` is a Proxy wrapper. Used by
 * ArraySchema (whose public API is a Proxy) to grab the underlying instance
 * once at the top of hot methods and then access fields directly without
 * paying the Proxy.get cost on every read.
 */
const $proxyTarget = Symbol.for("$proxyTarget");
/**
 * Optional "discard" method for custom types (ArraySchema)
 * (Discards changes for next serialization)
 */
const $onEncodeEnd = '~onEncodeEnd';
/**
 * Optional "reset" method on every poolable Ref (Schema + collections).
 * Empties the instance's backing store and recycles its ChangeTree WITHOUT
 * emitting any wire op, and recurses into ref-type children — so the instance
 * can be returned to a SchemaPool and reused, avoiding the cost of `new`.
 * See encoder/Pool.ts and Schema.reset().
 */
const $reset = "~reset";
/**
 * When decoding, this method is called after the instance is fully decoded
 */
const $onDecodeEnd = "~onDecodeEnd";
/**
 * Per-instance dense array holding field values by index.
 * Replaces per-field _fieldName shadow properties.
 *
 * Real JS Symbol (not "~"-prefixed string) so plain assignment is safe —
 * symbols are non-enumerable to Object.keys / JSON.stringify / for-in,
 * which means we can drop Object.defineProperty(...{ enumerable: false })
 * and avoid the slow-path / dictionary-mode hazards that come with it.
 */
const $values = Symbol.for("$values");
/**
 * Brand for FieldBuilder instances so schema() can detect them.
 */
const $builder = "~builder";
/**
 * Metadata
 */
const $descriptors = "~descriptors";
/**
 * Per-class bitmask: bit i set iff field i carries a @view tag.
 * Lazily computed from $viewFieldIndexes on first encode pass.
 * Skips the per-field metadata[i].tag property chase in the hot encode loop.
 */
const $filterBitmask = "~__filterBitmask";
/**
 * Cached per-class encode descriptor: bundles encoder fn, filter fn,
 * metadata, isSchema flag, and filterBitmask into one object stashed on
 * the constructor. Replaces 5 separate per-tree property chases /
 * function calls in the encode loop with a single property load.
 */
const $encodeDescriptor = "~__encodeDescriptor";
const $encoders = "~encoders";
const $numFields = "~__numFields";
const $refTypeFieldIndexes = "~__refTypeFieldIndexes";
const $viewFieldIndexes = "~__viewFieldIndexes";
const $fieldIndexesByViewTag = "$__fieldIndexesByViewTag";
const $unreliableFieldIndexes = "~__unreliableFieldIndexes";
const $transientFieldIndexes = "~__transientFieldIndexes";
const $staticFieldIndexes = "~__staticFieldIndexes";
const $streamFieldIndexes = "~__streamFieldIndexes";
const $streamPriorities = "~__streamPriorities";

// @ts-nocheck
/**
 * msgpack implementation highly based on notepack.io
 * https://github.com/darrachequesne/notepack
 */
let textEncoder;
// @ts-ignore
try {
    textEncoder = new TextEncoder();
}
catch (e) { }
const _convoBuffer$1 = new ArrayBuffer(8);
const _int32$1 = new Int32Array(_convoBuffer$1);
const _float32$1 = new Float32Array(_convoBuffer$1);
const _float64$1 = new Float64Array(_convoBuffer$1);
const _int64$1 = new BigInt64Array(_convoBuffer$1);
const hasBufferByteLength = (typeof Buffer !== 'undefined' && Buffer.byteLength);
const utf8Length = (hasBufferByteLength)
    ? Buffer.byteLength // node
    : function (str, _) {
        var c = 0, length = 0;
        for (var i = 0, l = str.length; i < l; i++) {
            c = str.charCodeAt(i);
            if (c < 0x80) {
                length += 1;
            }
            else if (c < 0x800) {
                length += 2;
            }
            else if (c < 0xd800 || c >= 0xe000) {
                length += 3;
            }
            else {
                i++;
                length += 4;
            }
        }
        return length;
    };
function utf8Write(view, str, it) {
    var c = 0;
    for (var i = 0, l = str.length; i < l; i++) {
        c = str.charCodeAt(i);
        if (c < 0x80) {
            view[it.offset++] = c;
        }
        else if (c < 0x800) {
            view[it.offset] = 0xc0 | (c >> 6);
            view[it.offset + 1] = 0x80 | (c & 0x3f);
            it.offset += 2;
        }
        else if (c < 0xd800 || c >= 0xe000) {
            view[it.offset] = 0xe0 | (c >> 12);
            view[it.offset + 1] = 0x80 | (c >> 6 & 0x3f);
            view[it.offset + 2] = 0x80 | (c & 0x3f);
            it.offset += 3;
        }
        else {
            i++;
            c = 0x10000 + (((c & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
            view[it.offset] = 0xf0 | (c >> 18);
            view[it.offset + 1] = 0x80 | (c >> 12 & 0x3f);
            view[it.offset + 2] = 0x80 | (c >> 6 & 0x3f);
            view[it.offset + 3] = 0x80 | (c & 0x3f);
            it.offset += 4;
        }
    }
}
function int8$1(bytes, value, it) {
    bytes[it.offset++] = value & 255;
}
function uint8$1(bytes, value, it) {
    bytes[it.offset++] = value & 255;
}
function int16$1(bytes, value, it) {
    bytes[it.offset++] = value & 255;
    bytes[it.offset++] = (value >> 8) & 255;
}
function uint16$1(bytes, value, it) {
    bytes[it.offset++] = value & 255;
    bytes[it.offset++] = (value >> 8) & 255;
}
function int32$1(bytes, value, it) {
    bytes[it.offset++] = value & 255;
    bytes[it.offset++] = (value >> 8) & 255;
    bytes[it.offset++] = (value >> 16) & 255;
    bytes[it.offset++] = (value >> 24) & 255;
}
function uint32$1(bytes, value, it) {
    const b4 = value >> 24;
    const b3 = value >> 16;
    const b2 = value >> 8;
    const b1 = value;
    bytes[it.offset++] = b1 & 255;
    bytes[it.offset++] = b2 & 255;
    bytes[it.offset++] = b3 & 255;
    bytes[it.offset++] = b4 & 255;
}
function int64$1(bytes, value, it) {
    const high = Math.floor(value / Math.pow(2, 32));
    const low = value >>> 0;
    uint32$1(bytes, low, it);
    uint32$1(bytes, high, it);
}
function uint64$1(bytes, value, it) {
    const high = (value / Math.pow(2, 32)) >> 0;
    const low = value >>> 0;
    uint32$1(bytes, low, it);
    uint32$1(bytes, high, it);
}
function bigint64$1(bytes, value, it) {
    _int64$1[0] = BigInt.asIntN(64, value);
    int32$1(bytes, _int32$1[0], it);
    int32$1(bytes, _int32$1[1], it);
}
function biguint64$1(bytes, value, it) {
    _int64$1[0] = BigInt.asIntN(64, value);
    int32$1(bytes, _int32$1[0], it);
    int32$1(bytes, _int32$1[1], it);
}
function float32$1(bytes, value, it) {
    _float32$1[0] = value;
    int32$1(bytes, _int32$1[0], it);
}
function float64$1(bytes, value, it) {
    _float64$1[0] = value;
    int32$1(bytes, _int32$1[0 ], it);
    int32$1(bytes, _int32$1[1 ], it);
}
function boolean$1(bytes, value, it) {
    bytes[it.offset++] = value ? 1 : 0; // uint8
}
function string$1(bytes, value, it) {
    // encode `null` strings as empty.
    if (!value) {
        value = "";
    }
    let length = utf8Length(value, "utf8");
    let size = 0;
    // fixstr
    if (length < 0x20) {
        bytes[it.offset++] = length | 0xa0;
        size = 1;
    }
    // str 8
    else if (length < 0x100) {
        bytes[it.offset++] = 0xd9;
        bytes[it.offset++] = length;
        size = 2;
    }
    // str 16
    else if (length < 0x10000) {
        bytes[it.offset++] = 0xda;
        uint16$1(bytes, length, it);
        size = 3;
    }
    // str 32
    else if (length < 0x100000000) {
        bytes[it.offset++] = 0xdb;
        uint32$1(bytes, length, it);
        size = 5;
    }
    else {
        throw new Error('String too long');
    }
    utf8Write(bytes, value, it);
    return size + length;
}
function number$1(bytes, value, it) {
    if (isNaN(value)) {
        return number$1(bytes, 0, it);
    }
    else if (!isFinite(value)) {
        return number$1(bytes, (value > 0) ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER, it);
    }
    else if (value !== (value | 0)) {
        if (Math.abs(value) <= 3.4028235e+38) { // range check
            _float32$1[0] = value;
            if (Math.abs(Math.abs(_float32$1[0]) - Math.abs(value)) < 1e-4) { // precision check; adjust 1e-n (n = precision) to in-/decrease acceptable precision loss
                // now we know value is in range for f32 and has acceptable precision for f32
                bytes[it.offset++] = 0xca;
                float32$1(bytes, value, it);
                return 5;
            }
        }
        bytes[it.offset++] = 0xcb;
        float64$1(bytes, value, it);
        return 9;
    }
    if (value >= 0) {
        // positive fixnum
        if (value < 0x80) {
            bytes[it.offset++] = value & 255; // uint8
            return 1;
        }
        // uint 8
        if (value < 0x100) {
            bytes[it.offset++] = 0xcc;
            bytes[it.offset++] = value & 255; // uint8
            return 2;
        }
        // uint 16
        if (value < 0x10000) {
            bytes[it.offset++] = 0xcd;
            uint16$1(bytes, value, it);
            return 3;
        }
        // uint 32
        if (value < 0x100000000) {
            bytes[it.offset++] = 0xce;
            uint32$1(bytes, value, it);
            return 5;
        }
        // uint 64
        bytes[it.offset++] = 0xcf;
        uint64$1(bytes, value, it);
        return 9;
    }
    else {
        // negative fixnum
        if (value >= -32) {
            bytes[it.offset++] = 0xe0 | (value + 0x20);
            return 1;
        }
        // int 8
        if (value >= -128) {
            bytes[it.offset++] = 0xd0;
            int8$1(bytes, value, it);
            return 2;
        }
        // int 16
        if (value >= -32768) {
            bytes[it.offset++] = 0xd1;
            int16$1(bytes, value, it);
            return 3;
        }
        // int 32
        if (value >= -2147483648) {
            bytes[it.offset++] = 0xd2;
            int32$1(bytes, value, it);
            return 5;
        }
        // int 64
        bytes[it.offset++] = 0xd3;
        int64$1(bytes, value, it);
        return 9;
    }
}
const encode = {
    int8: int8$1,
    uint8: uint8$1,
    int16: int16$1,
    uint16: uint16$1,
    int32: int32$1,
    uint32: uint32$1,
    int64: int64$1,
    uint64: uint64$1,
    bigint64: bigint64$1,
    biguint64: biguint64$1,
    float32: float32$1,
    float64: float64$1,
    boolean: boolean$1,
    string: string$1,
    number: number$1,
    utf8Write,
    utf8Length,
};

// @ts-nocheck
// force little endian to facilitate decoding on multiple implementations
const _convoBuffer = new ArrayBuffer(8);
const _int32 = new Int32Array(_convoBuffer);
const _float32 = new Float32Array(_convoBuffer);
const _float64 = new Float64Array(_convoBuffer);
const _uint64 = new BigUint64Array(_convoBuffer);
const _int64 = new BigInt64Array(_convoBuffer);
function utf8Read(bytes, it, length) {
    // boundary check
    if (length > bytes.length - it.offset) {
        length = bytes.length - it.offset;
    }
    var string = '', chr = 0;
    for (var i = it.offset, end = it.offset + length; i < end; i++) {
        var byte = bytes[i];
        if ((byte & 0x80) === 0x00) {
            string += String.fromCharCode(byte);
            continue;
        }
        if ((byte & 0xe0) === 0xc0) {
            string += String.fromCharCode(((byte & 0x1f) << 6) |
                (bytes[++i] & 0x3f));
            continue;
        }
        if ((byte & 0xf0) === 0xe0) {
            string += String.fromCharCode(((byte & 0x0f) << 12) |
                ((bytes[++i] & 0x3f) << 6) |
                ((bytes[++i] & 0x3f) << 0));
            continue;
        }
        if ((byte & 0xf8) === 0xf0) {
            chr = ((byte & 0x07) << 18) |
                ((bytes[++i] & 0x3f) << 12) |
                ((bytes[++i] & 0x3f) << 6) |
                ((bytes[++i] & 0x3f) << 0);
            if (chr >= 0x010000) { // surrogate pair
                chr -= 0x010000;
                string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
            }
            else {
                string += String.fromCharCode(chr);
            }
            continue;
        }
        // (do not throw error to avoid server/client from crashing due to hack attemps)
        // throw new Error('Invalid byte ' + byte.toString(16));
        console.error('decode.utf8Read(): Invalid byte ' + byte + ' at offset ' + i + '. Skip to end of string: ' + (it.offset + length));
        break;
    }
    it.offset += length;
    return string;
}
function int8(bytes, it) {
    return uint8(bytes, it) << 24 >> 24;
}
function uint8(bytes, it) {
    return bytes[it.offset++];
}
function int16(bytes, it) {
    return uint16(bytes, it) << 16 >> 16;
}
function uint16(bytes, it) {
    return bytes[it.offset++] | bytes[it.offset++] << 8;
}
function int32(bytes, it) {
    return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
}
function uint32(bytes, it) {
    return int32(bytes, it) >>> 0;
}
function float32(bytes, it) {
    _int32[0] = int32(bytes, it);
    return _float32[0];
}
function float64(bytes, it) {
    _int32[0 ] = int32(bytes, it);
    _int32[1 ] = int32(bytes, it);
    return _float64[0];
}
function int64(bytes, it) {
    const low = uint32(bytes, it);
    const high = int32(bytes, it) * Math.pow(2, 32);
    return high + low;
}
function uint64(bytes, it) {
    const low = uint32(bytes, it);
    const high = uint32(bytes, it) * Math.pow(2, 32);
    return high + low;
}
function bigint64(bytes, it) {
    _int32[0] = int32(bytes, it);
    _int32[1] = int32(bytes, it);
    return _int64[0];
}
function biguint64(bytes, it) {
    _int32[0] = int32(bytes, it);
    _int32[1] = int32(bytes, it);
    return _uint64[0];
}
function boolean(bytes, it) {
    return uint8(bytes, it) > 0;
}
function string(bytes, it) {
    const prefix = bytes[it.offset++];
    let length;
    if (prefix < 0xc0) {
        // fixstr
        length = prefix & 0x1f;
    }
    else if (prefix === 0xd9) {
        length = uint8(bytes, it);
    }
    else if (prefix === 0xda) {
        length = uint16(bytes, it);
    }
    else if (prefix === 0xdb) {
        length = uint32(bytes, it);
    }
    return utf8Read(bytes, it, length);
}
function number(bytes, it) {
    const prefix = bytes[it.offset++];
    if (prefix < 0x80) {
        // positive fixint
        return prefix;
    }
    else if (prefix === 0xca) {
        // float 32
        return float32(bytes, it);
    }
    else if (prefix === 0xcb) {
        // float 64
        return float64(bytes, it);
    }
    else if (prefix === 0xcc) {
        // uint 8
        return uint8(bytes, it);
    }
    else if (prefix === 0xcd) {
        // uint 16
        return uint16(bytes, it);
    }
    else if (prefix === 0xce) {
        // uint 32
        return uint32(bytes, it);
    }
    else if (prefix === 0xcf) {
        // uint 64
        return uint64(bytes, it);
    }
    else if (prefix === 0xd0) {
        // int 8
        return int8(bytes, it);
    }
    else if (prefix === 0xd1) {
        // int 16
        return int16(bytes, it);
    }
    else if (prefix === 0xd2) {
        // int 32
        return int32(bytes, it);
    }
    else if (prefix === 0xd3) {
        // int 64
        return int64(bytes, it);
    }
    else if (prefix > 0xdf) {
        // negative fixint
        return (0xff - prefix + 1) * -1;
    }
}
function stringCheck(bytes, it) {
    const prefix = bytes[it.offset];
    return (
    // fixstr
    (prefix < 0xc0 && prefix > 0xa0) ||
        // str 8
        prefix === 0xd9 ||
        // str 16
        prefix === 0xda ||
        // str 32
        prefix === 0xdb);
}
const decode = {
    utf8Read,
    int8,
    uint8,
    int16,
    uint16,
    int32,
    uint32,
    float32,
    float64,
    int64,
    uint64,
    bigint64,
    biguint64,
    boolean,
    string,
    number,
    stringCheck,
};

const registeredTypes = {};
const identifiers = new Map();
function registerType(identifier, definition) {
    if (definition.constructor) {
        identifiers.set(definition.constructor, identifier);
        registeredTypes[identifier] = definition;
    }
    if (definition.encode) {
        encode[identifier] = definition.encode;
    }
    if (definition.decode) {
        decode[identifier] = definition.decode;
    }
}
function getType(identifier) {
    return registeredTypes[identifier];
}
function defineCustomTypes(types) {
    for (const identifier in types) {
        registerType(identifier, types[identifier]);
    }
    return (t) => type(t);
}

/**
 * Shared routing helpers for streamable collections (`StreamSchema`,
 * `MapSchema.stream()`, etc.).
 *
 * Each streamable class carries exactly one lazy slot (`_stream`) that
 * holds the 6 per-view / broadcast bookkeeping structures. Keeping the
 * slot undefined until streaming actually activates means non-streaming
 * `MapSchema` / `SetSchema` instances pay zero Map/Set allocations. One
 * declared slot → hidden-class shape stays stable across streaming and
 * non-streaming instances, so V8's ICs on `$items` / `journal` / etc.
 * stay monomorphic.
 *
 * Lives alongside `changeTree/*.ts` — another directory of module-level
 * free functions that operate on ChangeTree instances.
 */
/**
 * Thrown (from both the `FieldBuilder` chainable and the decorator's
 * `addField` auto-flag) when a user attempts to stream an ArraySchema.
 * Centralized so the two callsites emit the same diagnostic.
 */
const ARRAY_STREAM_NOT_SUPPORTED = "ArraySchema does not support streaming — positional ops " +
    "(splice / unshift / reverse) shift subsequent indexes, so holding " +
    "ADDs back for a later tick under `maxPerTick` would desync the " +
    "decoder. Use `t.stream(X)` (stable monotonic positions) or " +
    "`t.map(X).stream()` (stable keys) instead.";
function createStreamableState() {
    return {
        pendingByView: new Map(),
        sentByView: new Map(),
        broadcastPending: new Set(),
        sentBroadcast: new Set(),
        broadcastDeletes: new Set(),
        maxPerTick: 32,
    };
}
/** Allocate `_stream` on first use (idempotent). Returns the state. */
function ensureStreamState(s) {
    return (s._stream ??= createStreamableState());
}
/**
 * Route an ADD into the pending backlogs.
 * - No active views: push into broadcast pending (shared encode drains up
 *   to `maxPerTick` per tick).
 * - With views: push into per-view pending for every currently-bound view.
 */
function streamRouteAdd(s, root, index) {
    // Broadcast mode (no views registered): seed broadcast pending so
    // the shared `encode()` pass drains it up to `maxPerTick` per tick.
    // View mode: do nothing — users must call `view.add(element)` per
    // entity to subscribe it for that view. This matches the StateView
    // design philosophy: per-client visibility is imperative, not
    // declarative. An encode-time predicate would be O(views × entities)
    // each tick — the whole reason StateView exists is to push that
    // bookkeeping to game-loop cadence.
    if (root.activeViews.size === 0) {
        ensureStreamState(s).broadcastPending.add(index);
    }
}
/**
 * Route a REMOVE: silent-drop if never sent, force DELETE if already sent.
 * Returns `true` iff no wire op reached any channel (caller can skip
 * follow-on work like snapshotting the deleted value).
 */
function streamRouteRemove(s, root, refId, index) {
    // If `_stream` is still undefined, streaming never saw any add/remove —
    // nothing to unwind, and nothing was ever emitted.
    const st = s._stream;
    if (st === undefined)
        return true;
    let neverSent = false;
    // Broadcast side.
    if (st.broadcastPending.delete(index)) {
        neverSent = true;
    }
    else if (st.sentBroadcast.delete(index)) {
        st.broadcastDeletes.add(index);
    }
    // Per-view side.
    root.forEachActiveView((view) => {
        const pending = st.pendingByView.get(view.id);
        if (pending?.has(index)) {
            pending.delete(index);
            neverSent = true;
            return;
        }
        const sent = st.sentByView.get(view.id);
        if (sent?.has(index)) {
            sent.delete(index);
            let changes = view.changes.get(refId);
            if (changes === undefined) {
                changes = new Map();
                view.changes.set(refId, changes);
            }
            changes.set(index, OPERATION.DELETE);
        }
    });
    return neverSent;
}
/**
 * Queue DELETE ops for every already-sent entry on all channels and
 * reset pending. Caller is responsible for actually clearing its own
 * storage and releasing any element refs it owns.
 */
function streamRouteClear(s, root, refId) {
    const st = s._stream;
    if (st === undefined)
        return;
    // Broadcast: drop never-sent pending; force DELETE for sent entries.
    st.broadcastPending.clear();
    for (const index of st.sentBroadcast)
        st.broadcastDeletes.add(index);
    st.sentBroadcast.clear();
    // Per-view: clear pending; force DELETE for sent entries via
    // `view.changes` (drained first in encodeView).
    root.forEachActiveView((view) => {
        st.pendingByView.get(view.id)?.clear();
        const sent = st.sentByView.get(view.id);
        if (sent !== undefined && sent.size > 0) {
            let changes = view.changes.get(refId);
            if (changes === undefined) {
                changes = new Map();
                view.changes.set(refId, changes);
            }
            for (const index of sent)
                changes.set(index, OPERATION.DELETE);
            sent.clear();
        }
    });
}
/**
 * Push a single position into `_pendingByView[viewId]` — the building
 * block for `StateView.add(element)` when the element lives under a
 * streamable collection. Idempotent for already-pending positions.
 */
function streamEnqueueForView(s, viewId, index) {
    const st = ensureStreamState(s);
    let pending = st.pendingByView.get(viewId);
    if (pending === undefined) {
        pending = new Set();
        st.pendingByView.set(viewId, pending);
    }
    pending.add(index);
}
/**
 * Unsubscribe a single position from a view. Returns true iff the
 * element had already been sent and a DELETE op was queued on
 * `view.changes`; false if it was only pending (silent drop) or not
 * present at all.
 */
function streamDequeueForView(s, viewId, refId, index, viewChanges) {
    const st = s._stream;
    if (st === undefined)
        return false;
    const pending = st.pendingByView.get(viewId);
    if (pending?.has(index)) {
        pending.delete(index);
        return false;
    }
    const sent = st.sentByView.get(viewId);
    if (sent?.has(index)) {
        sent.delete(index);
        let changes = viewChanges.get(refId);
        if (changes === undefined) {
            changes = new Map();
            viewChanges.set(refId, changes);
        }
        changes.set(index, OPERATION.DELETE);
        return true;
    }
    return false;
}
/**
 * Drop all per-view state for a disposing/GC'd StateView. Keeps memory
 * bounded in long-running rooms with client churn.
 */
function streamDropView(s, viewId) {
    const st = s._stream;
    if (st === undefined)
        return;
    st.pendingByView.delete(viewId);
    st.sentByView.delete(viewId);
}

const WIRE_BY_BITS = {
    8: "uint8",
    16: "uint16",
    32: "uint32",
};
/** Validate options and precompute the wire codec + scale span. */
function resolveQuantize(opts) {
    if (opts == null || typeof opts !== "object") {
        throw new Error("t.quantized(): options object with { min, max } is required.");
    }
    const { min, max } = opts;
    if (typeof min !== "number" || typeof max !== "number" || !(max > min)
        || !Number.isFinite(min) || !Number.isFinite(max)) {
        throw new Error(`t.quantized(): require finite min < max (got min=${min}, max=${max}).`);
    }
    const bits = opts.bits ?? 16;
    if (bits !== 8 && bits !== 16 && bits !== 32) {
        throw new Error(`t.quantized(): bits must be 8, 16 or 32 (got ${bits}).`);
    }
    const mode = opts.mode ?? "clamp";
    if (mode !== "clamp" && mode !== "wrap") {
        throw new Error(`t.quantized(): mode must be "clamp" or "wrap" (got ${JSON.stringify(mode)}).`);
    }
    const wrap = mode === "wrap"; // descriptor + wire stay boolean; `mode` is the public knob
    const steps = Math.pow(2, bits);
    return {
        min,
        max,
        bits,
        wrap,
        wire: WIRE_BY_BITS[bits],
        range: max - min,
        // wrapping spreads `2^bits` steps across [min,max) (top ≡ bottom); clamped
        // maps the endpoints onto `0` and `2^bits − 1` inclusive.
        span: wrap ? steps : steps - 1,
    };
}
/** Type guard for the `{ quantized: QuantizeDescriptor }` field-type shape. */
function isQuantizedType(type) {
    return type !== null && typeof type === "object" && type.quantized !== undefined;
}
/**
 * Float → unsigned integer. Rounding is explicit half-up `floor(x + 0.5)`;
 * wrapping ranges are reduced in the float domain first (no huge→int cast).
 */
function quantize(desc, value) {
    if (desc.wrap) {
        // Non-finite can't be range-reduced (Inf % range = NaN); NaN would flow to
        // the wire as garbage while the local instance kept NaN — a silent peer
        // divergence. Pin to q=0 (= min): garbage in, deterministic out, both agree.
        if (!Number.isFinite(value))
            return 0;
        const range = desc.range;
        // float-domain range reduction → [0, range)
        let a = (value - desc.min) % range;
        if (a < 0)
            a += range;
        const steps = desc.span; // 2^bits
        // `% steps` (not `& mask`) so bits=32 doesn't overflow JS's int32 bitwise.
        return Math.floor((a / range) * steps + 0.5) % steps;
    }
    if (value !== value)
        return 0; // NaN → min (±Inf clamps naturally below)
    const v = value < desc.min ? desc.min : value > desc.max ? desc.max : value;
    return Math.floor(((v - desc.min) / desc.range) * desc.span + 0.5);
}
/** Unsigned integer → float. Correctly-rounded mul/div ⇒ bit-identical across languages. */
function dequantize(desc, q) {
    return desc.min + (q / desc.span) * desc.range;
}
/**
 * Pre-baked encoder for a quantized field: quantize the (snapped) float held on
 * the instance, then write it with the field's unsigned-int wire codec. Stored in
 * `metadata[$encoders]` so the encode hot path reaches it via the fast lane,
 * exactly like the pre-computed primitive encoders.
 */
function makeQuantizedEncoder(desc) {
    const writeWire = encode[desc.wire];
    return (bytes, value, it) => writeWire(bytes, quantize(desc, value), it);
}
/** Decode a quantized field: read the unsigned-int wire value, then dequantize. */
function decodeQuantized(desc, bytes, it) {
    const readWire = decode[desc.wire];
    return dequantize(desc, readWire(bytes, it));
}

class TypeContext {
    types = {};
    schemas = new Map();
    hasFilters = false;
    parentFiltered = {};
    /**
     * True iff `parentFiltered` has at least one entry. Flipped on by
     * `registerFilteredByParent` and read in `checkInheritedFlags` as a
     * cheap gate to skip the string-keyed `parentFiltered[key]` lookup
     * when no class has registered filter inheritance via ancestry — the
     * common case when @view tags exist only on sibling fields, not
     * along any attachment chain.
     */
    hasParentFilteredEntries = false;
    /**
     * For inheritance support
     * Keeps track of which classes extends which. (parent -> children)
     */
    static inheritedTypes = new Map();
    static cachedContexts = new Map();
    static register(target) {
        const parent = Object.getPrototypeOf(target);
        if (parent !== Schema) {
            let inherits = TypeContext.inheritedTypes.get(parent);
            if (!inherits) {
                inherits = new Set();
                TypeContext.inheritedTypes.set(parent, inherits);
            }
            inherits.add(target);
        }
    }
    static cache(rootClass) {
        let context = TypeContext.cachedContexts.get(rootClass);
        if (!context) {
            context = new TypeContext(rootClass);
            TypeContext.cachedContexts.set(rootClass, context);
        }
        return context;
    }
    constructor(rootClass) {
        if (rootClass) {
            this.discoverTypes(rootClass);
        }
    }
    has(schema) {
        return this.schemas.has(schema);
    }
    get(typeid) {
        return this.types[typeid];
    }
    add(schema, typeid = this.schemas.size) {
        // skip if already registered
        if (this.schemas.has(schema)) {
            return false;
        }
        this.types[typeid] = schema;
        //
        // Workaround to allow using an empty Schema (with no `@type()` fields)
        //
        if (schema[Symbol.metadata] === undefined) {
            Metadata.initialize(schema);
        }
        this.schemas.set(schema, typeid);
        return true;
    }
    getTypeId(klass) {
        return this.schemas.get(klass);
    }
    discoverTypes(klass, parentType, parentIndex, parentHasViewTag) {
        if (parentHasViewTag) {
            this.registerFilteredByParent(klass, parentType, parentIndex);
        }
        // skip if already registered
        if (!this.add(klass)) {
            return;
        }
        // add classes inherited from this base class
        TypeContext.inheritedTypes.get(klass)?.forEach((child) => {
            this.discoverTypes(child, parentType, parentIndex, parentHasViewTag);
        });
        // add parent classes
        let parent = klass;
        while ((parent = Object.getPrototypeOf(parent)) &&
            parent !== Schema && // stop at root (Schema)
            parent !== Function.prototype // stop at root (non-Schema)
        ) {
            this.discoverTypes(parent);
        }
        const metadata = (klass[Symbol.metadata] ??= {});
        // if any schema/field has filters, mark "context" as having filters.
        // Stream fields are always view-scoped — treat like @view tags for
        // filter inheritance.
        if (metadata[$viewFieldIndexes] || metadata[$streamFieldIndexes]) {
            this.hasFilters = true;
        }
        for (const fieldIndex in metadata) {
            const index = fieldIndex;
            const fieldType = metadata[index].type;
            const fieldHasViewTag = (metadata[index].tag !== undefined);
            if (typeof (fieldType) === "string") {
                continue;
            }
            // Quantized fields are scalar — their object `type` only carries the
            // descriptor, there's no child Schema to discover.
            if (isQuantizedType(fieldType)) {
                continue;
            }
            if (typeof (fieldType) === "function") {
                this.discoverTypes(fieldType, klass, index, parentHasViewTag || fieldHasViewTag);
            }
            else {
                const type = Object.values(fieldType)[0];
                // skip primitive types
                if (typeof (type) === "string") {
                    continue;
                }
                this.discoverTypes(type, klass, index, parentHasViewTag || fieldHasViewTag);
            }
        }
    }
    /**
     * Keep track of which classes have filters applied.
     * Format: `${typeid}-${parentTypeid}-${parentIndex}`
     */
    registerFilteredByParent(schema, parentType, parentIndex) {
        const typeid = this.schemas.get(schema) ?? this.schemas.size;
        let key = `${typeid}`;
        if (parentType) {
            key += `-${this.schemas.get(parentType)}`;
        }
        key += `-${parentIndex}`;
        this.parentFiltered[key] = true;
        this.hasParentFilteredEntries = true;
    }
    debug() {
        let parentFiltered = "";
        for (const key in this.parentFiltered) {
            const keys = key.split("-").map(Number);
            const fieldIndex = keys.pop();
            parentFiltered += `\n\t\t`;
            parentFiltered += `${key}: ${keys.reverse().map((id, i) => {
                const klass = this.types[id];
                const metadata = klass[Symbol.metadata];
                let txt = klass.name;
                if (i === 0) {
                    txt += `[${metadata[fieldIndex].name}]`;
                }
                return `${txt}`;
            }).join(" -> ")}`;
        }
        return `TypeContext ->\n` +
            `\tSchema types: ${this.schemas.size}\n` +
            `\thasFilters: ${this.hasFilters}\n` +
            `\tparentFiltered:${parentFiltered}`;
    }
}

/**
 * Given a normalized field type (`"number"`, `{ map: Foo }`, `Player`,
 * etc.), split into the collection-type descriptor (`{ constructor:
 * MapSchema, ... }`) if applicable and the inner child type. Shared by
 * `@type()` decoration and `Metadata.setFields` — both need to build a
 * property accessor that knows whether the slot holds a collection.
 */
function resolveFieldType(type) {
    const complexTypeKlass = typeof (Object.keys(type)[0]) === "string" && getType(Object.keys(type)[0]);
    return {
        complexTypeKlass,
        childType: complexTypeKlass ? Object.values(type)[0] : type,
    };
}
function getNormalizedType(type) {
    if (Array.isArray(type)) {
        return { array: getNormalizedType(type[0]) };
    }
    else if (isQuantizedType(type)) {
        // `{ quantized: ... }` — a scalar wire type, NOT a collection/ref. Resolve
        // raw options (the `@type({quantized:{min,max}})` path) once; an already-
        // resolved descriptor (the `t.quantized()` builder path) passes through.
        return (typeof type.quantized.wire === "string")
            ? type
            : { quantized: resolveQuantize(type.quantized) };
    }
    else if (typeof (type['type']) !== "undefined") {
        return type['type'];
    }
    else if (isTSEnum(type)) {
        // Detect TS Enum type (either string or number)
        return Object.keys(type).every(key => typeof type[key] === "string")
            ? "string"
            : "number";
    }
    else if (typeof type === "object" && type !== null) {
        // Handle collection types
        const collectionType = Object.keys(type).find(k => registeredTypes[k] !== undefined);
        if (collectionType) {
            type[collectionType] = getNormalizedType(type[collectionType]);
            return type;
        }
    }
    return type;
}
function isTSEnum(_enum) {
    if (typeof _enum === 'function' && _enum[Symbol.metadata]) {
        return false;
    }
    const keys = Object.keys(_enum);
    const numericFields = keys.filter(k => /\d+/.test(k));
    // Check for number enum (has numeric keys and reverse mapping)
    if (numericFields.length > 0 && numericFields.length === (keys.length / 2) && _enum[_enum[numericFields[0]]] == numericFields[0]) {
        return true;
    }
    // Check for string enum (all values are strings and keys match values)
    if (keys.length > 0 && keys.every(key => typeof _enum[key] === 'string' && _enum[key] === key)) {
        return true;
    }
    return false;
}
const Metadata = {
    addField(metadata, index, name, type, descriptor) {
        if (index > 64) {
            throw new Error(`Can't define field '${name}'.\nSchema instances may only have up to 64 fields.`);
        }
        metadata[index] = Object.assign(metadata[index] || {}, // avoid overwriting previous field metadata (@owned / @deprecated)
        {
            type: getNormalizedType(type),
            index,
            name,
        });
        // create "descriptors" map
        Object.defineProperty(metadata, $descriptors, {
            value: metadata[$descriptors] || {},
            enumerable: false,
            configurable: true,
        });
        if (descriptor) {
            // Accessor descriptor for the public field name.
            // Installed on the prototype at class-definition time.
            metadata[$descriptors][name] = descriptor;
        }
        else {
            // For decoder: simple writable slot, also on prototype.
            metadata[$descriptors][name] = {
                value: undefined,
                writable: true,
                enumerable: true,
                configurable: true,
            };
        }
        // map -1 as last field index
        Object.defineProperty(metadata, $numFields, {
            value: index,
            enumerable: false,
            configurable: true
        });
        // map field name => index (non enumerable)
        Object.defineProperty(metadata, name, {
            value: index,
            enumerable: false,
            configurable: true,
        });
        // if child Ref/complex type, add to -4. Quantized fields are scalar (their
        // `type` is an object only to carry the descriptor) — not refs, so skip them.
        if (typeof (metadata[index].type) !== "string" && !isQuantizedType(metadata[index].type)) {
            if (metadata[$refTypeFieldIndexes] === undefined) {
                Object.defineProperty(metadata, $refTypeFieldIndexes, {
                    value: [],
                    enumerable: false,
                    configurable: true,
                });
            }
            metadata[$refTypeFieldIndexes].push(index);
        }
        // `{ stream: ... }` collections are always view-scoped (priority-
        // batched emit). Auto-flag here so both `@type({stream: ...})` and
        // the `t.stream(...)` builder route into the same filter / encoder
        // dispatch without the caller needing an extra setStream() call.
        const t = metadata[index].type;
        if (t && typeof t === "object" && t["stream"] !== undefined) {
            // Reject the combined shorthand `@type({ array: X, stream:
            // true })` at decoration time — same diagnostic as the
            // builder chainable throws for `t.array(X).stream()`.
            if (t.array !== undefined) {
                throw new Error(ARRAY_STREAM_NOT_SUPPORTED);
            }
            metadata[index].stream = true;
            if (!metadata[$streamFieldIndexes]) {
                Object.defineProperty(metadata, $streamFieldIndexes, {
                    value: [],
                    enumerable: false,
                    configurable: true,
                    writable: true,
                });
            }
            if (!metadata[$streamFieldIndexes].includes(index)) {
                metadata[$streamFieldIndexes].push(index);
            }
            // Pick up the declaration-scope priority callback if present in
            // the `@type({ stream: X, priority: fn })` shorthand.
            const priorityFn = type?.priority;
            if (typeof priorityFn === "function") {
                Metadata.setStreamPriority(metadata, name, priorityFn);
            }
        }
    },
    setTag(metadata, fieldName, tag) {
        const index = metadata[fieldName];
        const field = metadata[index];
        // add 'tag' to the field
        field.tag = tag;
        if (!metadata[$viewFieldIndexes]) {
            // -2: all field indexes with "view" tag
            Object.defineProperty(metadata, $viewFieldIndexes, {
                value: [],
                enumerable: false,
                configurable: true
            });
            // -3: field indexes by "view" tag
            Object.defineProperty(metadata, $fieldIndexesByViewTag, {
                value: {},
                enumerable: false,
                configurable: true
            });
        }
        metadata[$viewFieldIndexes].push(index);
        // Populate $fieldIndexesByViewTag: for a bitmask tag, register the field
        // index under each individual set bit so that view.add(obj, Tag.ONE) finds
        // fields tagged @view(Tag.ONE|Tag.TWO).
        // Negative tags (i.e. DEFAULT_VIEW_TAG = -1) are stored as-is.
        if (tag < 0) {
            if (!metadata[$fieldIndexesByViewTag][tag]) {
                metadata[$fieldIndexesByViewTag][tag] = [];
            }
            metadata[$fieldIndexesByViewTag][tag].push(index);
        }
        else {
            for (let bits = tag; bits > 0; bits &= bits - 1) {
                const bit = bits & (-bits); // isolate lowest set bit
                if (!metadata[$fieldIndexesByViewTag][bit]) {
                    metadata[$fieldIndexesByViewTag][bit] = [];
                }
                metadata[$fieldIndexesByViewTag][bit].push(index);
            }
        }
    },
    setUnreliable(metadata, fieldName) {
        const index = metadata[fieldName];
        const fieldType = metadata[index].type;
        // `@unreliable` is only valid on primitive fields. Ref-type fields
        // (Schema sub-classes, MapSchema, ArraySchema, SetSchema,
        // CollectionSchema) carry refIds whose ADD/DELETE must arrive
        // on the reliable channel — otherwise a dropped unreliable packet
        // would leave the decoder unable to interpret subsequent packets
        // referencing the orphan refId. Primitive types are encoded as
        // strings ("number", "string", "int32", ...); anything else is a
        // ref. Reject at decoration time so the bug surfaces in dev, not
        // under packet loss in prod.
        if (typeof fieldType !== "string") {
            throw new Error(`@unreliable cannot be applied to ref-type field "${fieldName}". ` +
                `For ref-type fields, mark each primitive sub-field with @unreliable instead. ` +
                `See README "Limitations and best practices".`);
        }
        metadata[index].unreliable = true;
        if (!metadata[$unreliableFieldIndexes]) {
            Object.defineProperty(metadata, $unreliableFieldIndexes, {
                value: [],
                enumerable: false,
                configurable: true,
                writable: true,
            });
        }
        metadata[$unreliableFieldIndexes].push(index);
    },
    setTransient(metadata, fieldName) {
        const index = metadata[fieldName];
        metadata[index].transient = true;
        if (!metadata[$transientFieldIndexes]) {
            Object.defineProperty(metadata, $transientFieldIndexes, {
                value: [],
                enumerable: false,
                configurable: true,
                writable: true,
            });
        }
        metadata[$transientFieldIndexes].push(index);
    },
    setStatic(metadata, fieldName) {
        const index = metadata[fieldName];
        metadata[index].static = true;
        if (!metadata[$staticFieldIndexes]) {
            Object.defineProperty(metadata, $staticFieldIndexes, {
                value: [],
                enumerable: false,
                configurable: true,
                writable: true,
            });
        }
        metadata[$staticFieldIndexes].push(index);
    },
    setStream(metadata, fieldName) {
        const index = metadata[fieldName];
        metadata[index].stream = true;
        if (!metadata[$streamFieldIndexes]) {
            Object.defineProperty(metadata, $streamFieldIndexes, {
                value: [],
                enumerable: false,
                configurable: true,
                writable: true,
            });
        }
        metadata[$streamFieldIndexes].push(index);
    },
    /**
     * Attach a declaration-scope priority callback to a stream field.
     * Called at schema definition time (via `t.stream(X).priority(fn)` or
     * `@type({ stream: X, priority: fn })`), looked up at stream-attach
     * time to seed the instance's `_stream.priority` slot. The callback
     * signature is `(view: StateView, element: V) => number` — only fires
     * during `encodeView`, broadcast mode emits FIFO regardless.
     */
    setStreamPriority(metadata, fieldName, fn) {
        const index = metadata[fieldName];
        if (!metadata[$streamPriorities]) {
            Object.defineProperty(metadata, $streamPriorities, {
                value: {},
                enumerable: false,
                configurable: true,
                writable: true,
            });
        }
        metadata[$streamPriorities][index] = fn;
    },
    getStreamPriority(metadata, index) {
        return metadata?.[$streamPriorities]?.[index];
    },
    /**
     * Install a single field with full encoder wiring: accessor descriptor
     * on the prototype + `metadata[$encoders]` slot for primitives. Shared
     * between `Metadata.setFields` (build path) and
     * `Reflection.makeEncodable` (Reflection upgrade path).
     */
    defineField(target, metadata, fieldIndex, fieldName, type) {
        const normalized = getNormalizedType(type);
        const { complexTypeKlass, childType } = resolveFieldType(normalized);
        Metadata.addField(metadata, fieldIndex, fieldName, normalized, getPropertyDescriptor(fieldName, fieldIndex, childType, complexTypeKlass));
        // Install accessor descriptor on the prototype (once per class field).
        if (metadata[$descriptors][fieldName]) {
            Object.defineProperty(target.prototype, fieldName, metadata[$descriptors][fieldName]);
        }
        // Pre-compute encoder function for primitive + quantized types.
        if (typeof normalized === "string" || isQuantizedType(normalized)) {
            if (!metadata[$encoders]) {
                Object.defineProperty(metadata, $encoders, {
                    value: [],
                    enumerable: false,
                    configurable: true,
                    writable: true,
                });
            }
            metadata[$encoders][fieldIndex] = (typeof normalized === "string")
                ? encode[normalized]
                : makeQuantizedEncoder(normalized.quantized);
        }
    },
    setFields(target, fields) {
        // for inheritance support
        const constructor = target.prototype.constructor;
        TypeContext.register(constructor);
        const parentClass = Object.getPrototypeOf(constructor);
        const parentMetadata = parentClass && parentClass[Symbol.metadata];
        const metadata = Metadata.initialize(constructor);
        // Use Schema's methods if not defined in the class
        if (!constructor[$track]) {
            constructor[$track] = Schema[$track];
        }
        if (!constructor[$encoder]) {
            constructor[$encoder] = Schema[$encoder];
        }
        if (!constructor[$decoder]) {
            constructor[$decoder] = Schema[$decoder];
        }
        if (!constructor.prototype.toJSON) {
            constructor.prototype.toJSON = Schema.prototype.toJSON;
        }
        //
        // detect index for this field, considering inheritance
        //
        let fieldIndex = metadata[$numFields] // current structure already has fields defined
            ?? (parentMetadata && parentMetadata[$numFields]) // parent structure has fields defined
            ?? -1; // no fields defined
        fieldIndex++;
        // Pre-computed encoder function table: metadata[$encoders][fieldIndex] = encode.uint8 etc.
        if (!metadata[$encoders]) {
            Object.defineProperty(metadata, $encoders, {
                value: parentMetadata?.[$encoders] ? [...parentMetadata[$encoders]] : [],
                enumerable: false,
                configurable: true,
                writable: true,
            });
        }
        for (const field in fields) {
            Metadata.defineField(constructor, metadata, fieldIndex, field, fields[field]);
            fieldIndex++;
        }
        return target;
    },
    isDeprecated(metadata, field) {
        return metadata[field].deprecated === true;
    },
    initialize(constructor) {
        const parentClass = Object.getPrototypeOf(constructor);
        const parentMetadata = parentClass[Symbol.metadata];
        let metadata = constructor[Symbol.metadata] ?? Object.create(null);
        // make sure inherited classes have their own metadata object.
        if (parentClass !== Schema && metadata === parentMetadata) {
            metadata = Object.create(null);
            if (parentMetadata) {
                //
                // assign parent metadata to current
                //
                Object.setPrototypeOf(metadata, parentMetadata);
                // $numFields
                Object.defineProperty(metadata, $numFields, {
                    value: parentMetadata[$numFields],
                    enumerable: false,
                    configurable: true,
                    writable: true,
                });
                // $viewFieldIndexes / $fieldIndexesByViewTag
                if (parentMetadata[$viewFieldIndexes] !== undefined) {
                    Object.defineProperty(metadata, $viewFieldIndexes, {
                        value: [...parentMetadata[$viewFieldIndexes]],
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                    Object.defineProperty(metadata, $fieldIndexesByViewTag, {
                        value: { ...parentMetadata[$fieldIndexesByViewTag] },
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                }
                // $refTypeFieldIndexes
                if (parentMetadata[$refTypeFieldIndexes] !== undefined) {
                    Object.defineProperty(metadata, $refTypeFieldIndexes, {
                        value: [...parentMetadata[$refTypeFieldIndexes]],
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                }
                // $unreliableFieldIndexes
                if (parentMetadata[$unreliableFieldIndexes] !== undefined) {
                    Object.defineProperty(metadata, $unreliableFieldIndexes, {
                        value: [...parentMetadata[$unreliableFieldIndexes]],
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                }
                // $transientFieldIndexes
                if (parentMetadata[$transientFieldIndexes] !== undefined) {
                    Object.defineProperty(metadata, $transientFieldIndexes, {
                        value: [...parentMetadata[$transientFieldIndexes]],
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                }
                // $staticFieldIndexes
                if (parentMetadata[$staticFieldIndexes] !== undefined) {
                    Object.defineProperty(metadata, $staticFieldIndexes, {
                        value: [...parentMetadata[$staticFieldIndexes]],
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                }
                // $streamFieldIndexes
                if (parentMetadata[$streamFieldIndexes] !== undefined) {
                    Object.defineProperty(metadata, $streamFieldIndexes, {
                        value: [...parentMetadata[$streamFieldIndexes]],
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                }
                // $descriptors
                Object.defineProperty(metadata, $descriptors, {
                    value: { ...parentMetadata[$descriptors] },
                    enumerable: false,
                    configurable: true,
                    writable: true,
                });
                // $encoders
                if (parentMetadata[$encoders] !== undefined) {
                    Object.defineProperty(metadata, $encoders, {
                        value: [...parentMetadata[$encoders]],
                        enumerable: false,
                        configurable: true,
                        writable: true,
                    });
                }
            }
        }
        Object.defineProperty(constructor, Symbol.metadata, {
            value: metadata,
            writable: false,
            configurable: true
        });
        return metadata;
    },
    isValidInstance(klass) {
        return (klass.constructor[Symbol.metadata] &&
            Object.prototype.hasOwnProperty.call(klass.constructor[Symbol.metadata], $numFields));
    },
    getFields(klass) {
        const metadata = klass[Symbol.metadata];
        const fields = {};
        for (let i = 0; i <= metadata[$numFields]; i++) {
            fields[metadata[i].name] = metadata[i].type;
        }
        return fields;
    },
    hasViewTagAtIndex(metadata, index) {
        return metadata?.[$viewFieldIndexes]?.includes(index);
    },
    hasUnreliableAtIndex(metadata, index) {
        return metadata?.[$unreliableFieldIndexes]?.includes(index);
    },
    hasTransientAtIndex(metadata, index) {
        return metadata?.[$transientFieldIndexes]?.includes(index);
    },
    hasStaticAtIndex(metadata, index) {
        return metadata?.[$staticFieldIndexes]?.includes(index);
    },
    hasStreamAtIndex(metadata, index) {
        return metadata?.[$streamFieldIndexes]?.includes(index);
    }
};

// Module-scope adapter: lets `forEach(cb)` delegate to `forEachWithCtx`
// by passing the user's callback as ctx. No per-call allocation.
const _invokeNoCtx$2 = (cb, index, op) => cb(index, op);
// ──────────────────────────────────────────────────────────────────────────
// SchemaChangeRecorder — bitmask + Uint8Array, for Schema types (≤64 fields)
// ──────────────────────────────────────────────────────────────────────────
/**
 * Schema field operations are limited to ADD(128), DELETE(64), and
 * DELETE_AND_ADD(192). REPLACE(0) is collection-only, so `ops[i] === 0`
 * is a safe "no operation" sentinel.
 */
class SchemaChangeRecorder {
    // Bitmask storage for fields 0-31 (low) and 32-63 (high).
    dirtyLow = 0;
    dirtyHigh = 0;
    // ops[fieldIndex] = OPERATION value. Pre-sized to numFields+1.
    ops;
    constructor(numFields) {
        this.ops = new Uint8Array(Math.max(numFields + 1, 1));
    }
    record(index, op) {
        const prev = this.ops[index];
        if (prev === 0)
            this.ops[index] = op;
        else if (prev === OPERATION.DELETE)
            this.ops[index] = OPERATION.DELETE_AND_ADD;
        // Promote ADD → DELETE_AND_ADD when a ref is replaced in the same
        // tick. See `ChangeTree.record` for rationale — same logic, this
        // interface implementation is kept in sync.
        else if (prev === OPERATION.ADD && op === OPERATION.DELETE_AND_ADD) {
            this.ops[index] = OPERATION.DELETE_AND_ADD;
        }
        // else preserve existing ADD / DELETE_AND_ADD.
        if (index < 32)
            this.dirtyLow |= (1 << index);
        else
            this.dirtyHigh |= (1 << (index - 32));
    }
    recordDelete(index, op) {
        this.ops[index] = op;
        if (index < 32)
            this.dirtyLow |= (1 << index);
        else
            this.dirtyHigh |= (1 << (index - 32));
    }
    recordRaw(index, op) {
        this.record(index, op);
    }
    operationAt(index) {
        const op = this.ops[index];
        return op === 0 ? undefined : op;
    }
    setOperationAt(index, op) {
        this.ops[index] = op;
    }
    forEach(cb) {
        this.forEachWithCtx(cb, _invokeNoCtx$2);
    }
    forEachWithCtx(ctx, cb) {
        let low = this.dirtyLow;
        let high = this.dirtyHigh;
        const ops = this.ops;
        // Iterate set bits via clz32 (CPU-level bit scan).
        while (low !== 0) {
            const bit = low & -low;
            const fieldIndex = 31 - Math.clz32(bit);
            low ^= bit;
            cb(ctx, fieldIndex, ops[fieldIndex]);
        }
        while (high !== 0) {
            const bit = high & -high;
            const fieldIndex = 31 - Math.clz32(bit) + 32;
            high ^= bit;
            cb(ctx, fieldIndex, ops[fieldIndex]);
        }
    }
    size() {
        return popcount32(this.dirtyLow) + popcount32(this.dirtyHigh);
    }
    has() {
        return (this.dirtyLow | this.dirtyHigh) !== 0;
    }
    reset() {
        this.dirtyLow = 0;
        this.dirtyHigh = 0;
        this.ops.fill(0);
    }
}
// ──────────────────────────────────────────────────────────────────────────
// CollectionChangeRecorder — Map-based, for collections with sparse indexes
// ──────────────────────────────────────────────────────────────────────────
/**
 * Collection items have sparse indexes (e.g. 0, 7, 1024) exceeding the
 * 64-field cap Schema imposes. Map-based storage handles arbitrary
 * indexes; the value at each entry is the OPERATION.
 *
 * Pure operations (CLEAR, REVERSE) live in `pureOps` as `[position, op]`
 * entries where `position` is `dirty.size` at record time — preserves
 * insertion-order interleaving with indexed ops (e.g. CLEAR must emit
 * BEFORE subsequent ADDs).
 */
class CollectionChangeRecorder {
    dirty = new Map();
    pureOps = [];
    record(index, op) {
        const prev = this.dirty.get(index);
        if (prev === undefined)
            this.dirty.set(index, op);
        else if (prev === OPERATION.DELETE)
            this.dirty.set(index, OPERATION.DELETE_AND_ADD);
        // Promote ADD → DELETE_AND_ADD for same-tick replacement of a ref
        // (see `SchemaChangeRecorder.record` for rationale).
        else if (prev === OPERATION.ADD && op === OPERATION.DELETE_AND_ADD) {
            this.dirty.set(index, OPERATION.DELETE_AND_ADD);
        }
        // else preserve existing op.
    }
    recordDelete(index, op) {
        this.dirty.set(index, op);
    }
    recordRaw(index, op) {
        this.dirty.set(index, op);
    }
    recordPure(op) {
        this.pureOps.push([this.dirty.size, op]);
    }
    operationAt(index) {
        return this.dirty.get(index);
    }
    setOperationAt(index, op) {
        if (this.dirty.has(index))
            this.dirty.set(index, op);
    }
    forEach(cb) {
        this.forEachWithCtx(cb, _invokeNoCtx$2);
    }
    forEachWithCtx(ctx, cb) {
        const pure = this.pureOps;
        if (pure.length > 0) {
            let pureIdx = 0, i = 0;
            for (const [index, op] of this.dirty) {
                while (pureIdx < pure.length && pure[pureIdx][0] <= i) {
                    const pureOp = pure[pureIdx++][1];
                    cb(ctx, -pureOp, pureOp);
                }
                cb(ctx, index, op);
                i++;
            }
            while (pureIdx < pure.length) {
                const pureOp = pure[pureIdx++][1];
                cb(ctx, -pureOp, pureOp);
            }
        }
        else {
            for (const [index, op] of this.dirty)
                cb(ctx, index, op);
        }
    }
    size() {
        return this.dirty.size + this.pureOps.length;
    }
    has() {
        return this.dirty.size > 0 || this.pureOps.length > 0;
    }
    reset() {
        this.dirty.clear();
        this.pureOps.length = 0;
    }
    shift(shiftIndex) {
        const dst = new Map();
        for (const [idx, val] of this.dirty)
            dst.set(idx + shiftIndex, val);
        this.dirty = dst;
    }
}
// ──────────────────────────────────────────────────────────────────────────
// Helpers
// ──────────────────────────────────────────────────────────────────────────
/** 32-bit Hamming weight (popcount). */
function popcount32(n) {
    n = n - ((n >>> 1) & 0x55555555);
    n = (n & 0x33333333) + ((n >>> 2) & 0x33333333);
    return (((n + (n >>> 4)) & 0x0f0f0f0f) * 0x01010101) >>> 24;
}

/**
 * EncodeDescriptor — per-class snapshot of the values the encode loop needs
 * from a Ref's constructor. Lazily computed once per class (the first time
 * a tree of that class is constructed) and stashed on the constructor via
 * `$encodeDescriptor`. Each ChangeTree caches a reference to its class's
 * descriptor at construction time, so the encode loop reads a single
 * property from the tree instead of chasing 5 separate per-tree lookups:
 *
 *   ctor[$encoder]
 *   ctor[$filter]
 *   ctor[Symbol.metadata]
 *   Metadata.isValidInstance(ref)
 *   getFilterBitmask(metadata)
 *
 * Lives in its own file to break the Encoder.ts ↔ ChangeTree.ts import
 * cycle (ChangeTree caches descriptors at construction; Encoder reads them
 * during encode).
 */
function computeFilterBitmask(metadata) {
    if (metadata === undefined)
        return 0;
    let bm = metadata[$filterBitmask];
    if (bm !== undefined)
        return bm;
    bm = 0;
    const tagged = metadata[$viewFieldIndexes];
    if (tagged !== undefined) {
        for (let i = 0, len = tagged.length; i < len; i++)
            bm |= (1 << tagged[i]);
    }
    // Non-enumerable so `for (const k in metadata)` iteration in TypeContext
    // and elsewhere doesn't mistake this cache for a real field index.
    Object.defineProperty(metadata, $filterBitmask, {
        value: bm,
        enumerable: false,
        writable: true,
        configurable: true,
    });
    return bm;
}
/**
 * Bitmask of field indexes 0–31 in `indexes`. For fields ≥32 callers must
 * fall back to the array lookup (same as `filterBitmask`).
 */
function indexesToBitmask(indexes) {
    if (indexes === undefined)
        return 0;
    let bm = 0;
    for (let i = 0, len = indexes.length; i < len; i++) {
        const idx = indexes[i];
        if (idx < 32)
            bm |= (1 << idx);
    }
    return bm;
}
/**
 * Build the per-field parallel arrays once at descriptor construction.
 * For collection trees (no metadata or no $numFields) this returns empty
 * arrays — readers branch on `isSchema` before touching them anyway.
 */
function buildFieldArrays(metadata) {
    const names = [];
    const types = [];
    const tags = [];
    const encoders = [];
    if (metadata === undefined)
        return { names, types, tags, encoders };
    const numFields = metadata[$numFields];
    if (numFields === undefined)
        return { names, types, tags, encoders };
    const srcEncoders = metadata[$encoders];
    for (let i = 0; i <= numFields; i++) {
        const field = metadata[i];
        if (field === undefined) {
            // Holes are normal — inheritance can leave gaps. Fill with
            // undefined so indexing is valid.
            names[i] = undefined;
            types[i] = undefined;
            tags[i] = undefined;
            encoders[i] = undefined;
            continue;
        }
        names[i] = field.name;
        types[i] = field.type;
        tags[i] = field.tag;
        encoders[i] = srcEncoders?.[i];
    }
    return { names, types, tags, encoders };
}
function getEncodeDescriptor(ref) {
    const ctor = ref.constructor;
    // Use hasOwn — Object.defineProperty on a parent class would otherwise
    // be inherited by every subclass via the prototype chain, and a
    // subclass's instance would read the parent's metadata/encoder. See
    // "should encode the correct class inside an array" for the regression.
    if (Object.prototype.hasOwnProperty.call(ctor, $encodeDescriptor)) {
        return ctor[$encodeDescriptor];
    }
    const metadata = ctor[Symbol.metadata];
    const isSchema = Metadata.isValidInstance(ref);
    const hasAnyView = (metadata?.[$viewFieldIndexes]?.length ?? 0) > 0;
    const arrays = buildFieldArrays(metadata);
    // For Schema classes with no `@view`-tagged fields, the per-field
    // `ctx.filter(ref, index, view)` call on the encode hot path is a
    // provable no-op: `Schema[$filter]` does `metadata[index]?.tag === undefined`
    // which is always true when no field carries a tag. Setting filter to
    // `undefined` here lets the `ctx.filter !== undefined && …` short-circuit
    // in `encodeChangeCb` skip the call entirely — the metadata lookup +
    // comparison adds up across 10k+ field encodes/tick.
    // Collection classes keep their filter — their `[$filter]` does
    // instance-level `ref[$childType]` / view-visibility checks that can't
    // be decided class-wide.
    const filter = (isSchema && !hasAnyView) ? undefined : ctor[$filter];
    const desc = {
        encoder: ctor[$encoder],
        filter,
        metadata,
        isSchema,
        filterBitmask: isSchema ? computeFilterBitmask(metadata) : 0,
        hasAnyStatic: (metadata?.[$staticFieldIndexes]?.length ?? 0) > 0,
        hasAnyUnreliable: (metadata?.[$unreliableFieldIndexes]?.length ?? 0) > 0,
        hasAnyStream: (metadata?.[$streamFieldIndexes]?.length ?? 0) > 0,
        hasAnyView,
        staticBitmask: indexesToBitmask(metadata?.[$staticFieldIndexes]),
        unreliableBitmask: indexesToBitmask(metadata?.[$unreliableFieldIndexes]),
        streamBitmask: indexesToBitmask(metadata?.[$streamFieldIndexes]),
        names: arrays.names,
        types: arrays.types,
        tags: arrays.tags,
        encoders: arrays.encoders,
    };
    Object.defineProperty(ctor, $encodeDescriptor, {
        value: desc,
        enumerable: false,
        writable: true,
        configurable: true,
    });
    return desc;
}

/**
 * Parent-chain helpers for ChangeTree. A tree can have multiple parents
 * (rare — instance sharing between Schema/Collection containers). The
 * primary parent is stored inline on the tree (`parentRef` / `_parentIndex`);
 * additional parents live in the `extraParents` linked list.
 */
/**
 * Add a parent to the chain. If `parent` already exists anywhere in the
 * chain, update the primary parent's index instead (matches legacy
 * behavior).
 */
function addParent(tree, parent, index) {
    // Check if this parent already exists anywhere in the chain
    if (tree.parentRef) {
        if (tree.parentRef[$changes] === parent[$changes]) {
            // Primary parent matches — update index
            tree._parentIndex = index;
            return;
        }
        // Check extra parents for duplicate
        if (hasParent(tree, (p, _) => p[$changes] === parent[$changes])) {
            // Match old behavior: update primary parent's index
            tree._parentIndex = index;
            return;
        }
    }
    if (tree.parentRef === undefined) {
        // First parent — store inline
        tree.parentRef = parent;
        tree._parentIndex = index;
    }
    else {
        // Push current inline parent to extraParents, set new as primary
        tree.extraParents = {
            ref: tree.parentRef,
            index: tree._parentIndex,
            next: tree.extraParents
        };
        tree.parentRef = parent;
        tree._parentIndex = index;
    }
}
/**
 * Remove a parent from the chain.
 * @returns true if parent was found and removed (Root.remove relies on this).
 */
function removeParent(tree, parent) {
    //
    // FIXME: it is required to check against `$changes` here because
    // ArraySchema is instance of Proxy
    //
    if (tree.parentRef && tree.parentRef[$changes] === parent[$changes]) {
        // Removing inline parent — promote first extra parent if exists
        if (tree.extraParents) {
            tree.parentRef = tree.extraParents.ref;
            tree._parentIndex = tree.extraParents.index;
            tree.extraParents = tree.extraParents.next;
        }
        else {
            tree.parentRef = undefined;
            tree._parentIndex = undefined;
        }
        return true;
    }
    // Search extra parents
    let current = tree.extraParents;
    let previous = null;
    while (current) {
        if (current.ref[$changes] === parent[$changes]) {
            if (previous) {
                previous.next = current.next;
            }
            else {
                tree.extraParents = current.next;
            }
            return true;
        }
        previous = current;
        current = current.next;
    }
    return tree.parentRef === undefined;
}
/**
 * Find the first parent in the chain matching `predicate`.
 */
function findParent(tree, predicate) {
    // Check inline parent first
    if (tree.parentRef && predicate(tree.parentRef, tree._parentIndex)) {
        return { ref: tree.parentRef, index: tree._parentIndex };
    }
    let current = tree.extraParents;
    while (current) {
        if (predicate(current.ref, current.index)) {
            return current;
        }
        current = current.next;
    }
    return undefined;
}
function hasParent(tree, predicate) {
    return findParent(tree, predicate) !== undefined;
}
/**
 * Return all parents as an array (debug/test helper).
 */
function getAllParents(tree) {
    const parents = [];
    if (tree.parentRef) {
        parents.push({ ref: tree.parentRef, index: tree._parentIndex });
    }
    let current = tree.extraParents;
    while (current) {
        parents.push({ ref: current.ref, index: current.index });
        current = current.next;
    }
    return parents;
}

/**
 * Walk all currently-populated non-transient indexes on a tree, emitting
 * each index once. Used by Root.add (re-stage), Encoder.encodeAll, and
 * StateView.add to derive full-sync output from the live structure.
 *
 * Transient fields (`@transient`) are skipped — they're delivered only on
 * tick patches and not persisted to snapshots. Collections whose parent
 * field is @transient inherit the skip (`tree.isTransient`).
 */
// Adapter that lets `forEachLive(cb)` delegate to `forEachLiveWithCtx(cb, _invokeNoCtx)` —
// keeps the no-ctx path closure-free and shares one walker implementation.
const _invokeNoCtx$1 = (cb, index) => cb(index);
function forEachLive(tree, callback) {
    forEachLiveWithCtx(tree, callback, _invokeNoCtx$1);
}
function forEachLiveWithCtx(tree, ctx, cb) {
    // `refTarget` skips the ArraySchema Proxy on every `.items` / `.$items`
    // / `[$childType]` read below. Same reference as `ref` for non-proxied
    // types. See `ChangeTree.refTarget` doc.
    const ref = tree.refTarget;
    if (ref[$childType] !== undefined) {
        // Collection inheriting @transient from parent field: skip entirely.
        // The resync sweep (decoder/Resync.ts) relies on this: a collection
        // absent from full-sync output is never pruned client-side.
        if (tree.isTransient)
            return;
        // Collection types: dispatch by shape.
        if (Array.isArray(ref.items)) {
            // ArraySchema
            const items = ref.items;
            for (let i = 0, len = items.length; i < len; i++) {
                if (items[i] !== undefined)
                    cb(ctx, i);
            }
        }
        else if (ref.journal !== undefined) {
            // MapSchema
            for (const [index, key] of ref.journal.keyByIndex) {
                if (ref.$items.has(key))
                    cb(ctx, index);
            }
        }
        else if (ref.$items !== undefined) {
            // SetSchema / CollectionSchema (key === wire index)
            for (const index of ref.$items.keys()) {
                cb(ctx, index);
            }
        }
    }
    else {
        // Schema: walk declared fields. `null` is treated as absent —
        // the setter records a DELETE when a field is set to null or
        // undefined, so it should not appear in full-sync output.
        // (@transient skips below matter to the resync sweep — see
        // decoder/Resync.ts: absent-from-payload means never pruned.)
        //
        // Read names from the per-class descriptor's parallel array —
        // saves the `metadata[i]` (per-field obj) + `.name` chain on
        // every iteration of the full-sync DFS.
        const metadata = tree.metadata;
        if (!metadata)
            return;
        const numFields = (metadata[$numFields] ?? -1);
        const transientIndexes = metadata[$transientFieldIndexes];
        const names = tree.encDescriptor.names;
        for (let i = 0; i <= numFields; i++) {
            const name = names[i];
            if (name === undefined)
                continue;
            if (transientIndexes && transientIndexes.includes(i))
                continue;
            const value = ref[name];
            if (value !== undefined && value !== null)
                cb(ctx, i);
        }
    }
}

/**
 * Filter / unreliable / transient / static inheritance helpers for
 * ChangeTree. Called by setRoot / setParent to derive child flags from
 * the parent field's annotation + the parent tree's own state.
 */
/**
 * Reconcile queue membership + inherited flags for a tree that just had
 * its root/parent assigned. See `_checkInheritedFlags` for the flag
 * inheritance logic.
 */
function checkIsFiltered(tree, parent, parentIndex, _isNewChangeTree) {
    checkInheritedFlags(tree, parent, parentIndex);
    // Static trees never track per-tick changes — skip the queue entirely.
    // Full-sync reaches them via structural walk (forEachChild).
    if (tree.isStatic)
        return;
    // Mutations that happened before setRoot (e.g. class-field initializers)
    // recorded into the appropriate recorder but couldn't enqueue yet.
    // Reconcile both queues now.
    if (tree.has()) {
        tree.root?.enqueueChangeTree(tree);
    }
    if (tree.unreliableRecorder?.has()) {
        tree.root?.enqueueUnreliable(tree);
    }
    // Fresh tree with nothing recorded: still enqueue into its primary
    // queue so the tree is reachable for its first mutation cycle.
    //
    // Tree-level unreliable is disabled (see INHERITABLE_FLAGS) so the
    // unreliable branch is unreachable today. Kept as a comment for
    // re-enablement.
    if (!tree.has() && !(tree.unreliableRecorder?.has())) {
        // if (tree.isUnreliable) {
        //     tree.root?.enqueueUnreliable(tree);
        // } else {
        tree.root?.enqueueChangeTree(tree);
        // }
    }
}
/**
 * Inherit filter / unreliable / transient / static classification from
 * the parent field's annotation. Collections (MapSchema / ArraySchema /
 * etc.) inherit these from the Schema field that holds them.
 *
 * The common case — fresh tree attached to a parent field that carries
 * none of the inheritable annotations — produces no flag change, no
 * queue update, and no `parentFiltered` hit. Two small structural
 * choices keep that case cheap without any precomputed descriptor
 * bitmask:
 *
 *  1) Flag inheritance is a single bitwise OR onto `tree.flags`. The
 *     three per-annotation reads pack into `fieldBits`, the parent's
 *     inherited bits come from `parentChangeTree.flags` directly; one
 *     read-modify-write replaces three getter/setter cycles, and the
 *     bit diff against `beforeFlags` gives us the "just became static /
 *     unreliable" signal for the side-effect branches.
 *
 *  2) The `parentFiltered` string-key lookup is gated on
 *     `types.hasParentFilteredEntries`, which is only flipped true when
 *     `registerFilteredByParent` actually records an entry — i.e. when
 *     some @view-tagged field reaches this (child, parent, index)
 *     triple through the ancestry walk. Schemas with @view tags only on
 *     sibling fields (not along any attachment chain) skip the string
 *     concat + hash lookup entirely.
 */
function checkInheritedFlags(tree, parent, parentIndex) {
    if (!parent) {
        return;
    }
    // Walk up a collection level so `parent` lands on the Schema that
    // owns the field at `parentIndex`. Field annotations live on Schema
    // metadata; collections have none.
    let parentChangeTree = parent[$changes];
    const parentIsCollection = !Metadata.isValidInstance(parent);
    if (parentIsCollection) {
        parent = parentChangeTree.parent;
        parentIndex = parentChangeTree.parentIndex;
    }
    const parentMetadata = parent?.constructor?.[Symbol.metadata];
    // Flag inheritance — pack the transient/static annotation checks into
    // flag bits alongside the parent's own transitive flags, then OR onto
    // `tree.flags` in one write. The bit diff tells us which flag just
    // went from 0→1, cheaper than the prior `becameX = !tree.isX && (...)`
    // pairs. IS_UNRELIABLE is omitted from both sides — tree-level
    // unreliable is disabled (see INHERITABLE_FLAGS in ChangeTree.ts).
    const fieldBits = (parentMetadata?.[$transientFieldIndexes]?.includes(parentIndex) ? IS_TRANSIENT : 0)
        | (parentMetadata?.[$staticFieldIndexes]?.includes(parentIndex) ? IS_STATIC : 0);
    const inheritedBits = (parentChangeTree.flags & INHERITABLE_FLAGS) | fieldBits;
    const beforeFlags = tree.flags;
    tree.flags = beforeFlags | inheritedBits;
    const gainedBits = inheritedBits & ~beforeFlags;
    // If this tree just became static via inheritance, discard any entries
    // that may have been recorded before the parent was assigned (e.g.
    // `new Config().assign({...})` populates the recorder before the
    // Config instance is attached). Static trees ship state via structural
    // walk only; per-tick dirty entries would leak post-first-sync.
    if (gainedBits & IS_STATIC) {
        tree.reset();
        tree.unreliableRecorder?.reset();
    }
    // Tree-level unreliable promotion is disabled — no tree can gain
    // IS_UNRELIABLE via inheritance under the current decoration-time
    // rejection (`Metadata.setUnreliable` on ref-type fields throws). The
    // promotion block used to migrate reliable-recorder entries populated
    // before attach (`new Item().assign({...})` then push into an
    // unreliable collection) over to the unreliable recorder. Kept here
    // as a comment for re-enablement if a safe tree-level unreliable
    // semantics is designed later.
    //
    // else if ((gainedBits & IS_UNRELIABLE) && tree.has()) {
    //     const dst = tree.ensureUnreliableRecorder() as ICollectionChangeRecorder;
    //     tree.forEach((index, op) => {
    //         if (index < 0) dst.recordPure(op);
    //         else dst.record(index, op);
    //     });
    //     tree.reset();
    // }
    // Filter inheritance — only when the type context has any @view or
    // @stream fields registered anywhere.
    const types = tree.root?.types;
    if (!types?.hasFilters)
        return;
    const fieldHasViewTag = parentMetadata?.[$viewFieldIndexes]?.includes(parentIndex) ?? false;
    // Stream fields are always view-scoped: the stream itself and its
    // child elements must behave as filtered trees. Elements must NOT
    // share visibility with the parent stream — `encodeView`'s priority
    // pass is the only way elements become visible to a view.
    const fieldHasStream = parentMetadata?.[$streamFieldIndexes]?.includes(parentIndex) ?? false;
    // Skip the `parentFiltered` string-key lookup when no class has
    // actually registered filter inheritance via ancestry. The lookup
    // cannot hit in that state, so the string concat + hash lookup would
    // be wasted work every attach.
    let parentFiltered = false;
    const parentConstructor = parent?.constructor;
    if (types.hasParentFilteredEntries && parentConstructor !== undefined) {
        const refType = Metadata.isValidInstance(tree.ref)
            ? tree.ref.constructor
            : tree.ref[$childType];
        const key = `${types.getTypeId(refType)}-${types.schemas.get(parentConstructor)}-${parentIndex}`;
        parentFiltered = types.parentFiltered[key] ?? false;
    }
    const newFiltered = parentChangeTree.isFiltered || parentFiltered || fieldHasViewTag || fieldHasStream;
    tree.isFiltered = newFiltered;
    // Flag collection trees attached to a `.stream()` field so the encoder
    // routes their emission through the priority/broadcast pass. Applies
    // when the tree IS the collection (not the collection's parent
    // structure walk above). `parentIsCollection` was true at entry iff
    // `tree.ref` is a child-of-collection (e.g. stream element) — we only
    // set the flag on the collection itself, not its elements.
    if (fieldHasStream && !parentIsCollection) {
        tree.isStreamCollection = true;
        // Allocate the lazy `_stream` slot once, here — so downstream
        // helpers (`streamRouteAdd`, `_emitStreamPriority`, …) never need
        // a null-check. `_stream` was always declared on the class at
        // `undefined`, so this is a value write, not a shape transition.
        const state = ensureStreamState(tree.ref);
        // Seed the priority callback from the schema declaration (builder's
        // `.priority(fn)` or decorator's `{ stream: X, priority: fn }`).
        // Instance-level overrides via `stream.priority = ...` win — only
        // assign if the instance slot hasn't already been set.
        if (state.priority === undefined) {
            const declared = Metadata.getStreamPriority(parentMetadata, parentIndex);
            if (declared !== undefined)
                state.priority = declared;
        }
        // Auto-register with `root.streamTrees` so the encoder's priority /
        // broadcast pass picks it up. Covers both `StreamSchema` and any
        // `.stream()`-opted collection (e.g. `MapSchema.stream()`).
        tree.root?.registerStream(tree.ref);
    }
    if (newFiltered) {
        const refType = Metadata.isValidInstance(tree.ref)
            ? tree.ref.constructor
            : tree.ref[$childType];
        // #218: nested Schema fields inherit visibility from a @view-gated
        // parent regardless of whether the parent is a collection. The
        // `parentIsCollection` constraint that used to live here blocked
        // nested-Schema-field-of-@view-tagged-Schema from sharing visibility,
        // forcing users to wrap the child in an ArraySchema as a workaround.
        //
        // #226 (4.0.25): items inside a non-default-tag `@view(N)` collection
        // also inherit visibility from the parent collection, so items
        // pushed/set after `view.add(state, N)` show up automatically.
        // Default-tag `@view()` collections keep per-item gating —
        // `view.add(item)` is still required to opt each one in.
        // The `parentMetadata[parentIndex].tag` access is safe inside the
        // `fieldHasViewTag` short-circuit (the metadata entry and its `tag`
        // are guaranteed to exist when that flag is set).
        tree.isVisibilitySharedWithParent = (parentChangeTree.isFiltered
            && typeof refType !== "string"
            && !fieldHasStream
            && (!fieldHasViewTag || (parentIsCollection && parentMetadata[parentIndex].tag !== DEFAULT_VIEW_TAG)));
    }
}

/**
 * Walk the `subscribedViews` bitmap of `parentTree` and propagate a new
 * child attachment to every subscribed view. Streams route through the
 * priority/pending queue; all other collections force-ship immediately.
 */
function propagateNewChildToSubscribers(parentTree, childIndex, childRef, root) {
    const subs = parentTree.subscribedViews;
    if (subs === undefined)
        return;
    const isStream = parentTree.isStreamCollection;
    const streamable = isStream ? parentTree.ref : undefined;
    const childTree = isStream ? undefined : childRef[$changes];
    // Walk set bits via clz32 — same pattern as the inline recorder
    // iteration elsewhere in the encoder.
    for (let slot = 0, n = subs.length; slot < n; slot++) {
        let bits = subs[slot];
        while (bits !== 0) {
            const bit = bits & -bits;
            bits ^= bit;
            const viewId = slot * 32 + (31 - Math.clz32(bit));
            const weakRef = root.activeViews.get(viewId);
            const view = weakRef?.deref();
            if (view === undefined) {
                // View was disposed / GC'd; clear the stale subscription bit.
                subs[slot] &= ~bit;
                continue;
            }
            if (isStream) {
                // Streams bypass the recorder — enqueue for the priority
                // pass to drain under `maxPerTick`.
                streamEnqueueForView(streamable, viewId, childIndex);
            }
            else if (childTree !== undefined) {
                // Non-stream collections: just markVisible. The parent's
                // recorder already carries the ADD op (triggered by the
                // push/set/add that led to this setParent), and the
                // child's tree carries its construction-time dirty state
                // — the encoder's normal view pass picks both up on the
                // next encode, no view.changes seeding needed.
                view.markVisible(childTree);
            }
        }
    }
}

/**
 * Tree-attachment helpers: setRoot / setParent + child-iteration recursion.
 * Hot path: every new Schema/Collection instance attached to the root
 * goes through here, which is why the recursive walk uses a hoisted
 * callback + ctx-pool instead of per-call closures.
 */
function setRoot(tree, root) {
    tree.root = root;
    const isNewChangeTree = root.add(tree);
    checkIsFiltered(tree, tree.parent, tree.parentIndex);
    // Recursively set root on child structures (closure-free hot path).
    if (isNewChangeTree) {
        forEachChildWithCtx(tree, root, _setRootChildCb);
    }
}
function setParent(tree, parent, root, parentIndex) {
    tree.addParent(parent, parentIndex);
    // avoid setting parents with empty `root`
    if (!root) {
        return;
    }
    const isNewChangeTree = root.add(tree);
    // skip if parent is already set
    if (root !== tree.root) {
        tree.root = root;
        checkIsFiltered(tree, parent, parentIndex);
    }
    // Persistent-subscription propagation — when this new child is being
    // attached to a collection that has one or more subscribed views,
    // force-ship (or enqueue, for streams) the new child to each of them.
    // Gated by `parent` being a collection (not a Schema) and the parent
    // tree having a non-empty `subscribedViews` bitmap; both common-case
    // short circuits are cheap.
    const parentTree = parent?.[$changes];
    if (parentTree !== undefined &&
        parentTree.subscribedViews !== undefined &&
        // Collection check: `$childType` on the ref identifies Array/Map/
        // Set/Collection/Stream. Schema-field parents don't have it.
        parent[$childType] !== undefined) {
        propagateNewChildToSubscribers(parentTree, parentIndex, tree.ref, root);
    }
    // assign same parent on child structures (closure-free hot path).
    // setParent recurses, so each depth gets its own ctx from a pool
    // that grows to the recursion depth (typically tree height = 3-5).
    if (isNewChangeTree) {
        let ctx = _setParentCtxPool[_setParentDepth];
        if (ctx === undefined) {
            ctx = { parentRef: undefined, root: undefined };
            _setParentCtxPool[_setParentDepth] = ctx;
        }
        ctx.parentRef = tree.ref;
        ctx.root = root;
        _setParentDepth++;
        forEachChildWithCtx(tree, ctx, _setParentChildCb);
        _setParentDepth--;
    }
}
function forEachChild(tree, callback) {
    forEachChildWithCtx(tree, callback, _forEachChildTrampoline);
}
function _forEachChildTrampoline(cb, change, at) {
    cb(change, at);
}
/**
 * Closure-free variant of {@link forEachChild}. Hot setRoot / setParent
 * recursion calls this once per new Schema instance attached to the
 * tree — the per-call closure was the #1 JS hotspot in profile-baseline.
 * Pass an explicit `ctx` so callers can hoist the callback to module
 * scope and avoid the allocation.
 */
function forEachChildWithCtx(tree, ctx, callback) {
    // `refTarget` is the raw backing instance — identical to `ref` for all
    // non-Proxy types (Schema / Map / Set / Collection / Stream), and the
    // un-wrapped `$proxyTarget` for ArraySchema. Reading through it here
    // skips the ArraySchema Proxy `get` trap on every `$childType`,
    // `_collectionIndexes`, `.entries()`, `.items` lookup below — hot during
    // the encodeAll DFS walk which touches every ArraySchema in the tree.
    const ref = tree.refTarget;
    if (ref[$childType]) {
        if (typeof ref[$childType] !== "string") {
            const items = ref.items;
            if (items !== undefined) {
                // ArraySchema (raw target): dense index loop — the previous
                // `for..of entries()` allocated an iterator + a [key, value]
                // pair array per child (top-10 allocation site in the
                // stateview and deep-nested heap profiles).
                for (let i = 0, len = items.length; i < len; i++) {
                    const value = items[i];
                    if (!value) {
                        continue;
                    } // sparse arrays can have undefined values
                    callback(ctx, value[$changes], i);
                }
            }
            else {
                // Map-backed collections (MapSchema/SetSchema/CollectionSchema/
                // StreamSchema all store `$items: Map`): keys() loop skips the
                // per-child [key, value] pair arrays of entries(), with no
                // closure either (a forEach closure showed up as a GC
                // regression on the construct bench).
                const $items = ref.$items;
                const collectionIndexes = ref._collectionIndexes;
                for (const key of $items.keys()) {
                    const value = $items.get(key);
                    if (!value) {
                        continue;
                    }
                    callback(ctx, value[$changes], collectionIndexes?.[key] ?? key);
                }
            }
        }
    }
    else {
        const metadata = tree.metadata;
        const indexes = metadata?.[$refTypeFieldIndexes];
        if (!indexes)
            return;
        const names = tree.encDescriptor.names;
        for (let i = 0, len = indexes.length; i < len; i++) {
            const index = indexes[i];
            const value = ref[names[index]];
            if (!value) {
                continue;
            }
            callback(ctx, value[$changes], index);
        }
    }
}
// Hoisted callbacks used by setRoot / setParent to avoid per-call
// closure allocation in the recursive attach path.
function _setRootChildCb(root, child, _index) {
    if (child.root !== root) {
        child.setRoot(root);
    }
    else {
        root.add(child); // increment refCount
    }
}
// Pool of ctx objects, indexed by setParent recursion depth. Grows to
// max depth seen (typically tree height = 3-5 in bench), then stays put.
const _setParentCtxPool = [];
let _setParentDepth = 0;
function _setParentChildCb(ctx, child, index) {
    if (child.root === ctx.root) {
        ctx.root.add(child);
        ctx.root.moveNextToParent(child);
        return;
    }
    child.setParent(ctx.parentRef, ctx.root, index);
}

/**
 * ChangeTree — the per-`Ref` mutation tracker attached via `$changes`.
 *
 * This file owns: class shape (fields, flags, ctor), inline
 * ChangeRecorder implementation (record / forEach / …), mutation API
 * (change / delete / operation / …), and encode lifecycle (endEncode /
 * discard / …). Helpers split out into ./changeTree/:
 *
 *   - parentChain.ts     addParent / removeParent / find / has / getAll
 *   - liveIteration.ts   forEachLive
 *   - inheritedFlags.ts  filter / unreliable / transient / static inheritance
 *   - treeAttachment.ts  setRoot / setParent / forEachChild(+WithCtx)
 *
 * Public surface on ChangeTree is unchanged — methods are thin pass-throughs
 * into the helpers. V8 inlines the pass-throughs; the runtime shape stays
 * a single class to preserve hidden-class + IC behavior.
 */
// Pure arithmetic, no `this` — V8 inlines into encode-loop forEach.
// Mirror of `ChangeTree._opAt` for the inline-ops-only branch.
function readInlineOpByte(low, high, index) {
    const shift = (index & 3) << 3;
    return (index < 4)
        ? (low >>> shift) & 0xFF
        : (high >>> shift) & 0xFF;
}
// Adapter that lets `forEach(cb)` delegate to `forEachWithCtx(cb, _invokeNoCtx)` —
// no per-call closure allocation. See ChangeRecorder.ts for the same pattern.
const _invokeNoCtx = (cb, index, op) => cb(index, op);
// Linked list helper functions
function createChangeTreeList() {
    return { next: undefined, tail: undefined };
}
// Flags bitfield. *_UNRELIABLE / _TRANSIENT / _STATIC mirror the parent
// field's annotation — inherited at setParent/setRoot time.
const IS_FILTERED = 1, IS_VISIBILITY_SHARED = 2, IS_NEW = 4;
const IS_UNRELIABLE = 8, IS_TRANSIENT = 16, IS_STATIC = 32;
// Collection tree attached to a parent field annotated `.stream()` —
// drives the encoder's priority/broadcast pass. Set in inheritedFlags
// so both `t.stream(X)` (via StreamSchema's `$isStream` brand) and
// `t.map(X).stream()` / `t.set(X).stream()` route through the same
// emission machinery.
const IS_STREAM_COLLECTION = 64;
// Set by `recycle()` (Schema.reset / pooling): the tree's values are live
// but its dirty buckets were cleared, so `Root.add` must re-stage every
// populated field as ADD when the instance re-enters a tree. Without this,
// only fields assigned after `pool.acquire()` would reach the wire — the
// retained ones (constructor-initialized children) would never be encoded.
const NEEDS_RESTAGE = 128;
/**
 * Flags a child inherits from its parent's own transitive state via
 * `checkInheritedFlags`. Read as a bitwise mask so the inheritance step
 * is a single OR instead of three getter/setter pairs.
 *
 * `IS_UNRELIABLE` is intentionally excluded: `@unreliable` is rejected
 * at decoration time for ref-type fields (see `Metadata.setUnreliable`)
 * because an unreliable ADD/DELETE could leave the decoder unable to
 * interpret later packets referencing an orphan refId. Tree-level
 * unreliable is therefore dead on every Schema/Collection tree today;
 * the bit and its machinery are kept in place so this can be
 * reconsidered if a safe semantics (e.g. reliable ADD + unreliable
 * field mutations only) is designed later.
 */
const INHERITABLE_FLAGS = IS_TRANSIENT | IS_STATIC;
class ChangeTree {
    ref;
    /**
     * Non-Proxy target of `ref` for encoder hot-path reads. For
     * `ArraySchema`, `ref` is the Proxy users interact with; every property
     * access on it runs through the `get` trap (even for symbol keys, which
     * fall through to `Reflect.get` — one extra hop per lookup). The encoder
     * loop reads `[$getByIndex]`, `[$childType]`, `.items`, `.tmpItems` at
     * high frequency during `encode()` / `encodeAll()`; going through
     * `refTarget` skips all of those traps.
     *
     * For non-proxied types (Schema, MapSchema, SetSchema, CollectionSchema,
     * StreamSchema), `refTarget === ref`. Consumers that need the user-
     * facing identity (debug output, callback parents) keep using `ref`.
     */
    refTarget;
    metadata;
    /**
     * Per-class cache of encoder fn / filter fn / isSchema / filterBitmask /
     * metadata, looked up once at construction. The encode loop reads
     * `tree.encDescriptor` and never touches `ref.constructor` again. See
     * EncodeDescriptor.ts.
     */
    encDescriptor;
    root;
    // Inline single parent (the common case)
    parentRef;
    _parentIndex;
    extraParents; // linked list for 2nd+ parents (rare: instance sharing)
    // Packed boolean flags. See IS_* constants above for bit layout.
    flags = IS_NEW;
    /**
     * Per-walk visit stamp written by `Encoder.encodeFullSync`'s DFS. A
     * tree is considered "already visited by the current walk" iff
     * `tree._fullSyncGen === ctx.gen` — the encoder bumps its generation
     * counter once per walk, then stamps each tree with that value on
     * first visit; any later encounter of the same tree (shared refs
     * reachable through multiple parents) short-circuits on the equality
     * check instead of recursing again.
     */
    _fullSyncGen = 0;
    // Schema vs Collection discriminator. Set once in ctor, never changes —
    // per-tree-stable branch for inline ChangeRecorder dispatch.
    _isSchema = false;
    // Inline reliable SchemaChangeRecorder state (valid only if _isSchema).
    dirtyLow = 0;
    dirtyHigh = 0;
    // Inline ops for Schemas with ≤8 fields (4 op-bytes per number).
    // When `ops` is set (>8 fields), reads/writes go through the Uint8Array.
    opsLow = 0;
    opsHigh = 0;
    ops;
    // Inline reliable CollectionChangeRecorder state (valid only if !_isSchema).
    // `collDirty` is allocated in the ctor. `collPureOps` stays undefined
    // until the first CLEAR/REVERSE (most workloads never hit this).
    collDirty;
    collPureOps;
    // Lazy-allocated unreliable-channel recorder (rare — opt-in via @unreliable).
    unreliableRecorder;
    // When true, mutations on the ref are NOT tracked. See pause/resume/untracked.
    paused = false;
    changesNode; // Root.changes linked-list node
    unreliableChangesNode; // Root.unreliableChanges linked-list node
    // Per-StateView visibility bitmaps. Bit `(viewId & 31)` in slot
    // `(viewId >> 5)` is set iff the view can see this tree. Replaces
    // per-view WeakSet lookups with direct bitwise ops.
    // Lazy: undefined until the tree participates in any view.
    visibleViews;
    invisibleViews;
    // Per-(view, tag) bitmap, indexed by tag. Custom tags only —
    // DEFAULT_VIEW_TAG visibility lives in `visibleViews`.
    tagViews;
    /**
     * Per-view subscription bitmap — same layout as `visibleViews`. Set by
     * `StateView.subscribe(collection)` to mark the view as persistently
     * interested in this collection's contents. When a new child is
     * attached to a subscribed collection (setParent hook), it's
     * auto-propagated to every subscribed view (force-shipped for
     * Array/Map/Set/Collection; enqueued into per-view pending for
     * streams). Undefined until the first subscribe.
     */
    subscribedViews;
    // Accessor properties for flags
    get isFiltered() { return (this.flags & IS_FILTERED) !== 0; }
    set isFiltered(v) { this.flags = v ? (this.flags | IS_FILTERED) : (this.flags & ~IS_FILTERED); }
    get isVisibilitySharedWithParent() { return (this.flags & IS_VISIBILITY_SHARED) !== 0; }
    set isVisibilitySharedWithParent(v) { this.flags = v ? (this.flags | IS_VISIBILITY_SHARED) : (this.flags & ~IS_VISIBILITY_SHARED); }
    get isNew() { return (this.flags & IS_NEW) !== 0; }
    set isNew(v) { this.flags = v ? (this.flags | IS_NEW) : (this.flags & ~IS_NEW); }
    get isUnreliable() { return (this.flags & IS_UNRELIABLE) !== 0; }
    set isUnreliable(v) { this.flags = v ? (this.flags | IS_UNRELIABLE) : (this.flags & ~IS_UNRELIABLE); }
    get isTransient() { return (this.flags & IS_TRANSIENT) !== 0; }
    set isTransient(v) { this.flags = v ? (this.flags | IS_TRANSIENT) : (this.flags & ~IS_TRANSIENT); }
    get isStatic() { return (this.flags & IS_STATIC) !== 0; }
    set isStatic(v) { this.flags = v ? (this.flags | IS_STATIC) : (this.flags & ~IS_STATIC); }
    get isStreamCollection() { return (this.flags & IS_STREAM_COLLECTION) !== 0; }
    set isStreamCollection(v) { this.flags = v ? (this.flags | IS_STREAM_COLLECTION) : (this.flags & ~IS_STREAM_COLLECTION); }
    get needsRestage() { return (this.flags & NEEDS_RESTAGE) !== 0; }
    set needsRestage(v) { this.flags = v ? (this.flags | NEEDS_RESTAGE) : (this.flags & ~NEEDS_RESTAGE); }
    // True iff tree inherits `isFiltered` OR its Schema class declares any
    // @view-tagged fields. StateView.addParentOf uses this to decide whether
    // a parent must be included in a view's bootstrap. Reads the class-level
    // "any viewed field" flag that `EncodeDescriptor` precomputes — same
    // pattern as `hasAnyStatic` / `hasAnyUnreliable` / `hasAnyStream`.
    get hasFilteredFields() {
        return this.isFiltered || this.encDescriptor.hasAnyView;
    }
    ensureUnreliableRecorder() {
        if (this.unreliableRecorder === undefined) {
            const isSchema = Metadata.isValidInstance(this.ref);
            this.unreliableRecorder = isSchema
                ? new SchemaChangeRecorder((this.metadata?.[$numFields] ?? 0))
                : new CollectionChangeRecorder();
        }
        return this.unreliableRecorder;
    }
    isFieldUnreliable(index) {
        // Tree-level `isUnreliable` is disabled — @unreliable is rejected
        // on ref-type fields at decoration time, so no tree ever carries
        // the flag. Kept as a comment in case a safe semantics is added
        // later (see INHERITABLE_FLAGS rationale).
        // if (this.isUnreliable) return true;
        // Class-level fast path: most schemas have zero unreliable fields,
        // so the per-mutation check resolves without the symbol-keyed
        // metadata lookup. For schemas that DO have unreliable fields, the
        // bitmask answers fields 0-31 in one bitwise op (no Array.includes
        // linear scan). Fields ≥32 always fall back to the metadata lookup
        // (same limitation as filterBitmask — bitmask only covers low 32).
        const desc = this.encDescriptor;
        if (!desc.hasAnyUnreliable)
            return false;
        if (index < 32)
            return (desc.unreliableBitmask & (1 << index)) !== 0;
        return Metadata.hasUnreliableAtIndex(this.metadata, index);
    }
    // @static fields sync once via full-sync; post-init mutations are ignored
    // by the tracker (the value still lives on the instance).
    isFieldStatic(index) {
        if (this.isStatic)
            return true;
        const desc = this.encDescriptor;
        if (!desc.hasAnyStatic)
            return false;
        if (index < 32)
            return (desc.staticBitmask & (1 << index)) !== 0;
        return Metadata.hasStaticAtIndex(this.metadata, index);
    }
    // `t.stream(...)` collection fields — encoded via per-view priority/budget
    // gate instead of emitting all dirty ADDs in one tick. Class-level short
    // circuit avoids the metadata chase on schemas that carry no stream fields.
    isFieldStream(index) {
        const desc = this.encDescriptor;
        if (!desc.hasAnyStream)
            return false;
        if (index < 32)
            return (desc.streamBitmask & (1 << index)) !== 0;
        return Metadata.hasStreamAtIndex(this.metadata, index);
    }
    constructor(ref) {
        this.ref = ref;
        // `$proxyTarget` is a self-reference set by ArraySchema on the raw
        // target; for non-proxied refs it's undefined and we fall back to
        // `ref`. Cached here so hot-path reads skip the Proxy `get` trap.
        this.refTarget = (ref[$proxyTarget] ?? ref);
        // Single per-class lookup that subsumes Symbol.metadata,
        // isValidInstance, $encoder, $filter, and the filter bitmask.
        // After this, the encode loop never touches `ref.constructor`.
        const desc = getEncodeDescriptor(ref);
        this.encDescriptor = desc;
        this.metadata = desc.metadata;
        const isSchema = desc.isSchema;
        this._isSchema = isSchema;
        // Assign every optional slot so Schema and Collection trees share
        // one hidden-class transition path (tsconfig useDefineForClassFields=false
        // otherwise leaves uninitialized class fields absent from the shape).
        this.ops = undefined;
        this.collDirty = undefined;
        this.collPureOps = undefined;
        if (isSchema) {
            const numFields = (this.metadata?.[$numFields] ?? 0);
            if (numFields > 7)
                this.ops = new Uint8Array(numFields + 1);
        }
        else {
            this.collDirty = new Map();
        }
    }
    // ────────────────────────────────────────────────────────────────────
    // Inline ChangeRecorder implementation. Each method branches once on
    // `_isSchema` (per-tree-stable → predictable branch). Kills one
    // CollectionChangeRecorder+Map allocation per Collection tree.
    // ────────────────────────────────────────────────────────────────────
    // Schema-only helpers that own all inline-vs-array dispatch.
    _opAt(index) {
        const ops = this.ops;
        if (ops !== undefined)
            return ops[index];
        const shift = (index & 3) << 3;
        return (index < 4)
            ? (this.opsLow >>> shift) & 0xFF
            : (this.opsHigh >>> shift) & 0xFF;
    }
    _opPut(index, op) {
        const ops = this.ops;
        if (ops !== undefined) {
            ops[index] = op;
            return;
        }
        const shift = (index & 3) << 3;
        const mask = ~(0xFF << shift);
        if (index < 4)
            this.opsLow = (this.opsLow & mask) | (op << shift);
        else
            this.opsHigh = (this.opsHigh & mask) | (op << shift);
    }
    _markDirty(index) {
        if (index < 32)
            this.dirtyLow |= (1 << index);
        else
            this.dirtyHigh |= (1 << (index - 32));
    }
    record(index, op) {
        if (this._isSchema) {
            const prev = this._opAt(index);
            if (prev === 0)
                this._opPut(index, op);
            else if (prev === OPERATION.DELETE)
                this._opPut(index, OPERATION.DELETE_AND_ADD);
            // Promote ADD → DELETE_AND_ADD when a ref is replaced in the
            // same tick. Otherwise the on-wire op collapses to plain ADD
            // and the decoder's `refs` map leaks the displaced refId —
            // harmless on its own, but refId pooling turns that leak into
            // a catastrophic rebinding when the refId is later reused.
            else if (prev === OPERATION.ADD && op === OPERATION.DELETE_AND_ADD) {
                this._opPut(index, OPERATION.DELETE_AND_ADD);
            }
            // else: existing ADD / DELETE_AND_ADD — preserve op-byte.
            this._markDirty(index);
        }
        else {
            const dirty = this.collDirty;
            const prev = dirty.get(index);
            let finalOp;
            if (prev === undefined)
                finalOp = op;
            else if (prev === OPERATION.DELETE)
                finalOp = OPERATION.DELETE_AND_ADD;
            else if (prev === OPERATION.ADD && op === OPERATION.DELETE_AND_ADD)
                finalOp = OPERATION.DELETE_AND_ADD;
            else
                finalOp = prev;
            dirty.set(index, finalOp);
        }
    }
    recordDelete(index, op) {
        if (this._isSchema) {
            this._opPut(index, op);
            this._markDirty(index);
        }
        else {
            this.collDirty.set(index, op);
        }
    }
    recordRaw(index, op) {
        if (this._isSchema) {
            this._opPut(index, op);
            this._markDirty(index);
        }
        else {
            this.collDirty.set(index, op);
        }
    }
    recordPure(op) {
        if (this._isSchema) {
            throw new Error("ChangeTree (Schema): pure operations are not supported");
        }
        (this.collPureOps ??= []).push([this.collDirty.size, op]);
    }
    operationAt(index) {
        if (this._isSchema) {
            const op = this._opAt(index);
            return op === 0 ? undefined : op;
        }
        return this.collDirty.get(index);
    }
    setOperationAt(index, op) {
        // Schema: overwrite only (no dirty-mark). Collection: overwrite iff key exists (legacy).
        if (this._isSchema) {
            this._opPut(index, op);
        }
        else {
            const dirty = this.collDirty;
            if (dirty.has(index))
                dirty.set(index, op);
        }
    }
    // Cold-path delegate: all `forEach` callers are debug/dump utilities
    // (Schema.ts debug output, utils.ts change dump, discardAll in tests).
    // The hot encode loop uses `forEachWithCtx` directly. See ChangeRecorder.ts
    // for the same adapter pattern.
    forEach(cb) {
        this.forEachWithCtx(cb, _invokeNoCtx);
    }
    forEachWithCtx(ctx, cb) {
        if (this._isSchema) {
            let low = this.dirtyLow;
            let high = this.dirtyHigh;
            const ops = this.ops;
            if (ops !== undefined) {
                while (low !== 0) {
                    const bit = low & -low;
                    const fieldIndex = 31 - Math.clz32(bit);
                    low ^= bit;
                    cb(ctx, fieldIndex, ops[fieldIndex]);
                }
                while (high !== 0) {
                    const bit = high & -high;
                    const fieldIndex = 31 - Math.clz32(bit) + 32;
                    high ^= bit;
                    cb(ctx, fieldIndex, ops[fieldIndex]);
                }
            }
            else {
                const ol = this.opsLow;
                const oh = this.opsHigh;
                while (low !== 0) {
                    const bit = low & -low;
                    const fieldIndex = 31 - Math.clz32(bit);
                    low ^= bit;
                    cb(ctx, fieldIndex, readInlineOpByte(ol, oh, fieldIndex));
                }
            }
            return;
        }
        const dirty = this.collDirty;
        const pure = this.collPureOps;
        if (pure !== undefined && pure.length > 0) {
            let pureIdx = 0, i = 0;
            for (const [index, op] of dirty) {
                while (pureIdx < pure.length && pure[pureIdx][0] <= i) {
                    const pureOp = pure[pureIdx++][1];
                    cb(ctx, -pureOp, pureOp);
                }
                cb(ctx, index, op);
                i++;
            }
            while (pureIdx < pure.length) {
                const pureOp = pure[pureIdx++][1];
                cb(ctx, -pureOp, pureOp);
            }
        }
        else {
            for (const [index, op] of dirty)
                cb(ctx, index, op);
        }
    }
    size() {
        if (this._isSchema)
            return popcount32(this.dirtyLow) + popcount32(this.dirtyHigh);
        return this.collDirty.size + (this.collPureOps?.length ?? 0);
    }
    has() {
        if (this._isSchema)
            return (this.dirtyLow | this.dirtyHigh) !== 0;
        return this.collDirty.size > 0 || (this.collPureOps !== undefined && this.collPureOps.length > 0);
    }
    reset() {
        if (this._isSchema) {
            this.dirtyLow = 0;
            this.dirtyHigh = 0;
            if (this.ops !== undefined)
                this.ops.fill(0);
            else {
                this.opsLow = 0;
                this.opsHigh = 0;
            }
            return;
        }
        this.collDirty.clear();
        if (this.collPureOps !== undefined)
            this.collPureOps.length = 0;
    }
    /**
     * Full reset to construction defaults so the owning ref can be returned to
     * a pool and reused for a different logical entity (see encoder/Pool.ts +
     * Schema.reset). Unlike `reset()` / `endEncode()` (which only clear the
     * dirty bucket for the next encode), this also drops parent links, queue
     * nodes and per-view bitmaps, and re-arms IS_NEW.
     *
     * Precondition: the tree must already be detached from the encoder
     * (`root === undefined`) — i.e. the ref was removed from its parent
     * collection/field, which `Root.remove` does before this runs.
     */
    recycle() {
        if (this.root !== undefined) {
            throw new Error(`@colyseus/schema: cannot recycle an attached ChangeTree ` +
                `(${this.ref?.constructor?.name}). Remove the instance from its ` +
                `parent collection before releasing it to a pool.`);
        }
        // dirty/ops buckets (Schema: dirtyLow/High + ops; Collection: collDirty/collPureOps)
        this.reset();
        // keep the recorder object allocated (re-alloc is the cost we avoid), clear contents
        this.unreliableRecorder?.reset();
        // back to a freshly-constructed tree: IS_NEW, no inherited flags
        // (FILTERED/TRANSIENT/STATIC/STREAM are re-derived on the next setParent).
        // NEEDS_RESTAGE makes the next Root.add re-stage retained field values.
        this.flags = IS_NEW | NEEDS_RESTAGE;
        this._fullSyncGen = 0;
        // drop parent links — Root.remove clears `root` and the CHILDREN's
        // parent links, but leaves this tree's own parentRef dangling.
        this.parentRef = undefined;
        this._parentIndex = undefined;
        this.extraParents = undefined;
        // queue nodes (already nulled by Root.remove's queue removal; defensive)
        this.changesNode = undefined;
        this.unreliableChangesNode = undefined;
        this.paused = false;
        // per-view visibility lives on the tree (NOT keyed by refId), so a
        // recycled tree must not inherit its previous life's view membership.
        this.visibleViews = undefined;
        this.invisibleViews = undefined;
        this.tagViews = undefined;
        this.subscribedViews = undefined;
    }
    shift(shiftIndex) {
        if (this._isSchema)
            throw new Error("ChangeTree (Schema): shift is not supported");
        const src = this.collDirty;
        const dst = new Map();
        for (const [idx, val] of src)
            dst.set(idx + shiftIndex, val);
        this.collDirty = dst;
    }
    // Tree attachment + child iteration — see ./changeTree/treeAttachment.ts.
    setRoot(root) { setRoot(this, root); }
    setParent(parent, root, parentIndex) { setParent(this, parent, root, parentIndex); }
    forEachChild(cb) { forEachChild(this, cb); }
    forEachChildWithCtx(ctx, cb) {
        forEachChildWithCtx(this, ctx, cb);
    }
    forEachLive(cb) { forEachLive(this, cb); }
    forEachLiveWithCtx(ctx, cb) {
        forEachLiveWithCtx(this, ctx, cb);
    }
    operation(op) {
        if (this.paused || this.isStatic)
            return;
        // Pure ops (CLEAR/REVERSE) only emit from collection trees — the
        // recorder here is always a CollectionChangeRecorder by construction.
        //
        // Tree-level `isUnreliable` is disabled (see INHERITABLE_FLAGS):
        // no collection tree can be marked unreliable as a whole under the
        // ref-field rejection rule in `Metadata.setUnreliable`. The branch
        // is kept as a comment for re-enablement.
        // if (this.isUnreliable) {
        //     (this.ensureUnreliableRecorder() as ICollectionChangeRecorder).recordPure(op);
        //     this.root?.enqueueUnreliable(this);
        // } else {
        this.recordPure(op);
        this.root?.enqueueChangeTree(this);
        // }
    }
    /**
     * Route a field-level mutation to the reliable or unreliable channel
     * and enqueue into the matching queue. Shared by `change` and
     * `indexedOperation`; `raw=true` bypasses DELETE→ADD merge
     * (ArraySchema positional writes), `raw=false` merges inside `record`.
     *
     * Note: record() on both channels handles DELETE→ADD merge internally,
     * so callers do not need to pre-compute the merged op.
     *
     * `@unreliable` is decoration-time-validated to apply only to primitive
     * fields (see annotations.ts), so the per-field unreliable flag here
     * always means "primitive value updates" — the structural-ADD-routes-
     * reliable footgun for ref-type fields can't reach this code path.
     */
    _routeAndRecord(index, op, raw) {
        if (this.paused || this.isFieldStatic(index))
            return;
        if (this.isFieldUnreliable(index)) {
            const r = this.ensureUnreliableRecorder();
            if (raw)
                r.recordRaw(index, op);
            else
                r.record(index, op);
            this.root?.enqueueUnreliable(this);
            return;
        }
        if (raw)
            this.recordRaw(index, op);
        else
            this.record(index, op);
        this.root?.enqueueChangeTree(this);
    }
    change(index, operation = OPERATION.ADD) {
        this._routeAndRecord(index, operation, false);
    }
    indexedOperation(index, operation) {
        this._routeAndRecord(index, operation, true);
    }
    // ArraySchema#unshift(): apply shift to both channels.
    // Unreliable recorder on an array is always a CollectionChangeRecorder.
    shiftChangeIndexes(shiftIndex) {
        this.shift(shiftIndex);
        this.unreliableRecorder?.shift(shiftIndex);
    }
    getChange(index) {
        return this.operationAt(index);
    }
    // ────────────────────────────────────────────────────────────────────
    // Change-tracking control API
    // ────────────────────────────────────────────────────────────────────
    pause() { this.paused = true; }
    resume() { this.paused = false; }
    untracked(fn) {
        const wasPaused = this.paused;
        this.paused = true;
        try {
            return fn();
        }
        finally {
            this.paused = wasPaused;
        }
    }
    // Manually mark a field dirty for the next encode(). Useful after a
    // paused mutation or a nested mutation that bypassed the setter.
    markDirty(index, operation = OPERATION.ADD) {
        const wasPaused = this.paused;
        this.paused = false;
        try {
            this.change(index, operation);
        }
        finally {
            this.paused = wasPaused;
        }
    }
    // used during `.encode()` — `isEncodeAll` is only consumed by ArraySchema.
    // Reads via `refTarget` so ArraySchema's Proxy trap is bypassed on the
    // hot per-field encode path.
    getValue(index, isEncodeAll = false) {
        return this.refTarget[$getByIndex](index, isEncodeAll);
    }
    delete(index, operation) {
        if (index === undefined) {
            try {
                throw new Error(`@colyseus/schema ${this.ref.constructor.name}: trying to delete non-existing index '${index}'`);
            }
            catch (e) {
                console.warn(e);
            }
            return;
        }
        if (this.paused || this.isFieldStatic(index))
            return this.getValue(index);
        const unreliable = this.isFieldUnreliable(index);
        if (unreliable)
            this.ensureUnreliableRecorder().recordDelete(index, operation ?? OPERATION.DELETE);
        else
            this.recordDelete(index, operation ?? OPERATION.DELETE);
        const previousValue = this.getValue(index);
        // `this.root` is always undefined on decoder-side instances
        // (they're built via `initializeForDecoder`, which skips Root
        // attachment). The optional chain handles both sides; this is
        // an intentional invariant, not a bug.
        if (previousValue && previousValue[$changes])
            this.root?.remove(previousValue[$changes]);
        if (unreliable)
            this.root?.enqueueUnreliable(this);
        else
            this.root?.enqueueChangeTree(this);
        return previousValue;
    }
    // Clear the reliable dirty bucket after a reliable encode pass.
    endEncode() {
        this.reset();
        this.changesNode = undefined;
        this.ref[$onEncodeEnd]?.();
        this.isNew = false;
    }
    // Clear the unreliable dirty bucket after an unreliable encode pass.
    endEncodeUnreliable() {
        this.unreliableRecorder?.reset();
        this.unreliableChangesNode = undefined;
        this.ref[$onEncodeEnd]?.();
    }
    discard() {
        this.ref[$onEncodeEnd]?.();
        this.reset();
        this.unreliableRecorder?.reset();
    }
    // Recursively discard all changes on this + child structures. Tests only.
    discardAll() {
        const discardChild = (index) => {
            if (index < 0)
                return;
            const value = this.getValue(index);
            if (value && value[$changes])
                value[$changes].discardAll();
        };
        this.forEach(discardChild);
        this.unreliableRecorder?.forEach(discardChild);
        this.discard();
    }
    get changed() {
        return this.has() || (this.unreliableRecorder?.has() ?? false);
    }
    // ────────────────────────────────────────────────────────────────────
    // Parent chain — implementations in ./changeTree/parentChain.ts.
    // ────────────────────────────────────────────────────────────────────
    /** Immediate parent (primary). See `extraParents` for the 2nd+ chain. */
    get parent() { return this.parentRef; }
    get parentIndex() { return this._parentIndex; }
    addParent(parent, index) { addParent(this, parent, index); }
    /** @returns true if parent was found and removed */
    removeParent(parent = this.parent) { return removeParent(this, parent); }
    findParent(predicate) {
        return findParent(this, predicate);
    }
    hasParent(predicate) {
        return hasParent(this, predicate);
    }
    getAllParents() { return getAllParents(this); }
}
/**
 * Lightweight per-instance no-op ChangeTree used for instances the decoder
 * builds. Those instances never feed back into an Encoder, so the full
 * `ChangeTree` machinery (EncodeDescriptor lookup, recorder state, Maps /
 * Uint8Arrays for change slots) is pure overhead — this stub carries only a
 * `ref` back-pointer and no-op methods, so tree walkers and debug tooling
 * continue to work.
 *
 * Plug-in contract: each collection class and the `Decoder` pick between
 * `new ChangeTree(ref)` and `createUntrackedChangeTree(ref)` explicitly via
 * dedicated factories (`initializeForDecoder` on collections,
 * `createInstanceOfType` on the `Decoder`). There is no global state — every
 * decision is local to the call site.
 */
class UntrackedChangeTree {
    ref;
    // Mirror the subset of ChangeTree state that decoder-path readers touch.
    // Everything else is deliberately undefined (matches the shape of a
    // freshly-constructed tree that never participated in a Root).
    root = undefined;
    parentRef = undefined;
    paused = false;
    isNew = false;
    flags = 0;
    constructor(ref) {
        this.ref = ref;
    }
    // Mutation surface — all no-ops.
    change() { }
    delete() { }
    indexedOperation() { }
    operation() { }
    setParent() { }
    addParent() { }
    removeParent() { return false; }
    getChange() { return 0; }
    discard() { }
    discardAll() { }
    pause() { }
    resume() { }
    untracked(fn) { return fn(); }
    markDirty() { }
    // Tree-walk surface. Mirrors `treeAttachment.forEachChild` so debug tools
    // and `ArraySchema.clear()` can still descend from a tracked root into
    // decoder-built subtrees and read each child's `$changes` (which is
    // itself an UntrackedChangeTree carrying the right `ref`).
    forEachChild(callback) {
        const ref = this.ref;
        if (ref[$childType]) {
            if (typeof ref[$childType] !== "string") {
                for (const [key, value] of ref.entries()) {
                    if (!value)
                        continue;
                    callback(value[$changes], ref._collectionIndexes?.[key] ?? key);
                }
            }
            return;
        }
        const ctor = ref.constructor;
        const metadata = ctor?.[Symbol.metadata];
        if (!metadata)
            return;
        const refFieldIndexes = metadata[$refTypeFieldIndexes] ?? [];
        for (let i = 0; i < refFieldIndexes.length; i++) {
            const index = refFieldIndexes[i];
            const value = ref[metadata[index].name];
            if (!value)
                continue;
            callback(value[$changes], index);
        }
    }
    forEachChildWithCtx(ctx, callback) {
        this.forEachChild((change, at) => callback(ctx, change, at));
    }
    forEachLive() { }
    forEachLiveWithCtx() { }
    forEach() { }
}
// Factory, cast to ChangeTree so call sites that type `$changes` as
// `ChangeTree` accept it. The surface overlap above covers every read/write
// the decoder path reaches.
function createUntrackedChangeTree(ref) {
    return new UntrackedChangeTree(ref);
}
/**
 * Install a non-enumerable `$changes: UntrackedChangeTree` on `target`.
 * Shared by `Schema.initializeForDecoder` and every collection's
 * `initializeForDecoder`. `publicRef` defaults to `target` — pass a Proxy
 * instead (ArraySchema) so children attached to this tree see the Proxy
 * as their parent, not the raw target.
 *
 * `enumerable: false` is load-bearing — tests use `deepStrictEqual` on
 * decoded instances and walking into `$changes` would recurse through
 * circular refs. Same descriptor shape as the tracked `Schema.initialize`
 * + collection ctors.
 */
function installUntrackedChangeTree(target, publicRef = target) {
    Object.defineProperty(target, $changes, {
        value: createUntrackedChangeTree(publicRef),
        enumerable: false,
        writable: true,
    });
}

function encodeValue(encoder, bytes, type, value, operation, it, encoderFn) {
    if (encoderFn !== undefined) {
        // Fast path: pre-computed encoder for primitive types.
        encoderFn(bytes, value, it);
    }
    else if (typeof (type) === "string") {
        // Fallback for types not pre-computed (e.g. runtime-constructed).
        encode[type]?.(bytes, value, it);
    }
    else if (type[Symbol.metadata] !== undefined) {
        //
        // Encode refId for this instance.
        // The actual instance is going to be encoded on next `changeTree` iteration.
        //
        encode.number(bytes, value[$refId], it);
        // Try to encode inherited TYPE_ID if it's an ADD operation.
        if ((operation & OPERATION.ADD) === OPERATION.ADD) {
            encoder.tryEncodeTypeId(bytes, type, value.constructor, it);
        }
    }
    else {
        //
        // Encode refId for this instance.
        // The actual instance is going to be encoded on next `changeTree` iteration.
        //
        encode.number(bytes, value[$refId], it);
    }
}
/**
 * Used for Schema instances.
 * @private
 */
const encodeSchemaOperation = function (encoder, bytes, changeTree, index, operation, it, _, __) {
    // "compress" field index + operation
    bytes[it.offset++] = (index | operation) & 255;
    // Do not encode value for DELETE operations
    if (operation === OPERATION.DELETE) {
        return;
    }
    // Read field info from the per-class descriptor's parallel arrays —
    // replaces `metadata[index]` (returns a per-field obj) + `.name` /
    // `.type` chains. The `encoders` array is also pre-baked here so we
    // skip a `metadata[$encoders]?.[index]` symbol-keyed lookup per call.
    const desc = changeTree.encDescriptor;
    const ref = changeTree.ref;
    // Direct $values[index] read — bypasses prototype getter + metadata name lookup.
    // Falls back to named property for manual fields (which don't use $values).
    const value = ref[$values][index] ?? ref[desc.names[index]];
    encodeValue(encoder, bytes, desc.types[index], value, operation, it, desc.encoders[index]);
};
/**
 * Encode a single MapSchema entry. Splits the legacy
 * `encodeKeyValueOperation` so the per-emission `typeof ref['set']` check
 * is gone — MapSchema instances are routed here via their `[$encoder]`
 * static, the dynamic-key string emission is unconditional on ADD.
 *
 * @private
 */
const encodeMapEntry = function (encoder, bytes, changeTree, index, operation, it) {
    bytes[it.offset++] = operation & 255;
    encode.number(bytes, index, it);
    if (operation === OPERATION.DELETE)
        return;
    const ref = changeTree.ref;
    // ADD or DELETE_AND_ADD: emit the user-facing string key for dynamic
    // map fields. SetSchema/CollectionSchema use a different encoder and
    // skip this entirely (no dynamic key).
    if ((operation & OPERATION.ADD) === OPERATION.ADD) {
        const dynamicIndex = ref['$indexes'].get(index);
        encode.string(bytes, dynamicIndex, it);
    }
    encodeValue(encoder, bytes, ref[$childType], ref[$getByIndex](index), operation, it);
};
/**
 * Encode a single SetSchema / CollectionSchema entry. Wire format is the
 * same as MapSchema minus the dynamic-key string, so this path skips the
 * legacy `typeof ref['set']` check entirely.
 *
 * @private
 */
const encodeIndexedEntry = function (encoder, bytes, changeTree, index, operation, it) {
    bytes[it.offset++] = operation & 255;
    encode.number(bytes, index, it);
    if (operation === OPERATION.DELETE)
        return;
    const ref = changeTree.ref;
    encodeValue(encoder, bytes, ref[$childType], ref[$getByIndex](index), operation, it);
};
/**
 * Unified encoder kept for back-compat with external consumers that may
 * have registered it directly via `static [$encoder] =
 * encodeKeyValueOperation`. New code (and all internal collections)
 * should use the split variants — `encodeMapEntry` for MapSchema and
 * `encodeIndexedEntry` for SetSchema / CollectionSchema.
 *
 * The runtime `typeof ref['set']` check below is the per-emission cost
 * the split is designed to remove.
 */
const encodeKeyValueOperation = function (encoder, bytes, changeTree, index, operation, it) {
    const ref = changeTree.ref;
    if ((operation & OPERATION.ADD) === OPERATION.ADD && typeof ref['set'] === "function") {
        encodeMapEntry(encoder, bytes, changeTree, index, operation, it);
    }
    else {
        encodeIndexedEntry(encoder, bytes, changeTree, index, operation, it);
    }
};
/**
 * Used for collections (MapSchema, ArraySchema, etc.)
 * @private
 */
const encodeArray = function (encoder, bytes, changeTree, field, operation, it, isEncodeAll, hasView) {
    // Read through `refTarget` so every property access below skips the
    // ArraySchema Proxy `get` trap. `refTarget` points at the raw backing
    // instance; `ref` (the Proxy) stays the user-facing identity.
    const ref = changeTree.refTarget;
    // ArraySchema stores its per-instance child type at `$childType`.
    // This encoder is array-only — there's no Schema fallback to consider.
    const type = ref[$childType];
    const useOperationByRefId = hasView && changeTree.isFiltered && typeof type !== "string";
    let refOrIndex;
    if (useOperationByRefId) {
        const item = ref.tmpItems[field];
        // Skip encoding if item is undefined (e.g. when clear() is called)
        if (!item) {
            return;
        }
        refOrIndex = item[$refId];
        if (operation === OPERATION.DELETE) {
            operation = OPERATION.DELETE_BY_REFID;
        }
        else if (operation === OPERATION.ADD) {
            operation = OPERATION.ADD_BY_REFID;
        }
    }
    else {
        refOrIndex = field;
    }
    // encode operation
    bytes[it.offset++] = operation & 255;
    // encode index
    encode.number(bytes, refOrIndex, it);
    // Do not encode value for DELETE operations
    if (operation === OPERATION.DELETE || operation === OPERATION.DELETE_BY_REFID) {
        return;
    }
    // `type` was already read above. Direct $getByIndex call — skips
    // ChangeTree.getValue's pass-through wrapper.
    const value = ref[$getByIndex](field, isEncodeAll);
    encodeValue(encoder, bytes, type, value, operation, it);
};

/**
 * Resync ("full-snapshot reconciliation") support for {@link Decoder.decodeResync}.
 *
 * A rejoin snapshot is authoritative for everything it contains — but the
 * plain decode path is additive: entries deleted (or hidden by a view)
 * while the client was off the wire survive as ghosts. This module owns the
 * generic reconciliation algorithm:
 *
 * - during the decode walk, the collection DecodeOperation functions report
 *   every entry the payload touches ({@link resyncRecordVisit}) and every
 *   collection that appears at all ({@link resyncMarkPresent});
 * - after the walk, {@link resyncSweep} removes whatever was never reported,
 *   through the same DELETE bookkeeping the regular decode path uses
 *   (DataChange DELETE → onRemove; removeRef → GC).
 *
 * Storage-specific pruning (journal upkeep, array compaction, stream
 * exemption) lives on each collection class as `[$resyncPrune]` — declared
 * on the `Collection` interface, so every collection kind must state its
 * own sweep semantics.
 *
 * All entry points are guarded by `decoder.resyncVisited !== null` at the
 * call sites — the normal decode path never pays for any of this.
 */
/**
 * Record that the current structure's entry at `identity` (map string key /
 * element index) appeared in the payload — even when its value is unchanged
 * (`allChanges` cannot serve as this record: its pushes are guarded by
 * `previousValue !== value`, so unchanged entries would look unvisited).
 *
 * Also releases a replaced occupant: full-sync emits plain ADD (never
 * DELETE_AND_ADD), so an entry whose instance changed while this client was
 * off the wire would otherwise leak its previous ref (no onRemove, never
 * GC'd). This release is correct ONLY under a full snapshot — a live patch's
 * plain ADD over a different instance can be a positional rewrite (array
 * shift/unshift) where the occupant *moved* and is still alive; a snapshot
 * re-adds moved instances elsewhere, so the refcounts balance.
 */
function resyncTouchEntry(decoder, ref, operation, identity, previousValue, value, allChanges) {
    const visited = decoder.resyncVisited;
    let set = visited.get(decoder.currentRefId);
    if (set === undefined) {
        visited.set(decoder.currentRefId, set = new Set());
    }
    set.add(identity);
    if (previousValue !== undefined && operation === OPERATION.ADD && previousValue !== value) {
        const previousRefId = previousValue[$refId];
        if (previousRefId !== undefined) {
            decoder.root.removeRef(previousRefId);
            allChanges?.push({
                ref,
                refId: decoder.currentRefId,
                op: OPERATION.DELETE,
                dynamicIndex: identity,
                value: undefined,
                previousValue,
            });
        }
    }
}
/**
 * Mark a collection as present in the payload — even with zero entries.
 * The sweep only prunes collections reported here: absence means "not part
 * of full-sync" (@transient, view-invisible), where pruning would destroy
 * live data. Reflected clients have no @transient metadata, so payload
 * presence is the only reliable signal.
 */
function resyncMarkPresent(decoder, refId) {
    const visited = decoder.resyncVisited;
    if (!visited.has(refId)) {
        visited.set(refId, new Set());
    }
}
/**
 * Post-decode phase of {@link Decoder.decodeResync}: remove every collection
 * entry the snapshot did not visit.
 *
 * Walks the tree from the root — NOT `root.refs` — for three reasons:
 * `@transient` fields are never part of a snapshot and must be left alone;
 * entries of subtrees removed by the sweep itself are left to the GC's
 * transitive walk (sweeping them directly would double-decrement shared
 * children); and collections the snapshot never mentions (emptied
 * server-side) are still reachable and get pruned.
 */
function resyncSweep(decoder, allChanges) {
    if (decoder.resyncDamaged) {
        console.warn("@colyseus/schema: resync sweep skipped — parts of the payload could not be decoded. " +
            "Stale entries may persist until the next resync.");
        return;
    }
    sweepSchema(decoder, decoder.state, new Set(), allChanges);
}
function sweepSchema(decoder, ref, seen, allChanges) {
    const refId = ref[$refId];
    if (refId === undefined || seen.has(refId)) {
        return;
    }
    seen.add(refId);
    const metadata = ref.constructor[Symbol.metadata];
    const refIndexes = metadata?.[$refTypeFieldIndexes];
    if (refIndexes === undefined) {
        return;
    }
    const transient = metadata[$transientFieldIndexes];
    for (let i = 0; i < refIndexes.length; i++) {
        const fieldIndex = refIndexes[i];
        // @transient fields are never in a snapshot — leave them alone.
        if (transient !== undefined && transient.includes(fieldIndex)) {
            continue;
        }
        const field = metadata[fieldIndex];
        const value = ref[field.name];
        if (!value) {
            continue;
        }
        if (Schema.is(field.type)) {
            sweepSchema(decoder, value, seen, allChanges);
        }
        else {
            sweepCollection(decoder, value, seen, allChanges);
        }
    }
}
function sweepCollection(decoder, coll, seen, allChanges) {
    const tgt = coll[$proxyTarget] ?? coll;
    const refId = tgt[$refId];
    if (refId === undefined || seen.has(refId)) {
        return;
    }
    seen.add(refId);
    // `undefined` = the collection never appeared in the payload at all
    // (not even as its parent's field op) — it is not part of full-sync
    // (@transient, view-invisible) and must be left alone. An empty Set
    // means "present with zero entries" → prune everything.
    const visited = decoder.resyncVisited.get(refId);
    if (visited === undefined) {
        return;
    }
    const $root = decoder.root;
    tgt[$resyncPrune](visited, (value, identity) => {
        allChanges?.push({
            ref: coll,
            refId,
            op: OPERATION.DELETE,
            dynamicIndex: identity,
            value: undefined,
            previousValue: value,
        });
        const childRefId = value?.[$refId];
        if (childRefId !== undefined) {
            $root.removeRef(childRefId);
        }
    }, (value) => {
        // recurse so nested collections of retained entries sweep too
        if (Schema.isSchema(value)) {
            sweepSchema(decoder, value, seen, allChanges);
        }
    });
}

const DEFINITION_MISMATCH = -1;
/**
 * Collection-kind discriminator declared on each collection class as
 * `static COLLECTION_KIND = CollectionKind.X`. The decoder's key/value
 * dispatch used to make three back-to-back `typeof(ref.method) ===
 * "function"` checks per entry; those collapse into one switch on the
 * target's class tag. Missing / `undefined` on a ref hits the switch's
 * `default` branch and logs a warning — a guard for future collection
 * types that land without a tag.
 *
 * Declared as a `const` object (not a TS `enum`) so the codegen parser —
 * which picks up every `EnumDeclaration` in the lib source via transitive
 * imports — doesn't emit a generated .cs file for it.
 */
const CollectionKind = {
    Map: 1,
    Array: 2,
    Set: 3,
    Collection: 4,
    Stream: 5,
};
/**
 * Decode the next wire value for `ref[index]`. Returns the decoded value.
 *
 * Callers pass `previousValue` explicitly — it's the current value at the
 * slot before decoding and is needed for ref-count bookkeeping (on DELETE)
 * and for the DELETE_AND_ADD self-reassign case. Keeping it as a parameter
 * lets this function return a single primitive instead of a pair, so the
 * hot call path allocates nothing.
 */
function decodeValue(decoder, operation, ref, index, previousValue, type, bytes, it, allChanges) {
    const $root = decoder.root;
    let value;
    if ((operation & OPERATION.DELETE) === OPERATION.DELETE) {
        // Flag `refId` for garbage collection.
        const previousRefId = previousValue?.[$refId];
        if (previousRefId !== undefined) {
            $root.removeRef(previousRefId);
        }
        //
        // Delete operations
        //
        if (operation !== OPERATION.DELETE_AND_ADD) {
            ref[$deleteByIndex](index);
        }
        value = undefined;
    }
    if (operation === OPERATION.DELETE) ;
    else if (typeof (type) === "string") {
        //
        // Primitive value (number, string, boolean, …). Hot-path first
        // because steady-state ticks are dominated by primitive field
        // updates — moves us past a cheap typeof check instead of a
        // Symbol-metadata lookup via `Schema.is`.
        //
        value = decode[type](bytes, it);
    }
    else if (isQuantizedType(type)) {
        // Quantized scalar: read the unsigned-int wire value, then dequantize so
        // the instance holds (and yields) the wire-exact float — `decodeSchema-
        // Operation` writes it through the snapping setter (idempotent here).
        value = decodeQuantized(type.quantized, bytes, it);
    }
    else if (Schema.is(type)) {
        const refId = decode.number(bytes, it);
        value = $root.refs.get(refId);
        if ((operation & OPERATION.ADD) === OPERATION.ADD) {
            const childType = decoder.getInstanceType(bytes, it, type);
            if (!value) {
                value = decoder.createInstanceOfType(childType);
            }
            $root.addRef(refId, value, (value !== previousValue || // increment ref count if value has changed
                (operation === OPERATION.DELETE_AND_ADD && value === previousValue) // increment ref count if the same instance is being added again
            ));
        }
    }
    else {
        const typeDef = getType(Object.keys(type)[0]);
        const refId = decode.number(bytes, it);
        // resync bookkeeping — see Resync.ts
        if (decoder.resyncVisited !== null) {
            resyncMarkPresent(decoder, refId);
        }
        // `initializeForDecoder` is a static on every registered collection
        // class — it does `Object.create(Class.prototype)` + the class-
        // field init + assigns an untracked `$changes` directly. Keeps
        // the decoder free of collection-type internals.
        const valueRef = ($root.refs.has(refId))
            ? previousValue || $root.refs.get(refId)
            : typeDef.constructor.initializeForDecoder();
        value = valueRef.clone(true);
        value[$childType] = Object.values(type)[0]; // cache childType for ArraySchema and MapSchema
        if (previousValue) {
            let previousRefId = previousValue[$refId];
            if (previousRefId !== undefined && refId !== previousRefId) {
                // Collection field replaced by a different instance.
                //
                // Don't decrement children here: GC (`garbageCollectDeletedRefs`)
                // removes them once the previous collection's refId hits zero.
                // Doing it here too would double-decrement a *shared* child and
                // drop it while still referenced ("refId not found").
                if ((operation & OPERATION.DELETE) !== OPERATION.DELETE) {
                    // Replacement not tagged DELETE (e.g. pending ADD not upgraded
                    // to DELETE_AND_ADD), so the previous refId wasn't decremented
                    // above. Release it here, else it never gets GC'd (leak).
                    $root.removeRef(previousRefId);
                }
                // enqueue onRemove callbacks for the previous collection's children.
                const entries = previousValue.entries();
                let iter;
                while ((iter = entries.next()) && !iter.done) {
                    const [key, value] = iter.value;
                    if (typeof (value) === "object") {
                        previousRefId = value[$refId];
                    }
                    allChanges?.push({
                        ref: previousValue,
                        refId: previousRefId,
                        op: OPERATION.DELETE,
                        field: key,
                        value: undefined,
                        previousValue: value,
                    });
                }
            }
        }
        $root.addRef(refId, value, (valueRef !== previousValue ||
            (operation === OPERATION.DELETE_AND_ADD && valueRef === previousValue)));
    }
    return value;
}
const decodeSchemaOperation = function (decoder, bytes, it, ref, allChanges) {
    const first_byte = bytes[it.offset++];
    const metadata = ref.constructor[Symbol.metadata];
    // "compressed" index + operation
    const operation = (first_byte >> 6) << 6;
    const index = first_byte % (operation || 255);
    // skip early if field is not defined
    const field = metadata[index];
    if (field === undefined) {
        console.warn("@colyseus/schema: field not defined at", { index, ref: ref.constructor.name, metadata });
        return DEFINITION_MISMATCH;
    }
    const previousValue = ref[$getByIndex](index);
    const value = decodeValue(decoder, operation, ref, index, previousValue, field.type, bytes, it, allChanges);
    if (value !== null && value !== undefined) {
        // Write via the generated setter. Bypass to `(ref as any)[$values][index]`
        // was attempted but only works for @type-decorated classes (which
        // install accessor descriptors reading from `$values`). Reflection-
        // decoded classes install a plain data-property descriptor instead,
        // so their value lives as an own property on the instance — direct
        // `$values[index]` writes are invisible to the getter on that path.
        // Two-mode dispatch would cost more than the ~3% it'd save.
        ref[field.name] = value;
    }
    // add change
    if (previousValue !== value) {
        allChanges?.push({
            ref,
            refId: decoder.currentRefId,
            op: operation,
            field: field.name,
            value,
            previousValue,
        });
    }
};
const decodeKeyValueOperation = function (decoder, bytes, it, ref, allChanges) {
    // Unwrap ArraySchema Proxy once so subsequent property reads skip the
    // `get` trap. `$proxyTarget` is a self-reference on the target; on
    // non-proxied collections (Map/Set/Collection/Stream) the lookup is
    // undefined and we fall back to `ref`.
    const tgt = ref[$proxyTarget] ?? ref;
    // "uncompressed" index + operation (array/map items)
    const operation = bytes[it.offset++];
    if (operation === OPERATION.CLEAR) {
        //
        // When decoding:
        // - enqueue items for DELETE callback.
        // - flag child items for garbage collection.
        //
        decoder.removeChildRefs(tgt, allChanges);
        tgt.clear();
        return;
    }
    const index = decode.number(bytes, it);
    const type = tgt[$childType];
    // One constructor lookup, one integer read → switch. Replaces three
    // `typeof(ref.method) === "function"` dispatches per entry.
    const kind = tgt.constructor.COLLECTION_KIND;
    let dynamicIndex;
    if ((operation & OPERATION.ADD) === OPERATION.ADD) { // ADD or DELETE_AND_ADD
        if (kind === CollectionKind.Map) {
            dynamicIndex = decode.string(bytes, it); // MapSchema uses a wire-delivered string key
            tgt.setIndex(index, dynamicIndex);
        }
        else {
            dynamicIndex = index;
        }
    }
    else {
        dynamicIndex = tgt.getIndex(index);
    }
    const previousValue = tgt[$getByIndex](index);
    const value = decodeValue(decoder, operation, ref, index, previousValue, type, bytes, it, allChanges);
    // resync bookkeeping — see Resync.ts
    if (decoder.resyncVisited !== null) {
        resyncTouchEntry(decoder, ref, operation, dynamicIndex, previousValue, value, allChanges);
    }
    if (value !== null && value !== undefined) {
        switch (kind) {
            case CollectionKind.Map:
                tgt.$items.set(dynamicIndex, value);
                break;
            case CollectionKind.Array:
                tgt.$setAt(index, value, operation);
                break;
            // SetSchema / CollectionSchema / StreamSchema — use the wire-
            // index we decoded above so server/client `$items` stay in sync
            // regardless of duplicate emission (e.g. a bootstrap that walks
            // both `encodeAll` and the shared recorder emits the same ADD
            // op twice). Previous implementation called `ref.add(value)`
            // and let the decoder-side `$refId++` allocate a new index per
            // call — which for CollectionSchema (no value-dedup) turned
            // duplicate wire ADDs into duplicate client-side entries.
            case CollectionKind.Set:
            case CollectionKind.Collection:
            case CollectionKind.Stream:
                if (!tgt.$items.has(index)) {
                    tgt.$items.set(index, value);
                    // Keep the decoder's monotonic counter ahead of any
                    // wire-index we've seen so future server-side `.add()`
                    // allocations don't collide with ones already decoded.
                    // (StreamSchema has no `$refId` counter — `typeof`
                    // guards the Set/Collection path.)
                    if (typeof tgt.$refId === "number" && index >= tgt.$refId) {
                        tgt.$refId = index + 1;
                    }
                }
                break;
            default:
                // A future collection type landed without a COLLECTION_KIND
                // tag. Surface it loudly instead of silently dropping the
                // value — the missing entry here is the only place the new
                // type's item-storage semantics need to be wired up.
                console.warn(`@colyseus/schema: missing COLLECTION_KIND on ${tgt.constructor?.name} — item at index ${index} was not stored.`);
                break;
        }
    }
    // add change
    if (previousValue !== value) {
        allChanges?.push({
            ref,
            refId: decoder.currentRefId,
            op: operation,
            dynamicIndex,
            value,
            previousValue,
        });
    }
};
const decodeArray = function (decoder, bytes, it, ref, allChanges) {
    // Unwrap the Proxy once — ref is always an ArraySchema here.
    const tgt = ref[$proxyTarget] ?? ref;
    // "uncompressed" index + operation (array/map items)
    let operation = bytes[it.offset++];
    let index;
    if (operation === OPERATION.CLEAR) {
        //
        // When decoding:
        // - enqueue items for DELETE callback.
        // - flag child items for garbage collection.
        //
        decoder.removeChildRefs(tgt, allChanges);
        tgt.clear();
        return;
    }
    else if (operation === OPERATION.REVERSE) {
        tgt.reverse();
        return;
    }
    else if (operation === OPERATION.DELETE_BY_REFID) {
        // TODO: refactor here, try to follow same flow as below
        const refId = decode.number(bytes, it);
        const previousValue = decoder.root.refs.get(refId);
        // Decrement the removed child's ref-count so it can be garbage
        // collected — this refId-based branch returns early and never reaches
        // decodeValue(), so it must do the same DELETE bookkeeping itself.
        // Without this the refId leaks; a later encoder reuse then aliases a
        // different type → "field not defined" / "definition mismatch"
        // (surfaces under StateView when a filtered ArraySchema element is
        // spliced while its parent moves through view membership churn).
        if (previousValue !== undefined) {
            decoder.root.removeRef(refId);
        }
        index = tgt.findIndex((value) => value === previousValue);
        tgt[$deleteByIndex](index);
        allChanges?.push({
            ref,
            refId: decoder.currentRefId,
            op: OPERATION.DELETE,
            dynamicIndex: index,
            value: undefined,
            previousValue,
        });
        return;
    }
    else if (operation === OPERATION.ADD_BY_REFID) {
        const refId = decode.number(bytes, it);
        const itemByRefId = decoder.root.refs.get(refId);
        // if item already exists, use existing index
        if (itemByRefId) {
            index = tgt.findIndex((value) => value === itemByRefId);
        }
        // fallback to use last index
        if (index === -1 || index === undefined) {
            index = tgt.length;
        }
    }
    else {
        index = decode.number(bytes, it);
    }
    const type = tgt[$childType];
    let dynamicIndex = index;
    // Direct `items[index]` read — ArraySchema's `$getByIndex` is encoder-only
    // (it consults `tmpItems`/`deletedIndexes`, which the decoder doesn't
    // maintain). The decoder's authoritative state is `items`.
    const previousValue = tgt.items[index];
    const value = decodeValue(decoder, operation, ref, index, previousValue, type, bytes, it, allChanges);
    // resync bookkeeping — see Resync.ts. `index` is the RESOLVED position
    // (ADD_BY_REFID lands on the instance's current client-side index), so
    // visited entries form a sparse set.
    if (decoder.resyncVisited !== null) {
        resyncTouchEntry(decoder, ref, operation, index, previousValue, value, allChanges);
    }
    if (value !== null && value !== undefined &&
        value !== previousValue // avoid setting same value twice (if index === 0 it will result in a "unshift" for ArraySchema)
    ) {
        tgt.$setAt(index, value, operation);
    }
    // add change
    if (previousValue !== value) {
        allChanges?.push({
            ref,
            refId: decoder.currentRefId,
            op: operation,
            dynamicIndex,
            value,
            previousValue,
        });
    }
};

class EncodeSchemaError extends Error {
}
function assertInstanceType(value, type, instance, field) {
    if (!(value instanceof type)) {
        throw new EncodeSchemaError(`a '${type.name}' was expected, but '${value && value.constructor.name}' was provided in ${instance.constructor.name}#${field}`);
    }
}

const DEFAULT_SORT = (a, b) => {
    const A = a.toString();
    const B = b.toString();
    if (A < B)
        return -1;
    else if (A > B)
        return 1;
    else
        return 0;
};
/**
 * Module-level Proxy handler shared by every `ArraySchema` instance. Hoisted
 * out of the ctor so per-instance Proxy setup stops allocating ~6 arrow
 * closures (the `__name` wrappers around those closures dominated one slice
 * of the decoder profile). The handlers reference the target via the trap's
 * `obj` arg — they don't need a captured `this`. Both `new ArraySchema()`
 * and `ArraySchema.initializeForDecoder()` plug into it.
 */
const ARRAY_PROXY_HANDLER = {
    get: (obj, prop) => {
        if (typeof (prop) !== "symbol" &&
            // FIXME: d8 accuses this as low performance
            !isNaN(prop) // https://stackoverflow.com/a/175787/892698
        ) {
            return obj.items[prop];
        }
        return Reflect.get(obj, prop);
    },
    set: (obj, key, setValue) => {
        if (typeof (key) !== "symbol" && !isNaN(key)) {
            if (setValue === undefined || setValue === null) {
                obj.$deleteAt(key);
            }
            else {
                if (setValue[$changes]) {
                    assertInstanceType(setValue, obj[$childType], obj, key);
                    const previousValue = obj.items[key];
                    if (!obj.isMovingItems) {
                        obj.$changeAt(Number(key), setValue);
                    }
                    else {
                        if (previousValue !== undefined) {
                            if (setValue[$changes].isNew) {
                                obj[$changes].indexedOperation(Number(key), OPERATION.MOVE_AND_ADD);
                            }
                            else {
                                if ((obj[$changes].getChange(Number(key)) & OPERATION.DELETE) === OPERATION.DELETE) {
                                    obj[$changes].indexedOperation(Number(key), OPERATION.DELETE_AND_MOVE);
                                }
                                else {
                                    obj[$changes].indexedOperation(Number(key), OPERATION.MOVE);
                                }
                            }
                        }
                        else if (setValue[$changes].isNew) {
                            obj[$changes].indexedOperation(Number(key), OPERATION.ADD);
                        }
                        setValue[$changes].setParent(obj, obj[$changes].root, key);
                    }
                    if (previousValue !== undefined) {
                        // remove root reference from previous value
                        previousValue[$changes].root?.remove(previousValue[$changes]);
                    }
                }
                else {
                    obj.$changeAt(Number(key), setValue);
                }
                obj.items[key] = setValue;
                obj.tmpItems[key] = setValue;
            }
            return true;
        }
        return Reflect.set(obj, key, setValue);
    },
    deleteProperty: (obj, prop) => {
        if (typeof (prop) === "number") {
            obj.$deleteAt(prop);
        }
        else {
            delete obj[prop];
        }
        return true;
    },
    has: (obj, key) => {
        if (typeof (key) !== "symbol" && !isNaN(Number(key))) {
            return Reflect.has(obj.items, key);
        }
        return Reflect.has(obj, key);
    },
};
class ArraySchema {
    [$changes];
    [$refId];
    [$proxyTarget];
    [$childType];
    items = [];
    tmpItems = [];
    deletedIndexes = [];
    isMovingItems = false;
    /** Decode-side: `items` has holes (delete or gap-write) — `$onDecodeEnd` must compact. */
    _needsCompaction = false;
    static [$encoder] = encodeArray;
    static [$decoder] = decodeArray;
    /** Integer tag read by `decodeKeyValueOperation` — see `CollectionKind`. */
    static COLLECTION_KIND = CollectionKind.Array;
    /**
     * Determine if a property must be filtered.
     * - If returns false, the property is NOT going to be encoded.
     * - If returns true, the property is going to be encoded.
     *
     * Encoding with "filters" happens in two steps:
     * - First, the encoder iterates over all "not owned" properties and encodes them.
     * - Then, the encoder iterates over all "owned" properties per instance and encodes them.
     */
    static [$filter](ref, index, view) {
        if (!view)
            return true; // must stay first — encodeAll hits this per element
        const self = ref[$proxyTarget] ?? ref; // ref arrives proxied — skip traps below
        return (typeof (self[$childType]) === "string" ||
            view.isChangeTreeVisible(self['tmpItems'][index]?.[$changes]));
    }
    static is(type) {
        return (
        // type format: ["string"]
        Array.isArray(type) ||
            // type format: { array: "string" }
            (type['array'] !== undefined));
    }
    static from(iterable) {
        return new ArraySchema(...Array.from(iterable));
    }
    constructor(...items) {
        this[$childType] = undefined;
        // Self-reference so methods called via the Proxy can recover the
        // underlying instance and access fields directly. See $proxyTarget.
        this[$proxyTarget] = this;
        const proxy = new Proxy(this, ARRAY_PROXY_HANDLER);
        Object.defineProperty(this, $changes, {
            value: new ChangeTree(proxy),
            enumerable: false,
            writable: true,
        });
        if (items.length > 0) {
            this.push(...items);
        }
        return proxy;
    }
    /**
     * Decoder-side factory. Skips the `ChangeTree` allocation and
     * replicates the class-field initializers by hand (since `Object.create`
     * bypasses them). Must stay in sync with the class-field declarations
     * and the constructor body above.
     *
     * Pass the Proxy to `installUntrackedChangeTree` as the public identity
     * so children set their parent to the Proxy, not the raw target.
     */
    static initializeForDecoder() {
        const self = Object.create(ArraySchema.prototype);
        self.items = [];
        // `tmpItems` / `deletedIndexes` are encoder-only (consulted by the
        // staged-snapshot path in `$getByIndex`, `$onEncodeEnd`, etc.). The
        // decoder reads from `items` directly and never maintains them.
        self.isMovingItems = false;
        self._needsCompaction = false;
        self[$childType] = undefined;
        self[$proxyTarget] = self;
        const proxy = new Proxy(self, ARRAY_PROXY_HANDLER);
        installUntrackedChangeTree(self, proxy);
        return proxy;
    }
    set length(newLength) {
        if (newLength === 0) {
            this.clear();
        }
        else if (newLength < this.items.length) {
            this.splice(newLength, this.length - newLength);
        }
        else {
            console.warn("ArraySchema: can't set .length to a higher value than its length.");
        }
    }
    get length() {
        return this.items.length;
    }
    // ────── Change tracking control (same API as Schema) ──────
    pauseTracking() { this[$changes].pause(); }
    resumeTracking() { this[$changes].resume(); }
    untracked(fn) { return this[$changes].untracked(fn); }
    get isTrackingPaused() { return this[$changes].paused; }
    push(...values) {
        // `this` is the Proxy when called from user code. Grab the underlying
        // instance once so the body's field reads (items, tmpItems, $changes,
        // $childType) skip the Proxy.get trap on every iteration.
        const self = this[$proxyTarget];
        const items = self.items;
        const tmpItems = self.tmpItems;
        const changeTree = self[$changes];
        const childType = self[$childType];
        let length = tmpItems.length;
        for (let i = 0, l = values.length; i < l; i++, length++) {
            const value = values[i];
            if (value === undefined || value === null) {
                // skip null values
                return;
            }
            else if (typeof (value) === "object" && childType) {
                assertInstanceType(value, childType, self, i);
                // TODO: move value[$changes]?.setParent() to this block.
            }
            changeTree.indexedOperation(length, OPERATION.ADD);
            items.push(value);
            tmpItems.push(value);
            //
            // set value's parent after the value is set
            // (to avoid encoding "refId" operations before parent's "ADD" operation)
            // Pass `this` (the Proxy) as parent — the Proxy is the public
            // identity of the array; ChangeTree.parentRef compares by identity.
            //
            value[$changes]?.setParent(this, changeTree.root, length);
        }
        return length;
    }
    /**
     * Removes the last element from an array and returns it.
     */
    pop() {
        // Unwrap Proxy once — see push() for rationale.
        const self = this[$proxyTarget];
        const tmpItems = self.tmpItems;
        const deletedIndexes = self.deletedIndexes;
        let index = -1;
        // find last non-undefined index
        for (let i = tmpItems.length - 1; i >= 0; i--) {
            if (deletedIndexes[i] !== true) {
                index = i;
                break;
            }
        }
        if (index < 0) {
            return undefined;
        }
        self[$changes].delete(index);
        deletedIndexes[index] = true;
        return self.items.pop();
    }
    at(index) {
        // Allow negative indexing from the end
        if (index < 0)
            index += this.length;
        return this.items[index];
    }
    // encoding only
    $changeAt(index, value) {
        if (value === undefined || value === null) {
            console.error("ArraySchema items cannot be null nor undefined; Use `deleteAt(index)` instead.");
            return;
        }
        // skip if the value is the same as cached.
        if (this.items[index] === value) {
            return;
        }
        const operation = (this.items[index] !== undefined)
            ? typeof (value) === "object"
                ? OPERATION.DELETE_AND_ADD // schema child
                : OPERATION.REPLACE // primitive
            : OPERATION.ADD;
        const changeTree = this[$changes];
        changeTree.change(index, operation);
        //
        // set value's parent after the value is set
        // (to avoid encoding "refId" operations before parent's "ADD" operation)
        //
        value[$changes]?.setParent(this, changeTree.root, index);
    }
    // encoding only
    $deleteAt(index, operation) {
        this[$changes].delete(index, operation);
    }
    // decoding only
    $setAt(index, value, operation) {
        if (index === 0 &&
            operation === OPERATION.ADD &&
            this.items[index] !== undefined) {
            // handle decoding unshift
            this.items.unshift(value);
        }
        else if (operation === OPERATION.DELETE_AND_MOVE) {
            this.items.splice(index, 1);
            this.items[index] = value;
        }
        else {
            if (index > this.items.length) {
                this._needsCompaction = true; // gap-write (filtered/out-of-order ADD) leaves holes
            }
            this.items[index] = value;
        }
    }
    clear() {
        const self = this[$proxyTarget];
        // skip if already clear
        if (self.items.length === 0) {
            return;
        }
        // discard previous operations.
        const changeTree = self[$changes];
        // remove children references
        changeTree.forEachChild((childChangeTree, _) => {
            changeTree.root?.remove(childChangeTree);
        });
        changeTree.discard();
        changeTree.operation(OPERATION.CLEAR);
        self.items.length = 0;
        self.tmpItems.length = 0;
    }
    /**
     * Pool reset: empty this array and recycle its ChangeTree WITHOUT recording
     * any wire op (the parent field's ADD/DELETE owns the wire). Recurses into
     * ref-type children. Called by Schema.reset when a pooled entity has an
     * array field. The instance must already be detached from the encoder.
     */
    [$reset]() {
        const self = this[$proxyTarget] ?? this;
        const changeTree = self[$changes];
        if (changeTree.isStreamCollection) {
            throw new Error(`@colyseus/schema: cannot reset a streamed ArraySchema (pooling not supported).`);
        }
        const items = self.items;
        for (let i = 0; i < items.length; i++)
            items[i]?.[$reset]?.();
        self.items.length = 0;
        self.tmpItems.length = 0;
        self.deletedIndexes.length = 0;
        changeTree.recycle();
        self[$refId] = undefined; // assign (not delete) to avoid V8 dictionary-mode deopt
    }
    /**
     * Combines two or more arrays.
     * @param items Additional items to add to the end of array1.
     */
    // @ts-ignore
    concat(...items) {
        return new ArraySchema(...this.items.concat(...items));
    }
    /**
     * Adds all the elements of an array separated by the specified separator string.
     * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
     */
    join(separator) {
        return this.items.join(separator);
    }
    /**
     * Reverses the elements in an Array.
     */
    // @ts-ignore
    reverse() {
        const self = this[$proxyTarget];
        self[$changes].operation(OPERATION.REVERSE);
        self.items.reverse();
        self.tmpItems.reverse();
        return this;
    }
    /**
     * Removes the first element from an array and returns it.
     */
    shift() {
        const self = this[$proxyTarget];
        const items = self.items;
        if (items.length === 0) {
            return undefined;
        }
        const changeTree = self[$changes];
        const first = items[0];
        const index = self.tmpItems.findIndex(item => item === first);
        changeTree.delete(index, OPERATION.DELETE);
        self.deletedIndexes[index] = true;
        return items.shift();
    }
    /**
     * Returns a section of an array.
     * @param start The beginning of the specified portion of the array.
     * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
     */
    slice(start, end) {
        const sliced = new ArraySchema();
        sliced.push(...this.items.slice(start, end));
        return sliced;
    }
    /**
     * Sorts an array.
     * @param compareFn Function used to determine the order of the elements. It is expected to return
     * a negative value if first argument is less than second argument, zero if they're equal and a positive
     * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
     * ```ts
     * [11,2,22,1].sort((a, b) => a - b)
     * ```
     */
    sort(compareFn = DEFAULT_SORT) {
        const self = this[$proxyTarget];
        self.isMovingItems = true;
        const changeTree = self[$changes];
        const sortedItems = self.items.sort(compareFn);
        // wouldn't OPERATION.MOVE make more sense here?
        sortedItems.forEach((_, i) => changeTree.change(i, OPERATION.REPLACE));
        self.tmpItems.sort(compareFn);
        self.isMovingItems = false;
        return this;
    }
    /**
     * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
     * @param start The zero-based location in the array from which to start removing elements.
     * @param deleteCount The number of elements to remove.
     * @param insertItems Elements to insert into the array in place of the deleted elements.
     */
    splice(start, deleteCount, ...insertItems) {
        const self = this[$proxyTarget];
        const changeTree = self[$changes];
        const items = self.items;
        const tmpItems = self.tmpItems;
        const deletedIndexes = self.deletedIndexes;
        const itemsLength = items.length;
        const tmpItemsLength = tmpItems.length;
        const insertCount = insertItems.length;
        // build up-to-date list of indexes, excluding removed values.
        const indexes = [];
        for (let i = 0; i < tmpItemsLength; i++) {
            if (deletedIndexes[i] !== true) {
                indexes.push(i);
            }
        }
        if (itemsLength > start) {
            // if deleteCount is not provided, delete all items from start to end
            if (deleteCount === undefined) {
                deleteCount = itemsLength - start;
            }
            //
            // delete operations at correct index
            //
            for (let i = start; i < start + deleteCount; i++) {
                const index = indexes[i];
                changeTree.delete(index, OPERATION.DELETE);
                deletedIndexes[index] = true;
            }
        }
        else {
            // not enough items to delete
            deleteCount = 0;
        }
        // insert operations
        if (insertCount > 0) {
            if (insertCount > deleteCount) {
                console.error("Inserting more elements than deleting during ArraySchema#splice()");
                throw new Error("ArraySchema#splice(): insertCount must be equal or lower than deleteCount.");
            }
            for (let i = 0; i < insertCount; i++) {
                const addIndex = (indexes[start] ?? itemsLength) + i;
                changeTree.indexedOperation(addIndex, (deletedIndexes[addIndex])
                    ? OPERATION.DELETE_AND_ADD
                    : OPERATION.ADD);
                // set value's parent/root — use `this` (Proxy) as parent.
                insertItems[i][$changes]?.setParent(this, changeTree.root, addIndex);
            }
        }
        changeTree.root?.enqueueChangeTree(changeTree);
        return items.splice(start, deleteCount, ...insertItems);
    }
    /**
     * Inserts new elements at the start of an array.
     * @param items  Elements to insert at the start of the Array.
     */
    unshift(...items) {
        const self = this[$proxyTarget];
        const changeTree = self[$changes];
        // Existing items shift up — `shiftChangeIndexes` handles their
        // relocation bookkeeping. The prepended `items` are genuinely new
        // (no prior existence to MOVE), so each records an ADD.
        changeTree.shiftChangeIndexes(items.length);
        items.forEach((_, index) => {
            changeTree.change(index, OPERATION.ADD);
        });
        self.tmpItems.unshift(...items);
        return self.items.unshift(...items);
    }
    /**
     * Returns the index of the first occurrence of a value in an array.
     * @param searchElement The value to locate in the array.
     * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
     */
    indexOf(searchElement, fromIndex) {
        return this.items.indexOf(searchElement, fromIndex);
    }
    /**
     * Returns the index of the last occurrence of a specified value in an array.
     * @param searchElement The value to locate in the array.
     * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
     */
    lastIndexOf(searchElement, fromIndex = this.length - 1) {
        return this.items.lastIndexOf(searchElement, fromIndex);
    }
    every(callbackfn, thisArg) {
        return this.items.every(callbackfn, thisArg);
    }
    /**
     * Determines whether the specified callback function returns true for any element of an array.
     * @param callbackfn A function that accepts up to three arguments. The some method calls
     * the callbackfn function for each element in the array until the callbackfn returns a value
     * which is coercible to the Boolean value true, or until the end of the array.
     * @param thisArg An object to which the this keyword can refer in the callbackfn function.
     * If thisArg is omitted, undefined is used as the this value.
     */
    some(callbackfn, thisArg) {
        return this.items.some(callbackfn, thisArg);
    }
    /**
     * Performs the specified action for each element in an array.
     * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
     * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
     */
    forEach(callbackfn, thisArg) {
        return this.items.forEach(callbackfn, thisArg);
    }
    /**
     * Calls a defined callback function on each element of an array, and returns an array that contains the results.
     * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
     * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
     */
    map(callbackfn, thisArg) {
        return this.items.map(callbackfn, thisArg);
    }
    filter(callbackfn, thisArg) {
        return this.items.filter(callbackfn, thisArg);
    }
    /**
     * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
     * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
     * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
     */
    reduce(callbackfn, initialValue) {
        return this.items.reduce(callbackfn, initialValue);
    }
    /**
     * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
     * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
     * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
     */
    reduceRight(callbackfn, initialValue) {
        return this.items.reduceRight(callbackfn, initialValue);
    }
    /**
     * Returns the value of the first element in the array where predicate is true, and undefined
     * otherwise.
     * @param predicate find calls predicate once for each element of the array, in ascending
     * order, until it finds one where predicate returns true. If such an element is found, find
     * immediately returns that element value. Otherwise, find returns undefined.
     * @param thisArg If provided, it will be used as the this value for each invocation of
     * predicate. If it is not provided, undefined is used instead.
     */
    find(predicate, thisArg) {
        return this.items.find(predicate, thisArg);
    }
    /**
     * Returns the index of the first element in the array where predicate is true, and -1
     * otherwise.
     * @param predicate find calls predicate once for each element of the array, in ascending
     * order, until it finds one where predicate returns true. If such an element is found,
     * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
     * @param thisArg If provided, it will be used as the this value for each invocation of
     * predicate. If it is not provided, undefined is used instead.
     */
    findIndex(predicate, thisArg) {
        return this.items.findIndex(predicate, thisArg);
    }
    /**
     * Returns the this object after filling the section identified by start and end with value
     * @param value value to fill array section with
     * @param start index to start filling the array at. If start is negative, it is treated as
     * length+start where length is the length of the array.
     * @param end index to stop filling the array at. If end is negative, it is treated as
     * length+end.
     */
    fill(value, start, end) {
        throw new Error("ArraySchema#fill() not implemented");
    }
    /**
     * Returns the this object after copying a section of the array identified by start and end
     * to the same array starting at position target
     * @param target If target is negative, it is treated as length+target where length is the
     * length of the array.
     * @param start If start is negative, it is treated as length+start. If end is negative, it
     * is treated as length+end.
     * @param end If not specified, length of the this object is used as its default value.
     */
    copyWithin(target, start, end) {
        throw new Error("ArraySchema#copyWithin() not implemented");
    }
    /**
     * Returns a string representation of an array.
     */
    toString() {
        return this.items.toString();
    }
    /**
     * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
     */
    toLocaleString() {
        return this.items.toLocaleString();
    }
    ;
    /** Iterator */
    [Symbol.iterator]() {
        return this.items[Symbol.iterator]();
    }
    static get [Symbol.species]() {
        return ArraySchema;
    }
    // WORKAROUND for compatibility
    // - TypeScript 4 defines @@unscopables as a function
    // - TypeScript 5 defines @@unscopables as an object
    [Symbol.unscopables];
    /**
     * Returns an iterable of key, value pairs for every entry in the array
     */
    entries() { return this.items.entries(); }
    /**
     * Returns an iterable of keys in the array
     */
    keys() { return this.items.keys(); }
    /**
     * Returns an iterable of values in the array
     */
    values() { return this.items.values(); }
    /**
     * Determines whether an array includes a certain element, returning true or false as appropriate.
     * @param searchElement The element to search for.
     * @param fromIndex The position in this array at which to begin searching for searchElement.
     */
    includes(searchElement, fromIndex) {
        return this.items.includes(searchElement, fromIndex);
    }
    //
    // ES2022
    //
    /**
     * Calls a defined callback function on each element of an array. Then, flattens the result into
     * a new array.
     * This is identical to a map followed by flat with depth 1.
     *
     * @param callback A function that accepts up to three arguments. The flatMap method calls the
     * callback function one time for each element in the array.
     * @param thisArg An object to which the this keyword can refer in the callback function. If
     * thisArg is omitted, undefined is used as the this value.
     */
    // @ts-ignore
    flatMap(callback, thisArg) {
        // @ts-ignore
        throw new Error("ArraySchema#flatMap() is not supported.");
    }
    /**
     * Returns a new array with all sub-array elements concatenated into it recursively up to the
     * specified depth.
     *
     * @param depth The maximum recursion depth
     */
    // @ts-ignore
    flat(depth) {
        throw new Error("ArraySchema#flat() is not supported.");
    }
    findLast() {
        // @ts-ignore
        return this.items.findLast.apply(this.items, arguments);
    }
    findLastIndex(...args) {
        // @ts-ignore
        return this.items.findLastIndex.apply(this.items, arguments);
    }
    //
    // ES2023
    //
    with(index, value) {
        const copy = this.items.slice();
        // Allow negative indexing from the end
        if (index < 0)
            index += this.length;
        copy[index] = value;
        return new ArraySchema(...copy);
    }
    toReversed() {
        return this.items.slice().reverse();
    }
    toSorted(compareFn) {
        return this.items.slice().sort(compareFn);
    }
    // @ts-ignore
    toSpliced(start, deleteCount, ...items) {
        // @ts-ignore
        return this.items.toSpliced.apply(copy, arguments);
    }
    shuffle() {
        return this.move((_) => {
            let currentIndex = this.items.length;
            while (currentIndex != 0) {
                let randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;
                [this[currentIndex], this[randomIndex]] = [this[randomIndex], this[currentIndex]];
            }
        });
    }
    /**
     * Allows to move items around in the array.
     *
     * Example:
     *     state.cards.move((cards) => {
     *         [cards[4], cards[3]] = [cards[3], cards[4]];
     *         [cards[3], cards[2]] = [cards[2], cards[3]];
     *         [cards[2], cards[0]] = [cards[0], cards[2]];
     *         [cards[1], cards[1]] = [cards[1], cards[1]];
     *         [cards[0], cards[0]] = [cards[0], cards[0]];
     *     })
     *
     * @param cb
     * @returns
     */
    move(cb) {
        this.isMovingItems = true;
        cb(this);
        this.isMovingItems = false;
        return this;
    }
    /**
     * Encoder-only. Reads the staged-snapshot (`tmpItems`) so the encoder can
     * resolve a wire-index even after the user has mutated `items` mid-tick.
     * The decoder reads `items[index]` directly — see `decodeArray` and
     * `$deleteByIndex` below.
     */
    [$getByIndex](index, isEncodeAll = false) {
        const self = this[$proxyTarget] ?? this; // called via Proxy — one trap here beats one per field read
        return (isEncodeAll)
            ? self.items[index]
            : self.deletedIndexes[index]
                ? self.items[index]
                : self.tmpItems[index] || self.items[index];
    }
    [$deleteByIndex](index) {
        const self = this[$proxyTarget] ?? this;
        self.items[index] = undefined;
        self._needsCompaction = true;
    }
    [$onEncodeEnd]() {
        const self = this[$proxyTarget] ?? this;
        self.tmpItems = self.items.slice();
        self.deletedIndexes.length = 0;
    }
    [$onDecodeEnd]() {
        const self = this[$proxyTarget] ?? this;
        if (self._needsCompaction) {
            self._needsCompaction = false;
            self.items = self.items.filter((item) => item !== undefined);
        }
    }
    [$resyncPrune](visited, prune, keep) {
        // `items` is hole-free here: the decode loop's $onDecodeEnd already
        // ran, and a full-sync emits dense ADDs (no DELETEs, no gap-writes)
        // so no compaction happened mid-decode. Visited indexes may still be
        // sparse (ADD_BY_REFID resolves to the current client-side index).
        const self = this[$proxyTarget] ?? this;
        const items = self.items;
        let removed = false;
        for (let i = 0; i < items.length; i++) {
            const value = items[i];
            if (visited.has(i)) {
                keep(value);
                continue;
            }
            removed = true;
            prune(value, i);
            self[$deleteByIndex](i);
        }
        if (removed) {
            self[$onDecodeEnd]();
        } // compact the holes
    }
    toArray() {
        return this.items.slice(0);
    }
    toJSON() {
        return this.toArray().map((value) => {
            return (typeof (value['toJSON']) === "function")
                ? value['toJSON']()
                : value;
        });
    }
    //
    // Decoding utilities
    //
    clone(isDecoding) {
        let cloned;
        if (isDecoding) {
            cloned = new ArraySchema();
            cloned.push(...this.items);
        }
        else {
            cloned = new ArraySchema(...this.map(item => ((item[$changes])
                ? item.clone()
                : item)));
        }
        return cloned;
    }
    ;
}
registerType("array", { constructor: ArraySchema });

/**
 * MapJournal — owns the change-tracking and wire-protocol identity for a MapSchema.
 *
 * Replaces three parallel structures that previously lived on MapSchema:
 *   - `$indexes: Map<number, K>`        →  `keyByIndex`
 *   - `_collectionIndexes: { [key]: number }` (+ counter)  →  `indexByKey` + `nextIndex`
 *   - `deletedItems: { [index]: V }`    →  `snapshots`
 *
 * The journal is the single source of truth for:
 *   - assigning wire-protocol indexes to keys (server side)
 *   - looking up keys from wire indexes (server + client)
 *   - holding snapshots of removed values (for view-filter visibility checks)
 *
 * The journal does NOT track per-index operation types or maintain enqueue
 * order — those remain on `ChangeTree` for now. A future iteration may pull
 * them in too, but this version is intentionally scoped to the data-model
 * cleanup so we can validate the abstraction before going deeper.
 */
class MapJournal {
    /** index → key (was MapSchema.$indexes). Used by encoder and decoder. */
    keyByIndex = new Map();
    /**
     * key → index (was MapSchema._collectionIndexes — forward direction).
     * Server-only. Plain object so MapSchema can expose it via a getter
     * for backwards-compatible `_collectionIndexes?.[key]` access from
     * ChangeTree.forEachChild and similar polymorphic call sites.
     */
    indexByKey = {};
    /** Monotonic counter for assigning new indexes. Server-only. */
    nextIndex = 0;
    /**
     * Snapshot of values at the moment they were deleted. Lazy — only
     * allocated on first delete, since most maps are pure-grow and never
     * touch this. Used by `MapSchema[$filter]` to check view visibility
     * of a value that's already been removed from `$items` but whose
     * DELETE op is still in the encode queue.
     */
    snapshots;
    // ──────────────────────────────────────────────────────────────────
    // Server-side: recording mutations
    // ──────────────────────────────────────────────────────────────────
    /** Get the index assigned to a key, or undefined if never assigned. */
    indexOf(key) {
        const idx = this.indexByKey[key];
        return idx === undefined ? undefined : idx;
    }
    /** Assign and return a new wire index for an unseen key. */
    assign(key) {
        const index = this.nextIndex++;
        this.indexByKey[key] = index;
        this.keyByIndex.set(index, key);
        return index;
    }
    /** Stash a value at the moment it's deleted (for filter visibility checks). */
    snapshot(index, value) {
        (this.snapshots ??= new Map()).set(index, value);
    }
    /** Discard a snapshot — called when a deleted slot is being re-set. */
    forgetSnapshot(index) {
        this.snapshots?.delete(index);
    }
    /** Look up a snapshot. Returns undefined if no DELETE is pending for this index. */
    snapshotAt(index) {
        return this.snapshots?.get(index);
    }
    // ──────────────────────────────────────────────────────────────────
    // Client-side (decoder): index↔key sync from the wire
    // ──────────────────────────────────────────────────────────────────
    /** Decoder calls this when it sees an ADD/DELETE_AND_ADD on the wire. */
    setIndex(index, key) {
        this.keyByIndex.set(index, key);
        // Forward direction maintained for symmetry, even though decoder
        // rarely needs it. Cheap insert; keeps invariants aligned.
        this.indexByKey[key] = index;
    }
    // ──────────────────────────────────────────────────────────────────
    // Lookups (both sides)
    // ──────────────────────────────────────────────────────────────────
    /** Reverse lookup: wire index → key. */
    keyOf(index) {
        return this.keyByIndex.get(index);
    }
    // ──────────────────────────────────────────────────────────────────
    // Lifecycle
    // ──────────────────────────────────────────────────────────────────
    /**
     * Called from MapSchema's $onEncodeEnd hook.
     * Cleans up index/key mappings for entries that were deleted in this tick.
     */
    cleanupAfterEncode() {
        if (this.snapshots === undefined)
            return;
        for (const [index] of this.snapshots) {
            const key = this.keyByIndex.get(index);
            if (key !== undefined) {
                delete this.indexByKey[key];
                this.keyByIndex.delete(index);
            }
        }
        this.snapshots.clear();
    }
    /** Reset everything (called on .clear()). */
    reset() {
        this.indexByKey = {};
        this.keyByIndex.clear();
        this.snapshots?.clear();
        this.nextIndex = 0;
    }
}

class MapSchema {
    [$changes];
    [$refId];
    childType;
    [$childType];
    $items = new Map();
    /**
     * Wire-protocol identity + change-tracking metadata for this map.
     *
     * Owns: index↔key mapping, monotonic index counter, snapshots of removed
     * values for filter visibility checks. Replaces what used to live as three
     * separate fields on this class ($indexes, _collectionIndexes, deletedItems).
     */
    journal = new MapJournal();
    /**
     * Streamable state — lazily allocated by `inheritedFlags` (or the
     * `maxPerTick` setter) when streaming actually activates. `undefined`
     * on every non-streaming MapSchema so the common case pays zero
     * Map/Set allocation. Single slot → hidden-class shape stays stable
     * across streaming and non-streaming instances.
     */
    _stream;
    /** Max ADD ops emitted per tick per view. Ignored outside streaming mode. */
    get maxPerTick() {
        return this._stream?.maxPerTick ?? 32;
    }
    set maxPerTick(n) {
        (this._stream ??= createStreamableState()).maxPerTick = n;
    }
    /**
     * Per-view priority callback for `.stream()` maps. Initialized from the
     * schema declaration (`t.map(X).stream().priority(fn)` or `@type({ map,
     * priority })`); assigning here overrides for this instance. Only fires
     * during `encodeView` — broadcast mode drains FIFO.
     */
    get priority() {
        return this._stream?.priority;
    }
    set priority(fn) {
        (this._stream ??= createStreamableState()).priority = fn;
    }
    /** Backwards-compat alias for `journal.keyByIndex`. */
    get $indexes() { return this.journal.keyByIndex; }
    /**
     * Backwards-compat alias for `journal.indexByKey`. Plain object so
     * polymorphic call sites like `ref._collectionIndexes?.[key]` keep working.
     */
    get _collectionIndexes() { return this.journal.indexByKey; }
    static [$encoder] = encodeMapEntry;
    static [$decoder] = decodeKeyValueOperation;
    /** Integer tag read by `decodeKeyValueOperation` — see `CollectionKind`. */
    static COLLECTION_KIND = CollectionKind.Map;
    /**
     * Determine if a property must be filtered.
     * - If returns false, the property is NOT going to be encoded.
     * - If returns true, the property is going to be encoded.
     *
     * Encoding with "filters" happens in two steps:
     * - First, the encoder iterates over all "not owned" properties and encodes them.
     * - Then, the encoder iterates over all "owned" properties per instance and encodes them.
     */
    static [$filter](ref, index, view) {
        if (!view || typeof (ref[$childType]) === "string")
            return true;
        const value = ref[$getByIndex](index) ?? ref.journal.snapshotAt(index);
        return view.isChangeTreeVisible(value[$changes]);
    }
    static is(type) {
        return type['map'] !== undefined;
    }
    constructor(initialValues) {
        // $changes MUST be non-enumerable — see Schema.initialize comment.
        // ChangeTree has circular refs (root→changeTrees→…) and would send
        // `assert.deepStrictEqual` into exponential recursion.
        Object.defineProperty(this, $changes, {
            value: new ChangeTree(this),
            enumerable: false,
            writable: true,
        });
        this[$childType] = undefined;
        if (initialValues) {
            if (initialValues instanceof Map ||
                initialValues instanceof MapSchema) {
                initialValues.forEach((v, k) => this.set(k, v));
            }
            else {
                for (const k in initialValues) {
                    this.set(k, initialValues[k]);
                }
            }
        }
    }
    /**
     * Decoder-side factory. Skips the tracking `ChangeTree` allocation;
     * `Object.create` also bypasses the class-field initializers, so we
     * replicate the minimum slot init here. Must stay in sync with the
     * class-field declarations above and with the constructor body.
     */
    static initializeForDecoder() {
        const self = Object.create(MapSchema.prototype);
        self.$items = new Map();
        self.journal = new MapJournal();
        self[$childType] = undefined;
        installUntrackedChangeTree(self);
        return self;
    }
    /** Iterator */
    [Symbol.iterator]() { return this.$items[Symbol.iterator](); }
    get [Symbol.toStringTag]() { return this.$items[Symbol.toStringTag]; }
    static get [Symbol.species]() { return MapSchema; }
    set(key, value) {
        if (value === undefined || value === null) {
            throw new Error(`MapSchema#set('${key}', ${value}): trying to set ${value} value on '${key}'.`);
        }
        else if (typeof (value) === "object" && this[$childType]) {
            assertInstanceType(value, this[$childType], this, key);
        }
        // Force "key" as string
        // See: https://github.com/colyseus/colyseus/issues/561#issuecomment-1646733468
        key = key.toString();
        const changeTree = this[$changes];
        const isRef = (value[$changes]) !== undefined;
        const journal = this.journal;
        let index = journal.indexOf(key);
        let operation;
        if (index !== undefined) {
            // REPLACE branch
            operation = OPERATION.REPLACE;
            const previousValue = this.$items.get(key);
            if (previousValue === value) {
                // if value is the same, avoid re-encoding it.
                return;
            }
            else if (isRef) {
                // if is schema, force ADD operation if value differ from previous one.
                operation = OPERATION.DELETE_AND_ADD;
                // remove reference from previous value
                if (previousValue !== undefined) {
                    previousValue[$changes].root?.remove(previousValue[$changes]);
                }
            }
            // Re-setting after a delete: discard the snapshot.
            if (journal.snapshotAt(index) !== undefined) {
                journal.forgetSnapshot(index);
            }
        }
        else {
            // ADD branch
            index = journal.assign(key);
            operation = OPERATION.ADD;
        }
        this.$items.set(key, value);
        // Streaming-mode ADD: route the new entry into per-view or broadcast
        // pending instead of recording on the tree. The encoder's priority /
        // broadcast pass will drain up to `maxPerTick` per tick. REPLACE
        // and DELETE_AND_ADD fall through to the normal recorder path — the
        // old value is already being emitted, so the swap just mutates.
        if (operation === OPERATION.ADD && changeTree.isStreamCollection) {
            if (changeTree.root !== undefined) {
                streamRouteAdd(this, changeTree.root, index);
            }
        }
        else {
            changeTree.change(index, operation);
        }
        //
        // set value's parent after the value is set
        // (to avoid encoding "refId" operations before parent's "ADD" operation)
        //
        if (isRef) {
            value[$changes].setParent(this, changeTree.root, index);
        }
        return this;
    }
    get(key) {
        return this.$items.get(key);
    }
    delete(key) {
        if (!this.$items.has(key)) {
            return false;
        }
        const index = this.journal.indexOf(key);
        const previousValue = this.$items.get(key);
        const changeTree = this[$changes];
        // Streaming-mode: silent-drop if the entry never made it out to any
        // client (still in pending). Otherwise force DELETE on the channels
        // where it was already sent — bypasses the normal recorder so the
        // emission path stays symmetric with StreamSchema.
        if (changeTree.isStreamCollection) {
            const root = changeTree.root;
            let neverSent = false;
            if (root !== undefined) {
                neverSent = streamRouteRemove(this, root, this[$refId], index);
            }
            if (previousValue?.[$changes] !== undefined) {
                root?.remove(previousValue[$changes]);
            }
            this.$items.delete(key);
            // Only snapshot if we actually need a DELETE op (already-sent):
            // filter visibility checks look up the snapshot until the next
            // encode end. Never-sent entries can skip the snapshot work.
            if (!neverSent)
                this.journal.snapshot(index, previousValue);
            return true;
        }
        // Snapshot the deleted value (used by [$filter] for visibility checks
        // until $onEncodeEnd cleans it up).
        this.journal.snapshot(index, previousValue);
        changeTree.delete(index);
        return this.$items.delete(key);
    }
    clear() {
        const changeTree = this[$changes];
        // discard previous operations.
        changeTree.discard();
        // remove children references
        changeTree.forEachChild((childChangeTree, _) => {
            changeTree.root?.remove(childChangeTree);
        });
        // reset journal (clears all index/key state and snapshots)
        this.journal.reset();
        // clear items
        this.$items.clear();
        changeTree.operation(OPERATION.CLEAR);
    }
    /**
     * Pool reset: empty this map and recycle its ChangeTree WITHOUT recording
     * any wire op (the parent field's ADD/DELETE owns the wire). Recurses into
     * ref-type children. Called by Schema.reset when a pooled entity has a
     * map field. The instance must already be detached from the encoder.
     */
    [$reset]() {
        const changeTree = this[$changes];
        if (changeTree.isStreamCollection) {
            throw new Error(`@colyseus/schema: cannot reset a streamed MapSchema (pooling not supported).`);
        }
        // reset ref-type children first (primitives optional-chain away)
        this.$items.forEach((value) => value?.[$reset]?.());
        this.$items.clear();
        this.journal.reset();
        changeTree.recycle();
        this[$refId] = undefined; // assign (not delete) to avoid V8 dictionary-mode deopt
    }
    has(key) {
        return this.$items.has(key);
    }
    forEach(callbackfn) {
        this.$items.forEach(callbackfn);
    }
    entries() {
        return this.$items.entries();
    }
    keys() {
        return this.$items.keys();
    }
    values() {
        return this.$items.values();
    }
    get size() {
        return this.$items.size;
    }
    // ────── Change tracking control (same API as Schema) ──────
    pauseTracking() { this[$changes].pause(); }
    resumeTracking() { this[$changes].resume(); }
    untracked(fn) { return this[$changes].untracked(fn); }
    get isTrackingPaused() { return this[$changes].paused; }
    setIndex(index, key) {
        this.journal.setIndex(index, key);
    }
    getIndex(index) {
        return this.journal.keyOf(index);
    }
    [$getByIndex](index) {
        const key = this.journal.keyOf(index);
        return key !== undefined ? this.$items.get(key) : undefined;
    }
    [$deleteByIndex](index) {
        const key = this.journal.keyOf(index);
        if (key !== undefined) {
            this.$items.delete(key);
            this.journal.keyByIndex.delete(index);
        }
    }
    [$resyncPrune](visited, prune, keep) {
        // maps prune by string key, NOT wire index — the decoder-side
        // journal never evicts stale index→key mappings on re-indexing.
        let deletedKeys = null;
        this.$items.forEach((value, key) => {
            if (visited.has(key)) {
                keep(value);
                return;
            }
            (deletedKeys ??= new Set()).add(key);
            prune(value, key);
        });
        if (deletedKeys !== null) {
            deletedKeys.forEach((key) => {
                this.$items.delete(key);
                delete this.journal.indexByKey[key];
            });
            // drop index→key mappings of swept keys — including stale ones
            // left behind by re-indexing.
            const staleIndexes = [];
            this.journal.keyByIndex.forEach((key, index) => {
                if (deletedKeys.has(key)) {
                    staleIndexes.push(index);
                }
            });
            for (let i = 0; i < staleIndexes.length; i++) {
                this.journal.keyByIndex.delete(staleIndexes[i]);
            }
        }
    }
    [$onEncodeEnd]() {
        this.journal.cleanupAfterEncode();
    }
    // ─── Streamable interface (Encoder priority / broadcast pass) ──────
    _dropView(viewId) {
        streamDropView(this, viewId);
    }
    _unregister() {
        // no-op — `Root.unregisterStream` handles the Set removal.
    }
    toJSON() {
        const map = {};
        this.forEach((value, key) => {
            map[key] = (typeof (value['toJSON']) === "function")
                ? value['toJSON']()
                : value;
        });
        return map;
    }
    //
    // Decoding utilities
    //
    // @ts-ignore
    clone(isDecoding) {
        let cloned;
        if (isDecoding) {
            // client-side
            cloned = Object.assign(new MapSchema(), this);
        }
        else {
            // server-side
            cloned = new MapSchema();
            this.forEach((value, key) => {
                if (value[$changes]) {
                    cloned.set(key, value['clone']());
                }
                else {
                    cloned.set(key, value);
                }
            });
        }
        return cloned;
    }
}
registerType("map", { constructor: MapSchema });

class CollectionSchema {
    [$changes];
    [$refId];
    [$childType];
    /** The user-visible data, keyed directly by the wire-protocol index. */
    $items = new Map();
    /** Snapshots of values that were deleted this tick (for filter visibility). */
    deletedItems = {};
    /** Monotonic counter for assigning indexes to newly-added items. */
    $refId = 0;
    /**
     * Streamable state — lazily allocated when the field is opted into
     * streaming via `t.collection(X).stream()`. See MapSchema for the
     * same pattern / rationale.
     */
    _stream;
    get maxPerTick() {
        return this._stream?.maxPerTick ?? 32;
    }
    set maxPerTick(n) {
        (this._stream ??= createStreamableState()).maxPerTick = n;
    }
    get priority() {
        return this._stream?.priority;
    }
    set priority(fn) {
        (this._stream ??= createStreamableState()).priority = fn;
    }
    static [$encoder] = encodeIndexedEntry;
    static [$decoder] = decodeKeyValueOperation;
    /** Integer tag read by `decodeKeyValueOperation` — see `CollectionKind`. */
    static COLLECTION_KIND = CollectionKind.Collection;
    /**
     * Determine if a property must be filtered.
     * - If returns false, the property is NOT going to be encoded.
     * - If returns true, the property is going to be encoded.
     *
     * Encoding with "filters" happens in two steps:
     * - First, the encoder iterates over all "not owned" properties and encodes them.
     * - Then, the encoder iterates over all "owned" properties per instance and encodes them.
     */
    static [$filter](ref, index, view) {
        return (!view ||
            typeof (ref[$childType]) === "string" ||
            view.isChangeTreeVisible((ref[$getByIndex](index) ?? ref.deletedItems[index])[$changes]));
    }
    static is(type) {
        return type['collection'] !== undefined;
    }
    constructor(initialValues) {
        // $changes must be non-enumerable — see Schema.initialize.
        Object.defineProperty(this, $changes, {
            value: new ChangeTree(this),
            enumerable: false,
            writable: true,
        });
        this[$childType] = undefined;
        if (initialValues) {
            initialValues.forEach((v) => this.add(v));
        }
    }
    /**
     * Decoder-side factory. Skips the tracking `ChangeTree` allocation;
     * `Object.create` also bypasses the class-field initializers, so we
     * replicate the minimum slot init here. Must stay in sync with the
     * class-field declarations above.
     */
    static initializeForDecoder() {
        const self = Object.create(CollectionSchema.prototype);
        self.$items = new Map();
        self.deletedItems = {};
        self.$refId = 0;
        self[$childType] = undefined;
        installUntrackedChangeTree(self);
        return self;
    }
    add(value) {
        // assign the next wire-protocol index
        const index = this.$refId++;
        const changeTree = this[$changes];
        const isRef = (value[$changes]) !== undefined;
        if (isRef) {
            value[$changes].setParent(this, changeTree.root, index);
        }
        this.$items.set(index, value);
        if (changeTree.isStreamCollection) {
            if (changeTree.root !== undefined) {
                streamRouteAdd(this, changeTree.root, index);
            }
        }
        else {
            changeTree.change(index);
        }
        return index;
    }
    at(index) {
        const key = Array.from(this.$items.keys())[index];
        return this.$items.get(key);
    }
    entries() {
        return this.$items.entries();
    }
    delete(item) {
        const entries = this.$items.entries();
        let index;
        let entry;
        while (entry = entries.next()) {
            if (entry.done) {
                break;
            }
            if (item === entry.value[1]) {
                index = entry.value[0];
                break;
            }
        }
        if (index === undefined) {
            return false;
        }
        const changeTree = this[$changes];
        if (changeTree.isStreamCollection) {
            const root = changeTree.root;
            const previousValue = this.$items.get(index);
            if (root !== undefined) {
                streamRouteRemove(this, root, this[$refId], index);
            }
            if (previousValue?.[$changes] !== undefined) {
                root?.remove(previousValue[$changes]);
            }
            this.deletedItems[index] = previousValue;
            return this.$items.delete(index);
        }
        this.deletedItems[index] = changeTree.delete(index);
        return this.$items.delete(index);
    }
    clear() {
        const changeTree = this[$changes];
        // discard previous operations.
        changeTree.discard();
        // remove children references
        changeTree.forEachChild((childChangeTree, _) => {
            changeTree.root?.remove(childChangeTree);
        });
        // clear items
        this.$items.clear();
        changeTree.operation(OPERATION.CLEAR);
    }
    /**
     * Pool reset: empty this collection and recycle its ChangeTree WITHOUT
     * recording any wire op (the parent field's ADD/DELETE owns the wire).
     * Recurses into ref-type children. Called by Schema.reset when a pooled
     * entity has a collection field. Must already be detached from the encoder.
     */
    [$reset]() {
        const changeTree = this[$changes];
        if (changeTree.isStreamCollection) {
            throw new Error(`@colyseus/schema: cannot reset a streamed CollectionSchema (pooling not supported).`);
        }
        this.$items.forEach((value) => value?.[$reset]?.());
        this.$items.clear();
        this.deletedItems = {};
        this.$refId = 0; // reset the monotonic index counter (field, not the symbol)
        changeTree.recycle();
        this[$refId] = undefined; // drop encoder ref identity by assign (not delete: avoids dict-mode deopt)
    }
    has(value) {
        return Array.from(this.$items.values()).some((v) => v === value);
    }
    forEach(callbackfn) {
        this.$items.forEach((value, key, _) => callbackfn(value, key, this));
    }
    values() {
        return this.$items.values();
    }
    get size() {
        return this.$items.size;
    }
    // ────── Change tracking control (same API as Schema) ──────
    pauseTracking() { this[$changes].pause(); }
    resumeTracking() { this[$changes].resume(); }
    untracked(fn) { return this[$changes].untracked(fn); }
    get isTrackingPaused() { return this[$changes].paused; }
    /** Iterator */
    [Symbol.iterator]() {
        return this.$items.values();
    }
    // ────────────────────────────────────────────────────────────────────
    // Decoder-side index hooks. CollectionSchema's "key" IS the wire index,
    // so these are identity operations. Kept for protocol symmetry with
    // MapSchema (decoder calls them polymorphically).
    // ────────────────────────────────────────────────────────────────────
    setIndex(_index, _key) {
        // no-op: indexes are identity
    }
    getIndex(index) {
        return index;
    }
    [$getByIndex](index) {
        return this.$items.get(index);
    }
    [$deleteByIndex](index) {
        this.$items.delete(index);
    }
    [$resyncPrune](visited, prune, keep) {
        let toDelete = null;
        this.$items.forEach((value, index) => {
            if (visited.has(index)) {
                keep(value);
                return;
            }
            (toDelete ??= []).push(index);
            prune(value, index);
        });
        if (toDelete !== null) {
            for (let i = 0; i < toDelete.length; i++) {
                this[$deleteByIndex](toDelete[i]);
            }
        }
    }
    [$onEncodeEnd]() {
        for (const key in this.deletedItems) {
            delete this.deletedItems[key];
        }
    }
    // ─── Streamable interface (Encoder priority / broadcast pass) ──────
    _dropView(viewId) {
        streamDropView(this, viewId);
    }
    _unregister() {
        // no-op — `Root.unregisterStream` handles the Set removal.
    }
    toArray() {
        return Array.from(this.$items.values());
    }
    toJSON() {
        const values = [];
        this.forEach((value, key) => {
            values.push((typeof (value['toJSON']) === "function")
                ? value['toJSON']()
                : value);
        });
        return values;
    }
    //
    // Decoding utilities
    //
    clone(isDecoding) {
        let cloned;
        if (isDecoding) {
            // client-side
            cloned = Object.assign(new CollectionSchema(), this);
        }
        else {
            // server-side
            cloned = new CollectionSchema();
            this.forEach((value) => {
                if (value[$changes]) {
                    cloned.add(value['clone']());
                }
                else {
                    cloned.add(value);
                }
            });
        }
        return cloned;
    }
}
registerType("collection", { constructor: CollectionSchema, });

class SetSchema {
    [$changes];
    [$refId];
    [$childType];
    /** The user-visible data, keyed directly by the wire-protocol index. */
    $items = new Map();
    /** Snapshots of values that were deleted this tick (for filter visibility). */
    deletedItems = {};
    /** Monotonic counter for assigning indexes to newly-added items. */
    $refId = 0;
    /**
     * Streamable state — lazily allocated when the field is opted into
     * streaming via `t.set(X).stream()`. See MapSchema for the same
     * pattern / rationale.
     */
    _stream;
    /** Max ADD ops emitted per tick per view. Ignored outside streaming mode. */
    get maxPerTick() {
        return this._stream?.maxPerTick ?? 32;
    }
    set maxPerTick(n) {
        (this._stream ??= createStreamableState()).maxPerTick = n;
    }
    /** Per-view priority callback — see StreamSchema / MapSchema. */
    get priority() {
        return this._stream?.priority;
    }
    set priority(fn) {
        (this._stream ??= createStreamableState()).priority = fn;
    }
    static [$encoder] = encodeIndexedEntry;
    static [$decoder] = decodeKeyValueOperation;
    /** Integer tag read by `decodeKeyValueOperation` — see `CollectionKind`. */
    static COLLECTION_KIND = CollectionKind.Set;
    /**
     * Determine if a property must be filtered.
     * - If returns false, the property is NOT going to be encoded.
     * - If returns true, the property is going to be encoded.
     *
     * Encoding with "filters" happens in two steps:
     * - First, the encoder iterates over all "not owned" properties and encodes them.
     * - Then, the encoder iterates over all "owned" properties per instance and encodes them.
     */
    static [$filter](ref, index, view) {
        return (!view ||
            typeof (ref[$childType]) === "string" ||
            view.isVisible((ref[$getByIndex](index) ?? ref.deletedItems[index])[$changes]));
    }
    static is(type) {
        return type['set'] !== undefined;
    }
    constructor(initialValues) {
        // $changes must be non-enumerable to avoid deepStrictEqual recursing
        // into ChangeTree's circular refs.
        Object.defineProperty(this, $changes, {
            value: new ChangeTree(this),
            enumerable: false,
            writable: true,
        });
        this[$childType] = undefined;
        if (initialValues) {
            initialValues.forEach((v) => this.add(v));
        }
    }
    /**
     * Decoder-side factory. Skips the tracking `ChangeTree` allocation;
     * `Object.create` also bypasses the class-field initializers, so we
     * replicate the minimum slot init here. Must stay in sync with the
     * class-field declarations above.
     */
    static initializeForDecoder() {
        const self = Object.create(SetSchema.prototype);
        self.$items = new Map();
        self.deletedItems = {};
        self.$refId = 0;
        self[$childType] = undefined;
        installUntrackedChangeTree(self);
        return self;
    }
    add(value) {
        // immediatelly return false if value already added.
        if (this.has(value)) {
            return false;
        }
        // assign the next wire-protocol index
        const index = this.$refId++;
        const changeTree = this[$changes];
        if ((value[$changes]) !== undefined) {
            value[$changes].setParent(this, changeTree.root, index);
        }
        this.$items.set(index, value);
        // Streaming-mode ADD: route into per-view pending or broadcast
        // pending instead of the tree's recorder. See MapSchema.set for
        // the same branch / rationale.
        if (changeTree.isStreamCollection) {
            if (changeTree.root !== undefined) {
                streamRouteAdd(this, changeTree.root, index);
            }
        }
        else {
            changeTree.change(index, OPERATION.ADD);
        }
        return index;
    }
    entries() {
        return this.$items.entries();
    }
    delete(item) {
        const entries = this.$items.entries();
        let index;
        let entry;
        while (entry = entries.next()) {
            if (entry.done) {
                break;
            }
            if (item === entry.value[1]) {
                index = entry.value[0];
                break;
            }
        }
        if (index === undefined) {
            return false;
        }
        const changeTree = this[$changes];
        // Streaming-mode: route through stream's pending/sent bookkeeping
        // — silent drop if never sent to any view, force DELETE for views
        // that already received it. Mirror of MapSchema.delete's streaming
        // branch.
        if (changeTree.isStreamCollection) {
            const root = changeTree.root;
            const previousValue = this.$items.get(index);
            if (root !== undefined) {
                streamRouteRemove(this, root, this[$refId], index);
            }
            if (previousValue?.[$changes] !== undefined) {
                root?.remove(previousValue[$changes]);
            }
            this.deletedItems[index] = previousValue;
            return this.$items.delete(index);
        }
        this.deletedItems[index] = changeTree.delete(index);
        return this.$items.delete(index);
    }
    clear() {
        const changeTree = this[$changes];
        // discard previous operations.
        changeTree.discard();
        // clear items
        this.$items.clear();
        changeTree.operation(OPERATION.CLEAR);
    }
    /**
     * Pool reset: empty this set and recycle its ChangeTree WITHOUT recording
     * any wire op (the parent field's ADD/DELETE owns the wire). Recurses into
     * ref-type children. Called by Schema.reset when a pooled entity has a set
     * field. The instance must already be detached from the encoder.
     */
    [$reset]() {
        const changeTree = this[$changes];
        if (changeTree.isStreamCollection) {
            throw new Error(`@colyseus/schema: cannot reset a streamed SetSchema (pooling not supported).`);
        }
        this.$items.forEach((value) => value?.[$reset]?.());
        this.$items.clear();
        this.deletedItems = {};
        this.$refId = 0; // reset the monotonic index counter (field, not the symbol)
        changeTree.recycle();
        this[$refId] = undefined; // drop encoder ref identity by assign (not delete: avoids dict-mode deopt)
    }
    has(value) {
        const values = this.$items.values();
        let has = false;
        let entry;
        while (entry = values.next()) {
            if (entry.done) {
                break;
            }
            if (value === entry.value) {
                has = true;
                break;
            }
        }
        return has;
    }
    forEach(callbackfn) {
        this.$items.forEach((value, key, _) => callbackfn(value, key, this));
    }
    values() {
        return this.$items.values();
    }
    get size() {
        return this.$items.size;
    }
    // ────── Change tracking control (same API as Schema) ──────
    pauseTracking() { this[$changes].pause(); }
    resumeTracking() { this[$changes].resume(); }
    untracked(fn) { return this[$changes].untracked(fn); }
    get isTrackingPaused() { return this[$changes].paused; }
    /** Iterator */
    [Symbol.iterator]() {
        return this.$items.values();
    }
    // ────────────────────────────────────────────────────────────────────
    // Decoder-side index hooks. SetSchema's "key" IS the wire index, so
    // these are identity operations. Kept for protocol symmetry with
    // MapSchema (decoder calls them polymorphically).
    // ────────────────────────────────────────────────────────────────────
    setIndex(_index, _key) {
        // no-op: indexes are identity
    }
    getIndex(index) {
        return index;
    }
    [$getByIndex](index) {
        return this.$items.get(index);
    }
    [$deleteByIndex](index) {
        this.$items.delete(index);
    }
    [$resyncPrune](visited, prune, keep) {
        let toDelete = null;
        this.$items.forEach((value, index) => {
            if (visited.has(index)) {
                keep(value);
                return;
            }
            (toDelete ??= []).push(index);
            prune(value, index);
        });
        if (toDelete !== null) {
            for (let i = 0; i < toDelete.length; i++) {
                this[$deleteByIndex](toDelete[i]);
            }
        }
    }
    [$onEncodeEnd]() {
        for (const key in this.deletedItems) {
            delete this.deletedItems[key];
        }
    }
    // ─── Streamable interface (Encoder priority / broadcast pass) ──────
    _dropView(viewId) {
        streamDropView(this, viewId);
    }
    _unregister() {
        // no-op — `Root.unregisterStream` handles the Set removal.
    }
    toArray() {
        return Array.from(this.$items.values());
    }
    toJSON() {
        const values = [];
        this.forEach((value, key) => {
            values.push((typeof (value['toJSON']) === "function")
                ? value['toJSON']()
                : value);
        });
        return values;
    }
    //
    // Decoding utilities
    //
    clone(isDecoding) {
        let cloned;
        if (isDecoding) {
            // client-side
            cloned = Object.assign(new SetSchema(), this);
        }
        else {
            // server-side
            cloned = new SetSchema();
            this.forEach((value) => {
                if (value[$changes]) {
                    cloned.add(value['clone']());
                }
                else {
                    cloned.add(value);
                }
            });
        }
        return cloned;
    }
}
registerType("set", { constructor: SetSchema });

/**
 * `t.stream(Entity)` — priority-batched collection of Schema instances.
 *
 * Designed for ECS-style use cases where many entities spawn/despawn each
 * tick and the full set won't fit in one encode budget. Adds are queued
 * per-client and drained in priority order (callback on StateView) up to
 * `maxPerTick` per encode pass. Field mutations on already-sent elements
 * propagate through the normal reliable channel without consuming the
 * per-tick budget. Chain `.static()` on the field builder to suppress
 * post-add mutation tracking entirely.
 */
class StreamSchema {
    [$changes];
    [$refId];
    [$childType];
    /**
     * Wire-keyed storage: `position → element`. Position is a monotonic
     * counter assigned by `add()` — stable identity even when elements
     * are removed, so pending/sent view state can keep using the same
     * keys across ticks. Map (not Array) so `$items.keys()` / `.values()`
     * skip removed positions without a sparse-slot check.
     */
    $items = new Map();
    /** Monotonic position counter. Incremented on every `add()`. */
    $nextPosition = 0;
    /** Reverse lookup for O(1) `remove(el)`. */
    _itemIndex = new Map();
    /**
     * Streamable state — holds per-view and broadcast bookkeeping. Lazily
     * allocated when the stream is attached to a Root (or when the user
     * touches `maxPerTick`). `undefined` on detached streams so
     * construction is cheap.
     */
    _stream;
    /** Max element ADDs emitted per encode tick (per view, or broadcast). */
    get maxPerTick() {
        return this._stream?.maxPerTick ?? 32;
    }
    set maxPerTick(n) {
        (this._stream ??= createStreamableState()).maxPerTick = n;
    }
    /**
     * Per-view priority callback. Initialized from the schema declaration
     * (`.priority(fn)` or `@type({ stream, priority })`); assigning here
     * overrides the class-level default for this instance. Only fires
     * during `encodeView` — broadcast mode drains FIFO.
     */
    get priority() {
        return this._stream?.priority;
    }
    set priority(fn) {
        (this._stream ??= createStreamableState()).priority = fn;
    }
    /**
     * Brand used by Root / StateView to detect stream trees without
     * importing this class (avoids circular deps). The `isStreamCollection`
     * ChangeTree flag (set via `inheritedFlags`) is the preferred runtime
     * check — this brand is kept for back-compat.
     */
    static $isStream = true;
    static [$encoder] = encodeIndexedEntry;
    static [$decoder] = decodeKeyValueOperation;
    /** Integer tag read by `decodeKeyValueOperation` — see `CollectionKind`. */
    static COLLECTION_KIND = CollectionKind.Stream;
    /**
     * Element-level visibility. Identical to SetSchema's filter: stream
     * elements are always per-view, the filter just defers to the view's
     * per-tree visibility bitmap.
     */
    static [$filter](ref, index, view) {
        if (!view)
            return true;
        const value = ref[$getByIndex](index);
        if (value === undefined)
            return false;
        return view.isVisible(value[$changes]);
    }
    static is(type) {
        return type && type['stream'] !== undefined;
    }
    constructor() {
        Object.defineProperty(this, $changes, {
            value: new ChangeTree(this),
            enumerable: false,
            writable: true,
        });
        this[$childType] = undefined;
        // `isFiltered` / `isStreamCollection` are set via `inheritedFlags`
        // when this stream is attached to a parent field — no constructor-
        // time init needed (the stream tree is inert until assignment).
    }
    /**
     * Decoder-side factory. Skips the tracking `ChangeTree` allocation;
     * `Object.create` also bypasses the class-field initializers, so we
     * replicate the minimum slot init here. Must stay in sync with the
     * class-field declarations above.
     */
    static initializeForDecoder() {
        const self = Object.create(StreamSchema.prototype);
        self.$items = new Map();
        self.$nextPosition = 0;
        self._itemIndex = new Map();
        self[$childType] = undefined;
        installUntrackedChangeTree(self);
        return self;
    }
    /**
     * Append an element to the stream. Returns the assigned position,
     * or -1 if the element was already in the stream.
     */
    add(value) {
        if (this._itemIndex.has(value))
            return -1;
        const position = this.$nextPosition++;
        this.$items.set(position, value);
        this._itemIndex.set(value, position);
        const tree = this[$changes];
        const root = tree.root;
        // Attach element as a child — assigns $refId and wires the parent
        // chain so the element's own ChangeTree participates in encoding.
        if (value[$changes] !== undefined) {
            value[$changes].setParent(this, root, position);
        }
        if (root !== undefined)
            streamRouteAdd(this, root, position);
        return position;
    }
    /**
     * Remove an element by reference. If the element was pending (never sent
     * to a view), the pending entry is dropped silently. If already sent,
     * a DELETE op is forced on next `encodeView` for that view.
     */
    remove(value) {
        const position = this._itemIndex.get(value);
        if (position === undefined)
            return false;
        this._itemIndex.delete(value);
        this.$items.delete(position);
        const root = this[$changes].root;
        if (root !== undefined) {
            streamRouteRemove(this, root, this[$refId], position);
            if (value[$changes] !== undefined) {
                root.remove(value[$changes]);
            }
        }
        return true;
    }
    has(value) {
        return this._itemIndex.has(value);
    }
    /** Remove every element; queue DELETE wire ops for already-sent items. */
    clear() {
        const root = this[$changes].root;
        if (root !== undefined) {
            streamRouteClear(this, root, this[$refId]);
            for (const el of this.$items.values()) {
                if (el[$changes] !== undefined) {
                    root.remove(el[$changes]);
                }
            }
        }
        this.$items.clear();
        this._itemIndex.clear();
    }
    forEach(callback) {
        for (const [index, value] of this.$items)
            callback(value, index, this);
    }
    values() {
        return this.$items.values();
    }
    /**
     * Iterate `[position, value]` pairs in insertion order. Used by
     * `setParent` recursion when the stream is reassigned to a new parent.
     */
    entries() {
        return this.$items.entries();
    }
    [Symbol.iterator]() {
        return this.$items.values();
    }
    /** Live element count. */
    get size() {
        return this.$items.size;
    }
    /** Alias for `size`. */
    get length() {
        return this.$items.size;
    }
    // ────────────────────────────────────────────────────────────────────
    // Decoder / encoder plumbing — same shape as SetSchema so
    // {encode,decode}KeyValueOperation can route uniformly. StreamSchema
    // keys are identity (wire index === position), so `setIndex`/`getIndex`
    // are no-ops / identity like SetSchema.
    // ────────────────────────────────────────────────────────────────────
    setIndex(_index, _key) {
        // no-op: indexes are identity
    }
    getIndex(index) {
        return index;
    }
    [$getByIndex](index) {
        return this.$items.get(index);
    }
    [$deleteByIndex](index) {
        const value = this.$items.get(index);
        if (value !== undefined) {
            this._itemIndex.delete(value);
            this.$items.delete(index);
        }
    }
    [$resyncPrune]() {
        // Stream contents are delivered by the trickle/priority pass, NOT
        // by full-sync (encodeAll carries none of them) — a snapshot is not
        // authoritative for streams, so absence ≠ deleted. Never prune.
    }
    [$onEncodeEnd]() {
        // No per-tick cleanup: pending/sent state spans encode ticks by design.
    }
    toArray() {
        return Array.from(this.$items.values());
    }
    toJSON() {
        const out = [];
        this.forEach((v) => {
            out.push(typeof v?.toJSON === "function" ? v.toJSON() : v);
        });
        return out;
    }
    clone(isDecoding) {
        if (isDecoding) {
            const cloned = Object.assign(new StreamSchema(), this);
            return cloned;
        }
        const cloned = new StreamSchema();
        cloned.maxPerTick = this.maxPerTick;
        this.forEach((v) => {
            cloned.add(typeof v?.clone === "function" ? v.clone() : v);
        });
        return cloned;
    }
    // ─── Streamable interface (Encoder priority / broadcast pass) ──────
    _dropView(viewId) {
        streamDropView(this, viewId);
    }
    /** Called by Root.remove when the stream's refcount hits zero. */
    _unregister() {
        // no-op — `Root.unregisterStream` handles the Set removal.
    }
}
registerType("stream", { constructor: StreamSchema });

/**
 * Chainable field builder. Instances are produced by `t.*()` factories.
 *
 * Generics:
 *  - `T` is the runtime/JS type of the field (e.g. `number`, `string`,
 *    `ArraySchema<Item>`). `.optional()` widens it to `T | undefined`
 *    so the inferred instance/toJSON shapes reflect absence.
 *  - `HasDefault` is a compile-time flag that the field carries a
 *    construction-time default — either an explicit `.default(v)` or an
 *    auto-default from a collection factory (`t.array`, `t.map`, …) or a
 *    Schema ref whose `initialize` takes zero args.
 *  - `IsOptional` is a compile-time brand for `.optional()`. Both
 *    `HasDefault` and `IsOptional` make the field omittable in
 *    `BuilderInitProps<T>`. A separate brand (rather than reading
 *    `undefined extends V`) sidesteps a TypeScript quirk where
 *    class-generic-inferred `V` resolves `undefined extends V` as `true`
 *    even for non-undefined types.
 *
 * schema() reads the internal configuration via `toDefinition()` and wires
 * up metadata through the existing pipeline.
 */
class FieldBuilder {
    [$builder] = true;
    // Internal configuration. Declared `private` (soft-private): hidden from
    // editor autocomplete and from normal external `.field` access, but still
    // reachable at runtime via element access (e.g. `builder['_noSync']`) for
    // internal tooling/tests. Not meant to be mutated by end users.
    _type;
    _default = undefined;
    _hasDefault = false;
    _view = undefined;
    _owned = false;
    _unreliable = false;
    _transient = false;
    _deprecated = false;
    _deprecatedThrows = true;
    _static = false;
    _stream = false;
    _optional = false;
    _noSync = false;
    _streamPriority = undefined;
    constructor(type) {
        this._type = type;
    }
    /**
     * Provide a default value for this field.
     *
     * Pass a **factory function** `() => T` to build a FRESH value per instance
     * (invoked once per construction) instead of sharing a single default — the
     * clean way to default a ref to a plain custom class, or any field that must
     * not share a mutable default across instances:
     *
     * ```ts
     * acc: t.ref(GunAccuracy).noSync().default(() => new GunAccuracy()),
     * ```
     *
     * Schema fields are never function-typed, so a function is always treated as a
     * factory. A non-function value is shared (and cloned per instance if it is
     * clone-able, e.g. a Schema/collection).
     */
    default(value) {
        this._default = value;
        this._hasDefault = true;
        return this;
    }
    /** Tag this field with a view tag (DEFAULT_VIEW_TAG when called without arg). */
    view(tag) {
        // -1 is DEFAULT_VIEW_TAG; kept numeric here to avoid a circular import.
        this._view = tag ?? -1;
        return this;
    }
    /** Mark this field as owned (encoder-side ownership filtering). */
    owned() {
        this._owned = true;
        return this;
    }
    /**
     * Mark this field as unreliable — tick patches emit it on the unreliable
     * transport channel. Still persisted to full-sync snapshots unless also
     * tagged with `.transient()`.
     */
    unreliable() {
        this._unreliable = true;
        return this;
    }
    /**
     * Mark this field as transient — NOT persisted to full-sync snapshots
     * (`encodeAll` / `encodeAllView`). Late-joining clients see the field
     * only after its next mutation is emitted on a tick patch. Orthogonal
     * to `.unreliable()`.
     */
    transient() {
        this._transient = true;
        return this;
    }
    /**
     * Mark this field as static.
     * - Primitive / Schema fields: synchronized once, skips change tracking.
     * - Stream fields (`t.stream(X).static()`): child elements are frozen
     *   after add — post-add field mutations on elements become no-ops.
     */
    static() {
        this._static = true;
        return this;
    }
    /**
     * Mark this field as **local-only** — it is typed and initialized on the
     * instance (so `.default()` and the inferred instance type still apply),
     * but is never registered for synchronization: it never enters change
     * tracking, never goes over the wire, and decoders never receive it.
     *
     * Useful for server-side scratch state, per-peer UI state, or values you
     * want on the class for typing convenience without paying any sync cost.
     *
     * Mutually exclusive with the sync-only modifiers (`.view()`, `.owned()`,
     * `.unreliable()`, `.transient()`, `.static()`, `.stream()`) — combining
     * them throws at `schema()` time.
     *
     * ```ts
     * const Player = schema({
     *     hp: t.uint8().default(100),          // synchronized
     *     lastInputTick: t.number().noSync(),  // local-only
     * }, 'Player');
     * ```
     */
    noSync() {
        this._noSync = true;
        return this;
    }
    /**
     * Opt a collection field into priority-batched streaming delivery —
     * ADDs drain at most `maxPerTick` per tick per view (or per broadcast
     * tick without a view). Applies to `t.map(X)` / `t.set(X)` /
     * `t.collection(X)`. Redundant on `t.stream(X)` (the factory already
     * sets this flag).
     *
     * **Not supported on `t.array(X)`.** Array positional operations
     * (`splice`, `unshift`, `reverse`) shift every subsequent index —
     * holding some ADDs back for a later tick while indexes mutate
     * underneath would produce a decoder-side state that doesn't match
     * the server. Use `t.stream(X)` (stable monotonic positions) or
     * `t.map(X).stream()` (keys never shift) instead.
     */
    stream() {
        const t = this._type;
        if (t && typeof t === "object" && t.array !== undefined) {
            throw new Error(ARRAY_STREAM_NOT_SUPPORTED);
        }
        this._stream = true;
        return this;
    }
    /**
     * Attach a priority callback for per-view `encodeView` delivery. The
     * callback receives the client's StateView and the candidate element;
     * higher return values emit first. Does nothing in broadcast mode
     * (shared `encode()` drains FIFO). Only meaningful on stream fields.
     *
     * ```ts
     * t.stream(Enemy).priority((view, enemy) =>
     *     -dist2(view.anchor, enemy)
     * )
     * ```
     */
    priority(fn) {
        this._streamPriority = fn;
        return this;
    }
    /** Mark this field as deprecated. Pass `false` to silence the access error. */
    deprecated(throws = true) {
        this._deprecated = true;
        this._deprecatedThrows = throws;
        return this;
    }
    /**
     * Mark this field as optional — inferred instance type becomes
     * `T | undefined` and the property becomes omittable in initialization
     * props. Skips the auto-instantiation of collection / Schema-ref
     * defaults, so the field starts as `undefined` at runtime.
     */
    optional() {
        this._optional = true;
        return this;
    }
    /**
     * @internal — snapshot of the builder's configuration consumed by
     * `schema()`. `private` keeps it out of autocomplete; internal callers
     * reach it via element access (`builder['toDefinition']()`).
     */
    toDefinition() {
        return {
            type: this._type,
            default: this._default,
            hasDefault: this._hasDefault,
            view: this._view,
            owned: this._owned,
            unreliable: this._unreliable,
            transient: this._transient,
            deprecated: this._deprecated,
            deprecatedThrows: this._deprecatedThrows,
            static: this._static,
            stream: this._stream,
            optional: this._optional,
            noSync: this._noSync,
            streamPriority: this._streamPriority,
        };
    }
}
function isBuilder(value) {
    return value != null && value[$builder] === true;
}
function primitive(name) {
    return (() => new FieldBuilder(name));
}
function resolveChild(child) {
    if (isBuilder(child)) {
        // `_type` is private; element access bypasses the visibility check.
        return child['_type'];
    }
    return child;
}
const arrayFactory = ((child) => new FieldBuilder({ array: resolveChild(child) }));
const mapFactory = ((child) => new FieldBuilder({ map: resolveChild(child) }));
const setFactory = ((child) => new FieldBuilder({ set: resolveChild(child) }));
const collectionFactory = ((child) => new FieldBuilder({ collection: resolveChild(child) }));
const streamFactory = ((child) => {
    const b = new FieldBuilder({ stream: resolveChild(child) });
    b['_stream'] = true; // element access bypasses `private`
    return b;
});
const refFactory = ((ctor) => new FieldBuilder(ctor));
/**
 * A bounded float carried on the wire as a fixed-width unsigned integer. App code
 * reads/writes the FLOAT; the wire carries the quantized int and the field only
 * ever yields `dequant(q)`, so client predict and server sim read the same value
 * (no full-precision path to leak ⇒ no shot misprediction). See
 * {@link QuantizeOptions} for the precision/wire trade-offs.
 *
 *     yaw:      t.quantized({ min: 0, max: TWO_PI, mode: "wrap" }), // 16-bit
 *     pitch:    t.quantized({ min: -PITCH_LIMIT, max: PITCH_LIMIT }), // clamp (default)
 *     throttle: t.quantized({ min: 0, max: 1, bits: 8 }),           // 1 byte
 */
function quantizedFactory(opts) {
    return new FieldBuilder({ quantized: resolveQuantize(opts) });
}
const t = Object.freeze({
    // Primitives
    string: primitive("string"),
    number: primitive("number"),
    boolean: primitive("boolean"),
    int8: primitive("int8"),
    uint8: primitive("uint8"),
    int16: primitive("int16"),
    uint16: primitive("uint16"),
    int32: primitive("int32"),
    uint32: primitive("uint32"),
    int64: primitive("int64"),
    uint64: primitive("uint64"),
    float32: primitive("float32"),
    float64: primitive("float64"),
    bigint64: primitive("bigint64"),
    biguint64: primitive("biguint64"),
    /**
     * Reference to a Schema subtype — `t.array(Item)` usually reads better, but
     * this is available when a plain ref is needed.
     *
     * The target may also be a **non-Schema custom class**. A synced ref still
     * requires it to be encodable — a `Schema` subclass, or a class retrofitted
     * with `Metadata.setFields(...)` (both carry `[Symbol.metadata]`); a bare
     * custom class is rejected at `schema()` time. A `.noSync()` (local-only)
     * field accepts ANY zero-arg class and auto-instantiates one per parent.
     */
    ref: refFactory,
    array: arrayFactory,
    map: mapFactory,
    set: setFactory,
    collection: collectionFactory,
    stream: streamFactory,
    /**
     * A bounded float quantized to a fixed-width unsigned int on the wire — half
     * (or a quarter) the bytes of a `float32` at a precision you pick. The field
     * reads/writes the float and only ever yields `dequant(q)`. {@see QuantizeOptions}
     */
    quantized: quantizedFactory,
    /**
     * Sugar for a full-circle wrapping angle in radians:
     * `t.quantized({ min: 0, max: 2π, mode: "wrap", bits })` (default 16-bit,
     * ~0.0055°/step). Any input angle is range-reduced into `[0, 2π)`. Render note:
     * lerp interpolated remotes shortest-arc (`attach({ angle: true })`) — the
     * wrap fixes the WIRE seam, not interpolation (see {@link QuantizeOptions.mode}).
     */
    angle: (opts) => quantizedFactory({ min: 0, max: Math.PI * 2, mode: "wrap", bits: opts?.bits ?? 16 }),
});

const DEFAULT_VIEW_TAG = -1;
/**
 * Class decorator that registers a `@type`-style Schema class with the
 * TypeContext (required for reflection / cross-language codegen).
 *
 *     @entity
 *     class Player extends Schema { ... }
 */
function entity(constructor) {
    TypeContext.register(constructor);
    return constructor;
}
/**
 * [See documentation](https://docs.colyseus.io/state/schema/)
 *
 * Annotate a Schema property to be serializeable.
 * \@type()'d fields are automatically flagged as "dirty" for the next patch.
 *
 * @example Standard usage, with automatic change tracking.
 * ```
 * \@type("string") propertyName: string;
 * ```
 *
 * @example You can provide the "manual" option if you'd like to manually control your patches via .setDirty().
 * ```
 * \@type("string", { manual: true })
 * ```
 */
// export function type(type: DefinitionType, options?: TypeOptions) {
//     return function ({ get, set }, context: ClassAccessorDecoratorContext): ClassAccessorDecoratorResult<Schema, any> {
//         if (context.kind !== "accessor") {
//             throw new Error("@type() is only supported for class accessor properties");
//         }
//         const field = context.name.toString();
//         //
//         // detect index for this field, considering inheritance
//         //
//         const parent = Object.getPrototypeOf(context.metadata);
//         let fieldIndex: number = context.metadata[$numFields] // current structure already has fields defined
//             ?? (parent && parent[$numFields]) // parent structure has fields defined
//             ?? -1; // no fields defined
//         fieldIndex++;
//         if (
//             !parent && // the parent already initializes the `$changes` property
//             !Metadata.hasFields(context.metadata)
//         ) {
//             context.addInitializer(function (this: Ref) {
//                 Object.defineProperty(this, $changes, {
//                     value: new ChangeTree(this),
//                     enumerable: false,
//                     writable: true
//                 });
//             });
//         }
//         Metadata.addField(context.metadata, fieldIndex, field, type);
//         const isArray = ArraySchema.is(type);
//         const isMap = !isArray && MapSchema.is(type);
//         // if (options && options.manual) {
//         //     // do not declare getter/setter descriptor
//         //     definition.descriptors[field] = {
//         //         enumerable: true,
//         //         configurable: true,
//         //         writable: true,
//         //     };
//         //     return;
//         // }
//         return {
//             init(value) {
//                 // TODO: may need to convert ArraySchema/MapSchema here
//                 // do not flag change if value is undefined.
//                 if (value !== undefined) {
//                     this[$changes].change(fieldIndex);
//                     // automaticallty transform Array into ArraySchema
//                     if (isArray) {
//                         if (!(value instanceof ArraySchema)) {
//                             value = new ArraySchema(...value);
//                         }
//                         value[$childType] = Object.values(type)[0];
//                     }
//                     // automaticallty transform Map into MapSchema
//                     if (isMap) {
//                         if (!(value instanceof MapSchema)) {
//                             value = new MapSchema(value);
//                         }
//                         value[$childType] = Object.values(type)[0];
//                     }
//                     // try to turn provided structure into a Proxy
//                     if (value['$proxy'] === undefined) {
//                         if (isMap) {
//                             value = getMapProxy(value);
//                         }
//                     }
//                 }
//                 return value;
//             },
//             get() {
//                 return get.call(this);
//             },
//             set(value: any) {
//                 /**
//                  * Create Proxy for array or map items
//                  */
//                 // skip if value is the same as cached.
//                 if (value === get.call(this)) {
//                     return;
//                 }
//                 if (
//                     value !== undefined &&
//                     value !== null
//                 ) {
//                     // automaticallty transform Array into ArraySchema
//                     if (isArray) {
//                         if (!(value instanceof ArraySchema)) {
//                             value = new ArraySchema(...value);
//                         }
//                         value[$childType] = Object.values(type)[0];
//                     }
//                     // automaticallty transform Map into MapSchema
//                     if (isMap) {
//                         if (!(value instanceof MapSchema)) {
//                             value = new MapSchema(value);
//                         }
//                         value[$childType] = Object.values(type)[0];
//                     }
//                     // try to turn provided structure into a Proxy
//                     if (value['$proxy'] === undefined) {
//                         if (isMap) {
//                             value = getMapProxy(value);
//                         }
//                     }
//                     // flag the change for encoding.
//                     this[$changes].change(fieldIndex);
//                     //
//                     // call setParent() recursively for this and its child
//                     // structures.
//                     //
//                     if (value[$changes]) {
//                         value[$changes].setParent(
//                             this,
//                             this[$changes].root,
//                             Metadata.getIndex(context.metadata, field),
//                         );
//                     }
//                 } else if (get.call(this)) {
//                     //
//                     // Setting a field to `null` or `undefined` will delete it.
//                     //
//                     this[$changes].delete(field);
//                 }
//                 set.call(this, value);
//             },
//         };
//     }
// }
function view(tag = DEFAULT_VIEW_TAG) {
    return function (target, fieldName) {
        const metadata = Metadata.initialize(target.constructor);
        Metadata.setTag(metadata, fieldName, tag);
    };
}
function owned(target, field) {
    const metadata = Metadata.initialize(target.constructor);
    metadata[metadata[field]].owned = true;
}
function unreliable(target, field) {
    const metadata = Metadata.initialize(target.constructor);
    Metadata.setUnreliable(metadata, field);
}
/**
 * @transient — mark a field as not persisted to snapshots (encodeAll /
 * encodeAllView). Transient fields are still emitted on per-tick patches
 * (reliable or unreliable), but late-joining clients won't see them until
 * the next mutation.
 *
 * Orthogonal to @unreliable: a field can be either, both, or neither.
 */
function transient(target, field) {
    const metadata = Metadata.initialize(target.constructor);
    Metadata.setTransient(metadata, field);
}
function type(type, options) {
    return function (target, field) {
        const constructor = target.constructor;
        if (!type) {
            throw new Error(`${constructor.name}: @type() reference provided for "${field}" is undefined. Make sure you don't have any circular dependencies.`);
        }
        // Normalize type (enum/collection/etc)
        type = getNormalizedType(type);
        // for inheritance support
        TypeContext.register(constructor);
        const parentClass = Object.getPrototypeOf(constructor);
        const parentMetadata = parentClass[Symbol.metadata];
        const metadata = Metadata.initialize(constructor);
        let fieldIndex = metadata[field];
        /**
         * skip if descriptor already exists for this field (`@deprecated()`)
         */
        if (metadata[fieldIndex] !== undefined) {
            if (metadata[fieldIndex].deprecated) {
                // do not create accessors for deprecated properties.
                return;
            }
            else if (metadata[fieldIndex].type !== undefined) {
                // trying to define same property multiple times across inheritance.
                // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                try {
                    throw new Error(`@colyseus/schema: Duplicate '${field}' definition on '${constructor.name}'.\nCheck @type() annotation`);
                }
                catch (e) {
                    const definitionAtLine = e.stack.split("\n")[4].trim();
                    throw new Error(`${e.message} ${definitionAtLine}`);
                }
            }
        }
        else {
            //
            // detect index for this field, considering inheritance
            //
            fieldIndex = metadata[$numFields] // current structure already has fields defined
                ?? (parentMetadata && parentMetadata[$numFields]) // parent structure has fields defined
                ?? -1; // no fields defined
            fieldIndex++;
        }
        if (options && options.manual) {
            Metadata.addField(metadata, fieldIndex, field, type, {
                // do not declare getter/setter descriptor
                enumerable: true,
                configurable: true,
                writable: true,
            });
        }
        else {
            const { complexTypeKlass, childType } = resolveFieldType(type);
            Metadata.addField(metadata, fieldIndex, field, type, getPropertyDescriptor(field, fieldIndex, childType, complexTypeKlass));
        }
        // Install accessor descriptor on the prototype (once per class field).
        if (metadata[$descriptors][field]) {
            Object.defineProperty(target, field, metadata[$descriptors][field]);
        }
        // Pre-compute encoder function for primitive + quantized types.
        if (typeof type === "string" || isQuantizedType(type)) {
            if (!metadata[$encoders]) {
                Object.defineProperty(metadata, $encoders, {
                    value: [],
                    enumerable: false,
                    configurable: true,
                    writable: true,
                });
            }
            metadata[$encoders][fieldIndex] = (typeof type === "string")
                ? encode[type]
                : makeQuantizedEncoder(type.quantized);
        }
    };
}
// ────────────────────────────────────────────────────────────────────────
// Per-field-shape specialized setters.
//
// Single shared closure used to handle all three shapes (primitive /
// schema-ref / collection) in one body with many branches. V8's inliner
// gave up on it because of the size + polymorphism. Splitting into three
// dedicated factories yields smaller, monomorphic bodies that the JIT can
// inline into hot setters like `position.x = 100`.
// ────────────────────────────────────────────────────────────────────────
/** typeof target per primitive type. Cached once, looked up O(1) at decoration. */
const PRIMITIVE_TYPEOF = {
    number: "number",
    int8: "number", uint8: "number",
    int16: "number", uint16: "number",
    int32: "number", uint32: "number",
    int64: "number", uint64: "number",
    float32: "number", float64: "number",
    bigint64: "bigint", biguint64: "bigint",
    string: "string",
    boolean: "boolean",
};
function makePrimitiveSetter(fieldName, fieldIndex, type) {
    const typeofTarget = PRIMITIVE_TYPEOF[type]; // undefined for custom types
    const allowNull = type === "string";
    const isBool = type === "boolean";
    return function (value) {
        const values = this[$values];
        const previousValue = values[fieldIndex];
        if (value === previousValue)
            return;
        if (value !== undefined && value !== null) {
            // Inlined assertType primitive check.
            if (!isBool &&
                typeofTarget !== undefined &&
                typeof value !== typeofTarget &&
                !(allowNull && value === null)) {
                const ctorSuffix = (value && value.constructor) ? ` (${value.constructor.name})` : '';
                throw new EncodeSchemaError(`a '${typeofTarget}' was expected, but '${JSON.stringify(value)}'${ctorSuffix} was provided in ${this.constructor.name}#${fieldName}`);
            }
            this.constructor[$track](this[$changes], fieldIndex, OPERATION.ADD);
        }
        else if (previousValue !== undefined && previousValue !== null) {
            this[$changes].delete(fieldIndex);
        }
        values[fieldIndex] = value;
    };
}
function makeSchemaRefSetter(fieldName, fieldIndex, type) {
    return function (value) {
        const values = this[$values];
        const previousValue = values[fieldIndex];
        if (value === previousValue)
            return;
        if (value !== undefined && value !== null) {
            assertInstanceType(value, type, this, fieldName);
            const changeTree = this[$changes];
            const ctor = this.constructor;
            if (previousValue !== undefined && previousValue !== null && previousValue[$changes]) {
                changeTree.root?.remove(previousValue[$changes]);
                ctor[$track](changeTree, fieldIndex, OPERATION.DELETE_AND_ADD);
            }
            else {
                ctor[$track](changeTree, fieldIndex, OPERATION.ADD);
            }
            // External Schema-like instances may not carry a ChangeTree.
            value[$changes]?.setParent(this, changeTree.root, fieldIndex);
        }
        else if (previousValue !== undefined && previousValue !== null) {
            this[$changes].delete(fieldIndex);
        }
        values[fieldIndex] = value;
    };
}
function makeCollectionSetter(_fieldName, fieldIndex, type, complexTypeKlass) {
    const isArrayKlass = complexTypeKlass.constructor === ArraySchema;
    const isMapKlass = complexTypeKlass.constructor === MapSchema;
    return function (value) {
        const values = this[$values];
        const previousValue = values[fieldIndex];
        if (value === previousValue)
            return;
        if (value !== undefined && value !== null) {
            // automatic Array → ArraySchema / Map → MapSchema conversion.
            if (isArrayKlass && !(value instanceof ArraySchema)) {
                value = new ArraySchema(...value);
            }
            else if (isMapKlass && !(value instanceof MapSchema)) {
                value = new MapSchema(value);
            }
            value[$childType] = type;
            const changeTree = this[$changes];
            const ctor = this.constructor;
            if (previousValue !== undefined && previousValue !== null && previousValue[$changes]) {
                changeTree.root?.remove(previousValue[$changes]);
                ctor[$track](changeTree, fieldIndex, OPERATION.DELETE_AND_ADD);
            }
            else {
                ctor[$track](changeTree, fieldIndex, OPERATION.ADD);
            }
            value[$changes]?.setParent(this, changeTree.root, fieldIndex);
        }
        else if (previousValue !== undefined && previousValue !== null) {
            this[$changes].delete(fieldIndex);
        }
        values[fieldIndex] = value;
    };
}
/**
 * Setter for a `t.quantized()` field. SNAPS the assigned float to the wire-exact
 * value (`dequant(quant(x))`) on write, so the stored value — and every read,
 * including the reconciler's live step off the staged input — is identical to
 * what the server decodes off the wire. This is the half that kills the
 * predict-from-the-wrong-value footgun; the encoder re-quantizes the snapped
 * value at send (a lossless round-trip). Change tracking keys on the SNAPPED
 * value, so a sub-step jitter that quantizes to the same integer emits no delta.
 */
function makeQuantizedSetter(fieldName, fieldIndex, desc) {
    return function (value) {
        const values = this[$values];
        const previousValue = values[fieldIndex];
        if (value !== undefined && value !== null) {
            if (typeof value !== "number") {
                throw new EncodeSchemaError(`a 'number' was expected, but '${JSON.stringify(value)}' was provided in ${this.constructor.name}#${fieldName}`);
            }
            value = dequantize(desc, quantize(desc, value)); // snap to wire-exact
            if (value === previousValue)
                return;
            this.constructor[$track](this[$changes], fieldIndex, OPERATION.ADD);
        }
        else {
            if (value === previousValue)
                return; // undefined === undefined
            if (previousValue !== undefined && previousValue !== null) {
                this[$changes].delete(fieldIndex);
            }
        }
        values[fieldIndex] = value;
    };
}
function getPropertyDescriptor(fieldName, fieldIndex, type, complexTypeKlass) {
    let setter;
    if (complexTypeKlass) {
        setter = makeCollectionSetter(fieldName, fieldIndex, type, complexTypeKlass);
    }
    else if (typeof type === "string") {
        setter = makePrimitiveSetter(fieldName, fieldIndex, type);
    }
    else if (isQuantizedType(type)) {
        setter = makeQuantizedSetter(fieldName, fieldIndex, type.quantized);
    }
    else {
        setter = makeSchemaRefSetter(fieldName, fieldIndex, type);
    }
    return {
        // Quantized stores the already-snapped float, so the getter is the plain
        // $values read — the field yields dequant(q) with no per-read math.
        get: function () { return this[$values][fieldIndex]; },
        set: setter,
        enumerable: true,
        configurable: true,
    };
}
/**
 * `@deprecated()` flag a field as deprecated.
 * The previous `@type()` annotation should remain along with this one.
 */
function deprecated(throws = true) {
    return function (klass, field) {
        const metadata = Metadata.initialize(klass.constructor);
        const fieldIndex = metadata[field];
        metadata[fieldIndex].deprecated = true;
        if (throws) {
            metadata[$descriptors] ??= {};
            metadata[$descriptors][field] = {
                get: function () { throw new Error(`${field} is deprecated.`); },
                set: function (_value) { },
                enumerable: false,
                configurable: true
            };
            // Override accessor on the prototype so deprecated throws at access.
            Object.defineProperty(klass, field, metadata[$descriptors][field]);
        }
        // flag metadata[field] as non-enumerable
        Object.defineProperty(metadata, fieldIndex, {
            value: metadata[fieldIndex],
            enumerable: false,
            configurable: true
        });
    };
}
/**
 * Build a per-construction factory for a builder type's auto-instantiated
 * default (empty collection or zero-arg Schema ref), or `undefined` when the
 * type has no auto-default. Returning a factory lets each construction `new` a
 * fresh value directly instead of cloning a shared prototype instance.
 */
function makeAutoDefaultFactory(rawType) {
    if (rawType && typeof rawType === "object") {
        if (rawType.array !== undefined) {
            return () => new ArraySchema();
        }
        if (rawType.map !== undefined) {
            return () => new MapSchema();
        }
        if (rawType.set !== undefined) {
            return () => new SetSchema();
        }
        if (rawType.collection !== undefined) {
            return () => new CollectionSchema();
        }
        if (rawType.stream !== undefined) {
            return () => new StreamSchema();
        }
    }
    else if (typeof rawType === "function" && Schema.is(rawType)) {
        if (!rawType.prototype.initialize || rawType.prototype.initialize.length === 0) {
            return () => new rawType();
        }
    }
    return undefined;
}
/**
 * Define a Schema class declaratively.
 *
 * @example
 * import { schema, t } from '@colyseus/schema';
 *
 * const Player = schema({
 *   hp: t.uint8().default(100),
 *   name: t.string().view(),
 *   takeDamage(n: number) { this.hp -= n; },
 * }, 'Player');
 *
 * const Warrior = Player.extend({
 *   weapon: t.string(),
 * }, 'Warrior');
 */
function schema(fieldsAndMethods, name, inherits = Schema) {
    if (fieldsAndMethods == null || typeof fieldsAndMethods !== "object") {
        throw new Error(`schema(): first argument must be a fields object (got ${typeof fieldsAndMethods}).`);
    }
    const fields = {};
    const methods = {};
    // Two buckets, both keyed by field name and applied at construction:
    //  - `defaultValues`: static values copied as-is (shared reference).
    //  - `defaultFactories`: invoked per construction for a fresh value —
    //    `.default(fn)`, clone-able defaults, and auto-instantiated collections/refs.
    const defaultValues = {};
    const defaultFactories = {};
    // Decide once (at definition time) how each `.default(v)` materializes per
    // construction: a function is a factory; a clone-able value clones fresh;
    // anything else is a shared static value.
    const assignDefault = (field, value) => {
        if (typeof value === "function") {
            defaultFactories[field] = value;
        }
        else if (value && typeof value.clone === "function") {
            defaultFactories[field] = () => value.clone();
        }
        else {
            defaultValues[field] = value;
        }
    };
    // Seed a field's construction default: explicit `.default(v)`, else the
    // auto-instantiated empty collection / zero-arg ref (skipped for `.optional()`).
    const seedDefault = (field, def) => {
        if (def.hasDefault) {
            assignDefault(field, def.default);
        }
        else if (!def.optional) {
            const factory = makeAutoDefaultFactory(def.type);
            if (factory) {
                defaultFactories[field] = factory;
            }
        }
    };
    const viewTagFields = {};
    const ownedFields = [];
    const unreliableFields = [];
    const transientFields = [];
    const deprecatedFields = {};
    const staticFields = [];
    const streamFields = [];
    const streamPriorityFields = {};
    const optionalFields = [];
    for (const fieldName in fieldsAndMethods) {
        const value = fieldsAndMethods[fieldName];
        if (isBuilder(value)) {
            const def = value['toDefinition'](); // private; element access bypasses visibility
            if (def.noSync) {
                // Local-only field: skip metadata registration entirely so it is
                // never encoded/decoded, but still seed its construction default
                // (honoring `.default()` and collection/ref auto-instantiation).
                if (def.view !== undefined || def.owned || def.unreliable ||
                    def.transient || def.static || def.stream) {
                    throw new Error(`schema(${name ? `'${name}'` : ""}): field '${fieldName}' uses .noSync() ` +
                        `together with a sync-only modifier (.view/.owned/.unreliable/.transient/.static/.stream). ` +
                        `A local-only field cannot be synchronized.`);
                }
                seedDefault(fieldName, def);
                continue;
            }
            const normalizedType = getNormalizedType(def.type);
            // A synced ref must be encodable (a Schema, or Metadata.setFields()'d) — reject a bare class.
            if (typeof normalizedType === "function" && !Schema.is(normalizedType)) {
                throw new Error(`schema(${name ? `'${name}'` : ""}): field '${fieldName}' is a synced ref to non-Schema ` +
                    `class '${normalizedType.name || "(anonymous)"}' — use .noSync(), or Metadata.setFields().`);
            }
            fields[fieldName] = normalizedType;
            if (def.view !== undefined) {
                viewTagFields[fieldName] = def.view;
            }
            if (def.owned) {
                ownedFields.push(fieldName);
            }
            if (def.unreliable) {
                unreliableFields.push(fieldName);
            }
            if (def.transient) {
                transientFields.push(fieldName);
            }
            if (def.deprecated) {
                deprecatedFields[fieldName] = def.deprecatedThrows;
            }
            if (def.static) {
                staticFields.push(fieldName);
            }
            if (def.stream) {
                streamFields.push(fieldName);
            }
            if (def.streamPriority !== undefined) {
                streamPriorityFields[fieldName] = def.streamPriority;
            }
            if (def.optional) {
                optionalFields.push(fieldName);
            }
            seedDefault(fieldName, def);
        }
        else if (typeof value === "function") {
            if (Schema.is(value)) {
                // Convenience: allow a bare Schema subclass (equivalent to `t.ref(Class)`).
                fields[fieldName] = getNormalizedType(value);
                if (!value.prototype.initialize || value.prototype.initialize.length === 0) {
                    defaultFactories[fieldName] = () => new value();
                }
            }
            else {
                methods[fieldName] = value;
            }
        }
        else {
            throw new Error(`schema(${name ? `'${name}'` : ""}): field '${fieldName}' must be a t.* builder, ` +
                `Schema subclass, or method (got ${typeof value}).`);
        }
    }
    // Write construction defaults onto `target` — either the instance directly
    // (no-args fast path) or a throwaway object that gets merged with props.
    const applyDefaults = (target) => {
        for (const fieldName in defaultValues) {
            target[fieldName] = defaultValues[fieldName];
        }
        for (const fieldName in defaultFactories) {
            target[fieldName] = defaultFactories[fieldName]();
        }
    };
    const getDefaultValues = () => {
        const defaults = {};
        applyDefaults(defaults);
        return defaults;
    };
    const getParentProps = (props) => {
        const fieldNames = Object.keys(fields);
        const parentProps = {};
        for (const key in props) {
            if (!fieldNames.includes(key)) {
                parentProps[key] = props[key];
            }
        }
        return parentProps;
    };
    const hasInitialize = typeof methods.initialize === "function";
    /** @codegen-ignore */
    const klass = Metadata.setFields(class extends inherits {
        constructor(...args) {
            const props = args[0];
            if (props === undefined) {
                // No-args: write defaults straight onto the instance — skips the
                // throwaway defaults object + Object.assign + assignProps walk.
                super();
                applyDefaults(this);
            }
            else {
                // With props: merge into the fresh defaults object in place (no
                // extra `{}` target); the super chain runs assignProps once. An
                // `initialize()` owns the schema fields, so only parent props flow up.
                super(Object.assign(getDefaultValues(), hasInitialize ? getParentProps(props) : props));
            }
            // Only call initialize() on the exact target class, not parents.
            if (hasInitialize && new.target === klass) {
                methods.initialize.apply(this, args);
            }
        }
    }, fields);
    klass._getDefaultValues = getDefaultValues;
    Object.assign(klass.prototype, methods);
    for (const fieldName in viewTagFields) {
        view(viewTagFields[fieldName])(klass.prototype, fieldName);
    }
    for (const fieldName of ownedFields) {
        owned(klass.prototype, fieldName);
    }
    for (const fieldName of unreliableFields) {
        unreliable(klass.prototype, fieldName);
    }
    for (const fieldName of transientFields) {
        transient(klass.prototype, fieldName);
    }
    for (const fieldName in deprecatedFields) {
        deprecated(deprecatedFields[fieldName])(klass.prototype, fieldName);
    }
    if (staticFields.length > 0 || streamFields.length > 0) {
        const metadata = klass[Symbol.metadata];
        for (const fieldName of staticFields) {
            Metadata.setStatic(metadata, fieldName);
        }
        for (const fieldName of streamFields) {
            Metadata.setStream(metadata, fieldName);
        }
        for (const fieldName in streamPriorityFields) {
            Metadata.setStreamPriority(metadata, fieldName, streamPriorityFields[fieldName]);
        }
    }
    if (optionalFields.length > 0) {
        const metadata = klass[Symbol.metadata];
        for (const fieldName of optionalFields) {
            metadata[metadata[fieldName]].optional = true;
        }
    }
    if (name) {
        Object.defineProperty(klass, "name", { value: name });
    }
    klass.extend = (childFields, childName) => schema(childFields, childName, klass);
    return klass;
}

function getIndent(level) {
    return (new Array(level).fill(0)).map((_, i) => (i === level - 1) ? `└─ ` : `   `).join("");
}
function dumpChanges(schema) {
    const $root = schema[$changes].root;
    const dump = {
        ops: {},
        refs: []
    };
    // for (const refId in $root.changes) {
    let current = $root.changes.next;
    while (current) {
        const changeTree = current.changeTree;
        // skip if ChangeTree is undefined
        if (changeTree === undefined) {
            current = current.next;
            continue;
        }
        dump.refs.push(`refId#${changeTree.ref[$refId]}`);
        changeTree.forEach((index, op) => {
            if (index < 0 || !op)
                return;
            const opName = OPERATION[op];
            if (!dump.ops[opName]) {
                dump.ops[opName] = 0;
            }
            dump.ops[opName]++;
        });
        current = current.next;
    }
    return dump;
}

/**
 * Schema encoder / decoder
 */
class Schema {
    static [Symbol.metadata];
    static [$encoder] = encodeSchemaOperation;
    static [$decoder] = decodeSchemaOperation;
    [$refId];
    [$values];
    /**
     * Initialize change tracking on this instance.
     * Field accessor descriptors (getter/setter) live on the prototype,
     * installed once at class-definition time. Per-instance work is limited
     * to allocating a ChangeTree and a values array.
     */
    static initialize(instance) {
        // $changes MUST be non-enumerable: tests use assert.deepStrictEqual on
        // Schema instances (e.g. arrayOfPlayers.toArray()), which walks
        // enumerable own Symbol properties. ChangeTree has circular refs
        // (root → changeTrees → other ChangeTrees), so a visible $changes
        // would send deepStrictEqual into exponential recursion. Plain
        // assignment of a Symbol key would be enumerable: true — hence we
        // keep defineProperty here.
        Object.defineProperty(instance, $changes, {
            value: new ChangeTree(instance),
            enumerable: false,
            writable: true
        });
        instance[$values] = [];
    }
    /**
     * Decoder-side factory. Skips the user subclass ctor entirely —
     * decoder-built instances are passive mirrors of server state, so any
     * field initializer / ctor body work would be overwritten by the
     * decoded ADDs immediately after. Assignment order matches
     * {@link Schema.initialize} so V8 assigns the same hidden class
     * ($changes, then $values), keeping decode-path ICs monomorphic even
     * when tracked and untracked instances coexist.
     *
     * The `this:` constraint pins the return type to the concrete subclass
     * when called as `Player.initializeForDecoder()`, not the base Schema.
     */
    static initializeForDecoder() {
        const inst = Object.create(this.prototype);
        installUntrackedChangeTree(inst);
        inst[$values] = [];
        return inst;
    }
    /**
     * Reset a DETACHED instance to construction defaults so it can be returned
     * to a {@link SchemaPool} and reused, avoiding the cost of `new`. Recurses
     * into ref-type fields (child Schemas / collections).
     *
     * Preconditions (enforced):
     * - The instance must be tracked (encoder-side), not a decoder mirror.
     * - The instance must NOT be shared across multiple parents.
     * - The instance must already be removed from its parent collection/field
     *   (so the encoder detached it: `root === undefined`).
     *
     * NOTE: primitive field values are NOT reset to class defaults — re-assign
     * the fields you care about when you reuse the instance (standard
     * object-pool discipline).
     */
    static reset(instance) {
        const changeTree = instance?.[$changes];
        // Only tracked (encoder-side) instances are poolable. Decoder-side
        // instances carry an UntrackedChangeTree, which has no recycle().
        if (changeTree === undefined || typeof changeTree.recycle !== "function") {
            throw new Error(`@colyseus/schema: Schema.reset() requires a tracked (encoder-side) instance.`);
        }
        // Instances reachable through more than one parent are unsafe to pool:
        // another owner may still hold this instance.
        if (changeTree.extraParents !== undefined) {
            throw new Error(`@colyseus/schema: cannot reset a shared instance (${instance.constructor.name}) with multiple parents.`);
        }
        instance[$reset]();
    }
    /**
     * Per-instance reset primitive (the recursive worker behind
     * {@link Schema.reset}). Resets ref-type children first (depth-first),
     * then recycles this instance's ChangeTree and drops its `$refId` so a
     * re-add is assigned a fresh refId exactly like a freshly constructed
     * instance. Dropping `$refId` is what makes instance reuse
     * wire-format-identical to `new T()`.
     */
    [$reset]() {
        const metadata = this.constructor[Symbol.metadata];
        const refIndexes = metadata?.[$refTypeFieldIndexes] ?? [];
        const values = this[$values];
        for (let i = 0; i < refIndexes.length; i++) {
            const child = values[refIndexes[i]];
            // ref fields hold a child Schema or collection (both implement
            // [$reset]); skip undefined/null. Optional-chain is a cheap guard.
            child?.[$reset]?.();
        }
        this[$changes].recycle();
        // Clear the refId by ASSIGNMENT (not `delete`): `delete` would force the
        // instance into V8 dictionary mode, making release() as expensive as the
        // construction it saves. `=== undefined` in Root.add still assigns a fresh
        // refId exactly like a freshly-constructed instance.
        this[$refId] = undefined;
    }
    /**
     * Check whether `type` describes a Schema *class* (a subclass
     * constructor carrying `Symbol.metadata`, as installed by `@type`).
     * Returns false for primitive type strings like `"number"`, descriptor
     * objects like `{ map: Player }`, and Schema *instances*.
     *
     * For the instance-level check — "is this value a Schema instance?" —
     * see {@link Schema.isSchema}.
     */
    static is(type) {
        return typeof (type[Symbol.metadata]) === "object";
    }
    /**
     * Check if a value is an *instance* of Schema. Uses duck-typing on
     * `.assign` to work across multiple `@colyseus/schema` versions that
     * may be loaded in the same process (e.g. bundled server types vs.
     * client types in a p2p setup).
     *
     * For the class-level check — "is this type a Schema subclass?" —
     * see {@link Schema.is}.
     *
     * @param obj Value to check
     * @returns true if the value is a Schema instance
     */
    static isSchema(obj) {
        return typeof obj?.assign === "function";
    }
    /**
     * Track property changes. Exposed as an override point so downstream
     * tools (debuggers, transparent proxies, custom instrumentation) can
     * intercept per-field writes. Hot-path code in `annotations.ts` calls
     * `(this.constructor as typeof Schema)[$track](...)` rather than
     * `changeTree.change(...)` directly so any subclass override wins.
     */
    static [$track](changeTree, index, operation = OPERATION.ADD) {
        changeTree.change(index, operation);
    }
    /**
     * Determine if a property must be filtered.
     * - If returns false, the property is NOT going to be encoded.
     * - If returns true, the property is going to be encoded.
     *
     * Encoding with "filters" happens in two steps:
     * - First, the encoder iterates over all "not owned" properties and encodes them.
     * - Then, the encoder iterates over all "owned" properties per instance and encodes them.
     */
    static [$filter](ref, index, view) {
        const metadata = ref.constructor[Symbol.metadata];
        const tag = metadata[index]?.tag;
        if (view === undefined) {
            // shared pass/encode: encode if doesn't have a tag
            return tag === undefined;
        }
        else if (tag === undefined) {
            // view pass: no tag
            return true;
        }
        else if (tag === DEFAULT_VIEW_TAG) {
            // view pass: default tag
            return view.isChangeTreeVisible(ref[$changes]);
        }
        else {
            // view pass: custom tag (bitmask) — field's stored mask matches
            // if it shares any bit with a tag this view was add()ed with.
            return view.hasTagOnTree(ref[$changes], tag);
        }
    }
    // allow inherited classes to have a constructor
    constructor(arg) {
        Schema.initialize(this);
        if (arg) {
            Schema.assignProps(this, arg);
        }
    }
    /**
     * Assign properties to the instance.
     * @param props Properties to assign to the instance
     * @returns
     */
    assign(props) {
        Schema.assignProps(this, props);
        return this;
    }
    /**
     * Metadata-driven property assignment.
     * Reads tracked fields via property access (works with prototype accessors),
     * then copies any remaining own properties for non-tracked fields.
     */
    static assignProps(target, source) {
        const metadata = target.constructor[Symbol.metadata];
        if (metadata && metadata[$numFields] !== undefined) {
            for (let i = 0; i <= metadata[$numFields]; i++) {
                const field = metadata[i];
                if (!field) {
                    continue;
                }
                const value = source[field.name];
                if (value !== undefined) {
                    target[field.name] = value;
                }
            }
        }
        // Copy non-tracked own properties (e.g. `notSynched: true`).
        const keys = Object.keys(source);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (metadata && metadata[key] !== undefined) {
                continue;
            }
            target[key] = source[key];
        }
    }
    /**
     * Restore the instance from JSON data.
     * @param jsonData JSON data to restore the instance from
     * @returns
     */
    restore(jsonData) {
        const metadata = this.constructor[Symbol.metadata];
        for (const fieldIndex in metadata) {
            const field = metadata[fieldIndex];
            const fieldName = field.name;
            const fieldType = field.type;
            const value = jsonData[fieldName];
            if (value === undefined || value === null) {
                continue;
            }
            if (typeof fieldType === "string") {
                // Primitive type: assign directly
                this[fieldName] = value;
            }
            else if (Schema.is(fieldType)) {
                // Schema type: create instance and restore
                const instance = new fieldType();
                instance.restore(value);
                this[fieldName] = instance;
            }
            else if (typeof fieldType === "object") {
                // Collection types: { map: ... }, { array: ... }, etc.
                const collectionType = Object.keys(fieldType)[0];
                const childType = fieldType[collectionType];
                if (collectionType === "map") {
                    const mapSchema = this[fieldName];
                    for (const key in value) {
                        if (Schema.is(childType)) {
                            const childInstance = new childType();
                            childInstance.restore(value[key]);
                            mapSchema.set(key, childInstance);
                        }
                        else {
                            mapSchema.set(key, value[key]);
                        }
                    }
                }
                else if (collectionType === "array") {
                    const arraySchema = this[fieldName];
                    for (let i = 0; i < value.length; i++) {
                        if (Schema.is(childType)) {
                            const childInstance = new childType();
                            childInstance.restore(value[i]);
                            arraySchema.push(childInstance);
                        }
                        else {
                            arraySchema.push(value[i]);
                        }
                    }
                }
            }
        }
        return this;
    }
    /**
     * (Server-side): Flag a property to be encoded for the next patch.
     * @param instance Schema instance
     * @param property string representing the property name, or number representing the index of the property.
     * @param operation OPERATION to perform (detected automatically)
     */
    setDirty(property, operation) {
        const metadata = this.constructor[Symbol.metadata];
        this[$changes].change(metadata[metadata[property]].index, operation);
    }
    // ────────────────────────────────────────────────────────────────────
    // Change-tracking control API
    //
    // By default, every mutation to a @type() property is automatically
    // recorded as a change. These methods let you opt out for bulk-load
    // scenarios or custom batching.
    //
    // @example
    //   // Bulk-load without emitting changes:
    //   player.untracked(() => {
    //     player.hp = 100;
    //     player.name = "alice";
    //   });
    //
    //   // Pause / resume pattern:
    //   player.pauseTracking();
    //   player.hp = 100;   // not tracked
    //   player.resumeTracking();
    //   player.hp = 50;    // tracked
    // ────────────────────────────────────────────────────────────────────
    /** Stop recording mutations until resumeTracking() is called. */
    pauseTracking() {
        this[$changes].pause();
    }
    /** Re-enable automatic change tracking. */
    resumeTracking() {
        this[$changes].resume();
    }
    /**
     * Run `fn` with change tracking paused, then resume.
     * Returns the function's return value. Safe to nest.
     */
    untracked(fn) {
        return this[$changes].untracked(fn);
    }
    /** True while tracking is paused. */
    get isTrackingPaused() {
        return this[$changes].paused;
    }
    clone() {
        // Create instance without calling custom constructor
        const cloned = Object.create(this.constructor.prototype);
        Schema.initialize(cloned);
        const metadata = this.constructor[Symbol.metadata];
        //
        // TODO: clone all properties, not only annotated ones
        //
        // for (const field in this) {
        for (const fieldIndex in metadata) {
            const field = metadata[fieldIndex].name;
            if (typeof (this[field]) === "object" &&
                typeof (this[field]?.clone) === "function") {
                // deep clone
                cloned[field] = this[field].clone();
            }
            else {
                // primitive values
                cloned[field] = this[field];
            }
        }
        return cloned;
    }
    toJSON() {
        const obj = {};
        const metadata = this.constructor[Symbol.metadata];
        for (const index in metadata) {
            const field = metadata[index];
            const fieldName = field.name;
            if (!field.deprecated && this[fieldName] !== null && typeof (this[fieldName]) !== "undefined") {
                obj[fieldName] = (typeof (this[fieldName]['toJSON']) === "function")
                    ? this[fieldName]['toJSON']()
                    : this[fieldName];
            }
        }
        return obj;
    }
    /**
     * Used in tests only
     * @internal
     */
    discardAllChanges() {
        this[$changes].discardAll();
    }
    [$getByIndex](index) {
        const metadata = this.constructor[Symbol.metadata];
        return this[metadata[index].name];
    }
    [$deleteByIndex](index) {
        const metadata = this.constructor[Symbol.metadata];
        this[metadata[index].name] = undefined;
    }
    /**
     * Inspect the `refId` of all Schema instances in the tree. Optionally display the contents of the instance.
     *
     * @param ref Schema instance
     * @param showContents display JSON contents of the instance
     * @returns
     */
    static debugRefIds(ref, showContents = false, level = 0, decoder, keyPrefix = "") {
        const contents = (showContents) ? ` - ${JSON.stringify(ref.toJSON())}` : "";
        const changeTree = ref[$changes];
        const refId = ref[$refId];
        const root = (decoder) ? decoder.root : changeTree.root;
        // log reference count if > 1
        const refCount = (root?.refCount?.[refId] > 1)
            ? ` [×${root.refCount[refId]}]`
            : '';
        let output = `${getIndent(level)}${keyPrefix}${ref.constructor.name} (refId: ${refId})${refCount}${contents}\n`;
        changeTree.forEachChild((childChangeTree, indexOrKey) => {
            let key = indexOrKey;
            if (typeof indexOrKey === 'number' && ref['$indexes']) {
                // MapSchema
                key = ref['$indexes'].get(indexOrKey) ?? indexOrKey;
            }
            const keyPrefix = (ref['forEach'] !== undefined && key !== undefined) ? `["${key}"]: ` : "";
            output += this.debugRefIds(childChangeTree.ref, showContents, level + 1, decoder, keyPrefix);
        });
        return output;
    }
    /**
     * @param changeSet
     *  - "changes": iterate the current-tick dirty queue (per-tick encode order)
     *  - "allChanges" / "allFilteredChanges" (legacy): structurally walk the
     *    tree in DFS preorder (matches the order in which full-sync emits
     *    trees). The two legacy modes differ by which side of the filter
     *    split they include.
     */
    static debugRefIdEncodingOrder(ref, changeSet = 'allChanges') {
        const encodeOrder = [];
        const rootChangeTree = ref[$changes];
        if (changeSet === "changes") {
            let current = rootChangeTree.root.changes?.next;
            while (current) {
                if (current.changeTree) {
                    encodeOrder.push(current.changeTree.ref[$refId]);
                }
                current = current.next;
            }
            return encodeOrder;
        }
        // Full-sync modes: DFS preorder from root, filtered by tree's
        // filter-status to match the unfiltered / filtered split.
        const wantFiltered = (changeSet === "allFilteredChanges");
        const visited = new Set();
        const walk = (changeTree) => {
            if (visited.has(changeTree))
                return;
            visited.add(changeTree);
            if (changeTree.isFiltered === wantFiltered) {
                encodeOrder.push(changeTree.ref[$refId]);
            }
            changeTree.forEachChild((child, _) => walk(child));
        };
        walk(rootChangeTree);
        return encodeOrder;
    }
    static debugRefIdsFromDecoder(decoder) {
        return this.debugRefIds(decoder.state, false, 0, decoder);
    }
    /**
     * Return a string representation of the changes on a Schema instance.
     * The list of changes is cleared after each encode.
     *
     * @param instance Schema instance
     * @param isEncodeAll Return "full encode" instead of current change set.
     * @returns
     */
    static debugChanges(instance, isEncodeAll = false) {
        const changeTree = instance[$changes];
        const label = isEncodeAll ? "allChanges" : "changes";
        let output = `${instance.constructor.name} (${instance[$refId]}) -> .${label}:\n`;
        if (isEncodeAll) {
            changeTree.forEachLive((index) => {
                output += `- [${index}]: ADD (${JSON.stringify(changeTree.getValue(Number(index), true))})\n`;
            });
        }
        else {
            changeTree.forEach((index, op) => {
                if (index < 0 || !op)
                    return;
                output += `- [${index}]: ${OPERATION[op]} (${JSON.stringify(changeTree.getValue(Number(index), false))})\n`;
            });
        }
        return output;
    }
}

// Reused across Root.add calls — defineProperty is unavoidable ($refId must
// stay non-enumerable for deepStrictEqual) but the descriptor literal isn't.
const $refIdDescriptor$1 = { value: 0, enumerable: false, writable: true };
class Root {
    types;
    /**
     * Monotonic refId counter. RefIds are never recycled — a refId is a
     * stable identity for the lifetime of the room, so a client that
     * missed DELETEs (reconnect) can never see an old id rebound to a
     * different instance. DevMode reads/writes this across HMR cycles.
     */
    nextUniqueId = 0;
    refCount = {};
    changeTrees = {};
    /**
     * Queue of all ChangeTrees with reliable dirty state. Per-tick encode()
     * walks this queue; per-view encodeView() walks it too (filtering at
     * emission time via tree.isFiltered + per-field @view tag).
     */
    changes = createChangeTreeList();
    /**
     * Queue of all ChangeTrees with unreliable dirty state. Walked by
     * `Encoder.encodeUnreliable` / `encodeUnreliableView`. A tree may live
     * in both queues when the Schema has both reliable and unreliable
     * fields dirty at the same time.
     */
    unreliableChanges = createChangeTreeList();
    /**
     * Free-list of ChangeTreeNode objects. Both queues share this pool —
     * a node carries no queue affinity, only `{ changeTree, prev, next, position }`.
     * Reusing nodes turns ~1,250 per-tick allocations (in bench) into 0.
     */
    _nodePool = [];
    /**
     * View ID allocator for StateView visibility bitmaps on ChangeTree.
     * Each new StateView claims the lowest free ID; releaseViewId() puts
     * the ID back. Avoids unbounded bitmap growth across long-running rooms
     * with view churn (clients joining/leaving).
     */
    _nextViewId = 0;
    _freeViewIds = [];
    /** Allocate a fresh view ID (lowest available). */
    acquireViewId() {
        return this._freeViewIds.length > 0
            ? this._freeViewIds.pop()
            : this._nextViewId++;
    }
    /** Return a view ID to the freelist for reuse. */
    releaseViewId(id) {
        this._freeViewIds.push(id);
    }
    /**
     * Currently-bound StateViews, keyed by view ID and held via `WeakRef`
     * so the FinalizationRegistry backstop in StateView still works when
     * the user forgets `dispose()`. Callers must iterate via
     * `forEachActiveView`, which prunes dead entries.
     */
    activeViews = new Map();
    /**
     * Streamable collections attached under this Root — `StreamSchema`
     * plus any collection opted into streaming via `.stream()` on the
     * builder. Encoder.encodeView / broadcast pass iterates this set to
     * dispatch per-view / per-tick budget gates.
     */
    streamTrees = new Set();
    registerView(view) {
        this.activeViews.set(view.id, new WeakRef(view));
    }
    unregisterView(view) {
        this.activeViews.delete(view.id);
        // Clear per-view state on every registered stream so dispose()ing
        // a view doesn't leak its `_pendingByView` / `_sentByView` entries
        // indefinitely. O(streams) on dispose, acceptable since dispose is
        // rare (once per client disconnect).
        const id = view.id;
        for (const stream of this.streamTrees) {
            stream._dropView(id);
        }
    }
    /**
     * Iterate all live StateViews bound to this Root. Prunes entries
     * whose underlying view has been garbage collected without an
     * explicit `dispose()`.
     */
    forEachActiveView(cb) {
        for (const [id, ref] of this.activeViews) {
            const view = ref.deref();
            if (view === undefined) {
                this.activeViews.delete(id);
                for (const stream of this.streamTrees)
                    stream._dropView(id);
                continue;
            }
            cb(view);
        }
    }
    registerStream(stream) {
        this.streamTrees.add(stream);
    }
    unregisterStream(stream) {
        this.streamTrees.delete(stream);
    }
    constructor(types, startRefId = 0) {
        this.types = types;
        this.nextUniqueId = startRefId;
    }
    add(changeTree) {
        const ref = changeTree.ref;
        // Assign unique `refId` to ref if it doesn't have one yet.
        // $refId is a Symbol but assert.deepStrictEqual still walks
        // *enumerable* own Symbols, so we keep defineProperty(enumerable:false)
        // to keep $refId hidden from deep-equal comparisons in tests.
        if (ref[$refId] === undefined) {
            $refIdDescriptor$1.value = this.nextUniqueId++;
            Object.defineProperty(ref, $refId, $refIdDescriptor$1);
        }
        const refId = ref[$refId];
        const isNewChangeTree = (this.changeTrees[refId] === undefined);
        if (isNewChangeTree) {
            this.changeTrees[refId] = changeTree;
        }
        const previousRefCount = this.refCount[refId];
        if (previousRefCount === 0 || changeTree.needsRestage) {
            //
            // Re-stage every currently-populated non-transient index as a
            // fresh ADD in the matching dirty bucket so the next encode
            // re-emits it on the correct channel. Two triggers:
            // - refCount 0: a previously-removed tree re-added under the
            //   same refId (its ops were consumed by an earlier encode).
            // - NEEDS_RESTAGE: a `Schema.reset` instance re-entering under
            //   a fresh refId (reset cleared the buckets; its retained
            //   values would otherwise never be encoded).
            //
            changeTree.needsRestage = false;
            changeTree.forEachLive((fieldIndex) => {
                if (changeTree.isFieldUnreliable(fieldIndex)) {
                    changeTree.ensureUnreliableRecorder().record(fieldIndex, OPERATION.ADD);
                }
                else {
                    changeTree.record(fieldIndex, OPERATION.ADD);
                }
            });
        }
        this.refCount[refId] = (previousRefCount || 0) + 1;
        return isNewChangeTree;
    }
    remove(changeTree) {
        const refId = changeTree.ref[$refId];
        const refCount = (this.refCount[refId]) - 1;
        if (refCount <= 0) {
            //
            // Only remove "root" reference if it's the last reference
            //
            changeTree.root = undefined;
            delete this.changeTrees[refId];
            // Streamable-collection detach (StreamSchema + any `.stream()`
            // collection). Tree flag is cheaper than the class-level
            // brand and covers both cases uniformly.
            if (changeTree.isStreamCollection) {
                const streamable = changeTree.ref;
                streamable._unregister?.();
                this.unregisterStream(streamable);
            }
            this.removeFromQueue(changeTree);
            this.removeFromUnreliableQueue(changeTree);
            this.refCount[refId] = 0;
            changeTree.forEachChild((child, _) => {
                if (child.removeParent(changeTree.ref)) {
                    if ((child.parentRef === undefined || // no parent, remove it
                        (child.parentRef && this.refCount[child.ref[$refId]] > 0) // parent is still in use, but has more than one reference, remove it
                    )) {
                        this.remove(child);
                    }
                    else if (child.parentRef) {
                        // re-assigning a child of the same root, move it next to parent
                        this.moveNextToParent(child);
                    }
                }
            });
        }
        else {
            this.refCount[refId] = refCount;
            //
            // When losing a reference to an instance, it is best to move the
            // ChangeTree next to its parent in the encoding queue.
            //
            // This way, at decoding time, the instance that contains the
            // ChangeTree will be available before the ChangeTree itself. If the
            // containing instance is not available, the Decoder will throw
            // "refId not found" error.
            //
            this.recursivelyMoveNextToParent(changeTree);
        }
        return refCount;
    }
    recursivelyMoveNextToParent(changeTree) {
        this.moveNextToParent(changeTree);
        changeTree.forEachChild((child, _) => this.recursivelyMoveNextToParent(child));
    }
    moveNextToParent(changeTree) {
        if (changeTree.changesNode) {
            this._moveNextToParentInList(this.changes, changeTree, changeTree.changesNode, "changesNode");
        }
        if (changeTree.unreliableChangesNode) {
            this._moveNextToParentInList(this.unreliableChanges, changeTree, changeTree.unreliableChangesNode, "unreliableChangesNode");
        }
    }
    _moveNextToParentInList(changeSet, changeTree, node, nodeField) {
        const parent = changeTree.parent;
        if (!parent || !parent[$changes])
            return;
        const parentNode = parent[$changes][nodeField];
        if (!parentNode || parentNode === node)
            return;
        // Check if child is already after parent by walking from parent
        let cursor = parentNode.next;
        while (cursor) {
            if (cursor === node)
                return; // already after parent
            cursor = cursor.next;
        }
        // If we reach here, node is before parent — need to move
        // Remove node from current position
        if (node.prev) {
            node.prev.next = node.next;
        }
        else {
            changeSet.next = node.next;
        }
        if (node.next) {
            node.next.prev = node.prev;
        }
        else {
            changeSet.tail = node.prev;
        }
        // Insert node right after parent
        node.prev = parentNode;
        node.next = parentNode.next;
        if (parentNode.next) {
            parentNode.next.prev = node;
        }
        else {
            changeSet.tail = node;
        }
        parentNode.next = node;
    }
    enqueueChangeTree(changeTree, existingNode = changeTree.changesNode) {
        if (existingNode) {
            return;
        }
        changeTree.changesNode = this._appendToList(this.changes, changeTree);
    }
    enqueueUnreliable(changeTree, existingNode = changeTree.unreliableChangesNode) {
        if (existingNode) {
            return;
        }
        changeTree.unreliableChangesNode = this._appendToList(this.unreliableChanges, changeTree);
    }
    _appendToList(list, changeTree) {
        const pool = this._nodePool;
        let node;
        if (pool.length > 0) {
            node = pool.pop();
            node.changeTree = changeTree;
            node.next = undefined;
            node.prev = undefined;
            node.position = 0;
        }
        else {
            node = { changeTree, next: undefined, prev: undefined, position: 0 };
        }
        if (!list.next) {
            list.next = node;
            list.tail = node;
        }
        else {
            node.prev = list.tail;
            list.tail.next = node;
            list.tail = node;
        }
        return node;
    }
    /**
     * Release a detached node back to the free-list. Caller must have
     * already unlinked it from any list and cleared the changeTree's
     * pointer to it. Clears `changeTree`/`prev`/`next` so the pool
     * doesn't retain references through the GC root.
     */
    releaseNode(node) {
        node.changeTree = undefined;
        node.prev = undefined;
        node.next = undefined;
        this._nodePool.push(node);
    }
    removeFromQueue(changeTree) {
        return this._removeNode(this.changes, changeTree, changeTree.changesNode, "changesNode");
    }
    removeFromUnreliableQueue(changeTree) {
        return this._removeNode(this.unreliableChanges, changeTree, changeTree.unreliableChangesNode, "unreliableChangesNode");
    }
    _removeNode(changeSet, changeTree, node, nodeField) {
        if (!node || node.changeTree !== changeTree)
            return false;
        if (node.prev) {
            node.prev.next = node.next;
        }
        else {
            changeSet.next = node.next;
        }
        if (node.next) {
            node.next.prev = node.prev;
        }
        else {
            changeSet.tail = node.prev;
        }
        changeTree[nodeField] = undefined;
        this.releaseNode(node);
        return true;
    }
}

/**
 * Emit the lazy structure-switch header (SWITCH_TO_STRUCTURE + refId) for
 * the current tree if it hasn't been emitted yet in this pass.
 */
function ensureStructSwitch(ctx) {
    if (ctx.structSwitchEmitted)
        return;
    if (ctx.shouldEmitSwitch) {
        ctx.buffer[ctx.it.offset++] = SWITCH_TO_STRUCTURE & 255;
        encode.number(ctx.buffer, ctx.ref[$refId], ctx.it);
    }
    ctx.structSwitchEmitted = true;
}
/**
 * Module-level adapter for `forEachLiveWithCtx`. Full-sync emits every live
 * field as ADD, so we re-enter `encodeChangeCb` with that fixed op — keeps
 * the callback closure-free across the entire DFS walk.
 *
 * The resync sweep (decoder/Resync.ts) depends on this shape: full-sync
 * output is dense plain ADDs — no DELETEs, no gap-writes (so decoding it
 * never compacts arrays mid-walk), and replaced occupants arrive as plain
 * ADD (the sweep's touch hook releases them). Changing full-sync emission
 * means revisiting the sweep.
 */
function encodeFullSyncCb(ctx, fieldIndex) {
    encodeChangeCb(ctx, fieldIndex, OPERATION.ADD);
}
/**
 * Structural DFS walker for `encodeFullSync`. Hoisted to module scope so
 * the recursion allocates no per-tree closures — `_fullSyncWalkChildCb`
 * captures nothing and is handed to `forEachChildWithCtx` once.
 *
 * The stamp check at the top (`tree._fullSyncGen === ctx.gen`) is how we
 * skip shared refs that are reachable through more than one parent. On
 * first visit the tree's stamp differs from the walk's current `ctx.gen`;
 * we write `ctx.gen` onto the tree and recurse. Any later reach of the
 * same tree during the SAME walk will find matching stamps and bail.
 * Next walk bumps `ctx.gen`, so every tree starts out stale again.
 */
function _fullSyncWalk(ctx, changeTree) {
    if (changeTree._fullSyncGen === ctx.gen)
        return;
    changeTree._fullSyncGen = ctx.gen;
    // Visibility gate: when a view is active, a non-visible tree contributes
    // nothing itself but we still recurse so descendants (possibly added to
    // the view explicitly) are reachable.
    let visibleHere = true;
    if (ctx.hasView) {
        const view = ctx.view;
        if (!view.isChangeTreeVisible(changeTree)) {
            view.markInvisible(changeTree);
            visibleHere = false;
        }
        else {
            view.unmarkInvisible(changeTree);
        }
    }
    if (visibleHere) {
        const desc = changeTree.encDescriptor;
        ctx.changeTree = changeTree;
        ctx.ref = changeTree.ref;
        ctx.encoder = desc.encoder;
        ctx.filter = desc.filter;
        ctx.metadata = desc.metadata;
        ctx.treeIsFiltered = changeTree.isFiltered;
        ctx.isSchema = desc.isSchema;
        ctx.filterBitmask = desc.filterBitmask;
        ctx.structSwitchEmitted = false;
        ctx.shouldEmitSwitch = (ctx.hasView || ctx.it.offset > ctx.initialOffset || changeTree !== ctx.rootChangeTree);
        // Call the module function directly — the `forEachLiveWithCtx`
        // method on ChangeTree is a pass-through that V8 doesn't inline
        // under the polymorphism the encoder sees (Schema + every
        // collection class share the method slot). Direct call saves the
        // dispatched frame.
        forEachLiveWithCtx(changeTree, ctx, encodeFullSyncCb);
    }
    forEachChildWithCtx(changeTree, ctx, _fullSyncWalkChildCb);
}
/**
 * Child-iteration callback for `_fullSyncWalk`. Module-level + closure-free:
 * just re-enters `_fullSyncWalk` on each child. Replaces a per-tree
 * `(child, _) => walk(child)` closure that used to allocate 2.5M times in
 * `encodeAll(5000 entities) x 500 iterations`.
 */
function _fullSyncWalkChildCb(ctx, child, _index) {
    _fullSyncWalk(ctx, child);
}
/**
 * Pure (non-capturing) callback for recorder.forEachWithCtx. Module-level so
 * V8 never needs to allocate a fresh function per tree. Decides per-field
 * whether to emit based on the unified filter rule, then defers to the
 * per-type encode function.
 */
function encodeChangeCb(ctx, fieldIndex, op) {
    if (fieldIndex < 0) {
        // Pure op (CLEAR/REVERSE): encoded as a single byte. Always emitted
        // for the pass that matches the tree's filter classification —
        // collections route pure ops to their single dirty bucket.
        if (ctx.treeIsFiltered !== ctx.emitFiltered)
            return;
        ensureStructSwitch(ctx);
        ctx.buffer[ctx.it.offset++] = Math.abs(fieldIndex) & 255;
        return;
    }
    // Per-field filter decision (same rule as ChangeTree.change()):
    // a field is filtered iff the tree inherits isFiltered OR the field
    // itself carries a @view tag. Schema trees check via the precomputed
    // bitmask; collection trees inherit tree-level (bitmask is 0).
    const fieldFiltered = ctx.isSchema
        ? (ctx.treeIsFiltered || (ctx.filterBitmask & (1 << fieldIndex)) !== 0)
        : ctx.treeIsFiltered;
    if (fieldFiltered !== ctx.emitFiltered)
        return;
    const operation = ctx.isEncodeAll ? OPERATION.ADD : op;
    if (operation === undefined)
        return;
    if (ctx.filter !== undefined && !ctx.filter(ctx.ref, fieldIndex, ctx.view))
        return;
    ensureStructSwitch(ctx);
    ctx.encoder(ctx.self, ctx.buffer, ctx.changeTree, fieldIndex, operation, ctx.it, ctx.isEncodeAll, ctx.hasView, ctx.metadata);
}
function concatBytes(a, b) {
    const result = new Uint8Array(a.length + b.length);
    result.set(a, 0);
    result.set(b, a.length);
    return result;
}
class Encoder {
    /**
     * Per-encoder shared output buffer size. The encoder auto-grows on
     * overflow and logs a one-time warning suggesting a higher value, so
     * the default just needs to comfortably cover typical room state.
     *
     * Sized to fit ~100 items in a `MapSchema<{x,y,z}>` keyed by
     * `nanoid(9)` (~4.5 KB worst-case full encode, float64-heavy) with
     * ~3-4× headroom for surrounding state (player list, world refs,
     * etc.). Raise per app via `Encoder.BUFFER_SIZE = N * 1024` before
     * constructing any Encoder.
     */
    static BUFFER_SIZE = 16 * 1024;
    sharedBuffer = new Uint8Array(Encoder.BUFFER_SIZE);
    context;
    state;
    root;
    constructor(state, root) {
        //
        // Use .cache() here to avoid re-creating a new context for every new room instance.
        //
        // We may need to make this optional in case of dynamically created
        // schemas - which would lead to memory leaks
        //
        this.context = TypeContext.cache(state.constructor);
        this.root = root ?? new Root(this.context);
        this.setState(state);
    }
    setState(state) {
        this.state = state;
        this.state[$changes].setRoot(this.root);
    }
    _encodeCtx = {
        self: undefined, buffer: undefined, it: undefined, changeTree: undefined,
        ref: undefined, encoder: undefined, filter: undefined, metadata: undefined,
        view: undefined, isEncodeAll: false, hasView: false,
        treeIsFiltered: false, isSchema: false, emitFiltered: false,
        filterBitmask: 0,
        structSwitchEmitted: false, isRootTree: false, shouldEmitSwitch: false,
        gen: 0, initialOffset: 0, rootChangeTree: undefined,
    };
    /**
     * Monotonic counter bumped at the start of every `encodeFullSync`
     * call. The new value is copied to `ctx.gen` and stamped into every
     * tree the walk touches (`tree._fullSyncGen = ctx.gen`); subsequent
     * revisits of the same tree detect the equality and return early.
     */
    _fullSyncGen = 0;
    encode(it = { offset: 0 }, view, buffer = this.sharedBuffer, initialOffset = it.offset) {
        return this._encodeChannel(it, view, buffer, initialOffset, /* unreliable */ false);
    }
    /**
     * Per-tick encode of the UNRELIABLE channel. Walks `root.unreliableChanges`
     * and emits each tree's `unreliableRecorder`. Safe to call at a different
     * cadence than `encode()` (e.g. 60Hz vs 20Hz) — the two channels are
     * fully independent.
     */
    encodeUnreliable(it = { offset: 0 }, view, buffer = this.sharedBuffer, initialOffset = it.offset) {
        return this._encodeChannel(it, view, buffer, initialOffset, /* unreliable */ true);
    }
    _encodeChannel(it, view, buffer, initialOffset, unreliable) {
        const hasView = (view !== undefined);
        const rootChangeTree = this.state[$changes];
        const ctx = this._encodeCtx;
        ctx.self = this;
        ctx.buffer = buffer;
        ctx.it = it;
        ctx.view = view;
        ctx.isEncodeAll = false;
        ctx.hasView = hasView;
        // Shared pass (no view): emit unfiltered fields. View pass: emit
        // filtered fields only. Fields on the other side of the split are
        // skipped inside encodeChangeCb.
        ctx.emitFiltered = hasView;
        const queue = unreliable ? this.root.unreliableChanges : this.root.changes;
        let current = queue;
        while (current = current.next) {
            const changeTree = current.changeTree;
            if (hasView) {
                if (!view.isChangeTreeVisible(changeTree)) {
                    view.markInvisible(changeTree);
                    continue;
                }
                view.unmarkInvisible(changeTree);
            }
            const recorder = unreliable ? changeTree.unreliableRecorder : changeTree;
            if (!recorder || !recorder.has()) {
                continue;
            }
            const desc = changeTree.encDescriptor;
            ctx.changeTree = changeTree;
            ctx.ref = changeTree.ref;
            ctx.encoder = desc.encoder;
            ctx.filter = desc.filter;
            ctx.metadata = desc.metadata;
            ctx.treeIsFiltered = changeTree.isFiltered;
            ctx.isSchema = desc.isSchema;
            ctx.filterBitmask = desc.filterBitmask;
            ctx.structSwitchEmitted = false;
            ctx.isRootTree = (changeTree === rootChangeTree);
            // Root's struct switch is skipped at the very start of the shared
            // pass (matches the legacy wire protocol). In view pass or after
            // the first emission, always emit the switch.
            ctx.shouldEmitSwitch = (hasView || it.offset > initialOffset || !ctx.isRootTree);
            recorder.forEachWithCtx(ctx, encodeChangeCb);
        }
        // Broadcast-mode stream emission runs after the main loop (state /
        // parent refs are already on the wire, so stream ADD ops can
        // reference element refIds safely). Reliable shared pass only;
        // skipped when any StateView is registered (priority pass in
        // `encodeView` owns emission in that mode).
        if (!unreliable && !hasView && this.root.activeViews.size === 0 && this.root.streamTrees.size > 0) {
            this._emitStreamBroadcast(buffer, it);
        }
        if (it.offset > buffer.byteLength) {
            buffer = this._resizeBuffer(buffer, it.offset);
            // Reuse `it` (reset its offset) instead of a fresh iterator so the
            // caller's `it.offset` ends at the true final offset. A fresh one
            // strands `it.offset` at the overflow value and corrupts the next
            // view's region in a multi-view encode.
            it.offset = initialOffset;
            return this._encodeChannel(it, view, buffer, initialOffset, unreliable);
        }
        return buffer.subarray(0, it.offset);
    }
    /**
     * Structural DFS walker for full-sync (encodeAll / encodeAllView).
     * Visits each ChangeTree in DFS preorder starting from the state root,
     * emitting ADD operations for every currently-populated index via
     * {@link ChangeTree.forEachLive}.
     */
    encodeFullSync(it, buffer, emitFiltered, view, initialOffset = it.offset) {
        const hasView = (view !== undefined);
        const rootChangeTree = this.state[$changes];
        const ctx = this._encodeCtx;
        ctx.self = this;
        ctx.buffer = buffer;
        ctx.it = it;
        ctx.view = view;
        ctx.isEncodeAll = true;
        ctx.hasView = hasView;
        ctx.emitFiltered = emitFiltered;
        // Bump the generation counter and carry the new value on `ctx` so
        // the recursive walker can stamp every tree it visits. Any tree
        // still holding the previous walk's stamp is treated as unvisited
        // on first reach, and stamped; a second reach (shared ref via
        // multiple parents) sees the match and bails.
        ctx.gen = ++this._fullSyncGen;
        ctx.initialOffset = initialOffset;
        ctx.rootChangeTree = rootChangeTree;
        _fullSyncWalk(ctx, rootChangeTree);
        if (it.offset > buffer.byteLength) {
            buffer = this._resizeBuffer(buffer, it.offset);
            it.offset = initialOffset; // reuse `it` so the caller's offset stays accurate
            return this.encodeFullSync(it, buffer, emitFiltered, view, initialOffset);
        }
        return buffer.subarray(0, it.offset);
    }
    _resizeBuffer(buffer, usedOffset) {
        const newSize = Math.ceil(usedOffset / Encoder.BUFFER_SIZE) * Encoder.BUFFER_SIZE;
        console.warn(`@colyseus/schema buffer overflow. Encoded state is higher than default BUFFER_SIZE. Use the following to increase default BUFFER_SIZE:

    import { Encoder } from "@colyseus/schema";
    Encoder.BUFFER_SIZE = ${Math.round(newSize / 1024)} * 1024; // ${Math.round(newSize / 1024)} KB
`);
        const newBuffer = new Uint8Array(newSize);
        newBuffer.set(buffer);
        if (buffer === this.sharedBuffer) {
            this.sharedBuffer = newBuffer;
        }
        return newBuffer;
    }
    encodeAll(it = { offset: 0 }, buffer = this.sharedBuffer) {
        return this.encodeFullSync(it, buffer, /* emitFiltered */ false);
    }
    encodeAllView(view, sharedOffset, it, bytes = this.sharedBuffer) {
        const viewOffset = it.offset;
        // encodeFullSync() may reallocate the buffer on overflow — keep its
        // return, not the stale `bytes`, or the concat below reads a dead buffer.
        bytes = this.encodeFullSync(it, bytes, /* emitFiltered */ true, view, viewOffset);
        return concatBytes(bytes.subarray(0, sharedOffset), bytes.subarray(viewOffset, it.offset));
    }
    /** Grow `buffer` to keep BUFFER_SIZE free bytes past `offset`, preserving `[0, offset)`. */
    ensureCapacity(buffer, offset) {
        if (offset + Encoder.BUFFER_SIZE <= buffer.byteLength) {
            return buffer;
        }
        const size = Math.ceil((offset + Encoder.BUFFER_SIZE) / Encoder.BUFFER_SIZE) * Encoder.BUFFER_SIZE;
        const grown = new Uint8Array(size);
        grown.set(buffer.subarray(0, offset));
        if (buffer === this.sharedBuffer) {
            this.sharedBuffer = grown;
        }
        return grown;
    }
    encodeView(view, sharedOffset, it, bytes = this.sharedBuffer) {
        const viewOffset = it.offset;
        // Stream priority pass: drain up to `maxPerTick` per-view entries
        // from every registered stream before draining view.changes. Each
        // selected element is passed to `view.add()` which populates
        // view.changes with the stream-link ADD + element-field ADDs.
        this._emitStreamPriority(view);
        //
        // `view.changes` Map insertion order IS topological order:
        //   - `view.add` walks the parent chain to root via `addParentOf`
        //     (depth-first ancestor-first), inserting every ancestor's
        //     entry before the descendant's.
        //   - `view.remove` calls `_touchAncestorsOf` before its own
        //     write to insert any missing ancestors at the front of the
        //     chain — empty entries that get skipped by the size==0
        //     check below but establish Map position.
        // No per-encode topo sort needed.
        //
        for (const refId of view.changes.keys()) {
            const changes = view.changes.get(refId);
            const changeTree = this.root.changeTrees[refId];
            if (changeTree === undefined) {
                // detached instance, remove from view and skip.
                view.changes.delete(refId);
                continue;
            }
            if (changes.size === 0) {
                continue;
            }
            const desc = changeTree.encDescriptor;
            const encoder = desc.encoder;
            const metadata = desc.metadata;
            // `ref` → user-facing identity (Proxy on ArraySchema), used for
            // `[$refId]`. `refTarget` → raw instance, used for the hot
            // `[$getByIndex]` lookup that runs once per change.
            const ref = changeTree.ref;
            const refTarget = changeTree.refTarget;
            // These writes are unguarded and unrecoverable (view.changes is cleared
            // below), so unlike encode() they can't re-encode on overflow — grow ahead.
            bytes = this.ensureCapacity(bytes, it.offset);
            bytes[it.offset++] = SWITCH_TO_STRUCTURE & 255;
            encode.number(bytes, ref[$refId], it);
            // Iterate entries directly — the inner Map gives us the (index, op)
            // pair without an intermediate keys array or Number() parse.
            for (const [index, op] of changes) {
                // workaround when using view.add() on item that has been deleted from state
                // (see test "adding to view item that has been removed from state")
                const value = refTarget[$getByIndex](index);
                const operation = (value !== undefined && op) || OPERATION.DELETE;
                // isEncodeAll = false, hasView = true
                encoder(this, bytes, changeTree, index, operation, it, false, true, metadata);
            }
        }
        //
        // TODO: only clear view changes after all views are encoded
        // (to allow re-using StateView's for multiple clients)
        //
        view.changes.clear();
        // Per-tick view-scoped pass: walks the same `changes` queue as the
        // shared pass, but `encodeChangeCb` emits only filtered fields.
        // encode() may reallocate the buffer on overflow — keep its return,
        // not the stale `bytes`. Anchor the re-encode at the current offset
        // (the default `initialOffset = it.offset`), NOT `viewOffset`: a
        // resize must not clobber the view.changes already written at
        // [viewOffset, it.offset).
        bytes = this.encode(it, view, bytes);
        return concatBytes(bytes.subarray(0, sharedOffset), bytes.subarray(viewOffset, it.offset));
    }
    /**
     * Per-view unreliable encode. Walks `root.unreliableChanges` and emits
     * only filtered fields visible to this view. Unlike `encodeView`, this
     * doesn't emit `view.changes` entries — those are used only for
     * reliable view bootstrap (membership ADDs) and are consumed by
     * `encodeView` on the reliable channel.
     */
    encodeUnreliableView(view, sharedOffset, it, bytes = this.sharedBuffer) {
        const viewOffset = it.offset;
        // Capture the return: a resize on overflow reallocates the buffer, and
        // the concat below must read from the live one, not the stale `bytes`.
        bytes = this.encodeUnreliable(it, view, bytes, viewOffset);
        return concatBytes(bytes.subarray(0, sharedOffset), bytes.subarray(viewOffset, it.offset));
    }
    /**
     * Broadcast-mode counterpart to `_emitStreamPriority`. Runs when NO
     * StateViews are registered — streams fall back to broadcast mode
     * where up to `maxPerTick` pending ADDs per stream emit to ALL clients
     * each shared tick. DELETEs always flush (no cap).
     *
     * Emits directly to the shared-encode buffer: stream & element trees
     * are `isFiltered=true` so the main loop would otherwise skip them.
     * Runs AFTER the main loop so state / parent refs are already encoded
     * — stream ADD ops reference element refIds, which must be decodable.
     */
    _emitStreamBroadcast(buffer, it) {
        const streams = this.root.streamTrees;
        for (const stream of streams) {
            const s = stream;
            const tree = s[$changes];
            // Stream is registered with Root but not yet assigned a refId
            // (e.g. created but never attached to state). Skip.
            const streamRefId = s[$refId];
            if (streamRefId === undefined)
                continue;
            // `inheritedFlags.ensureStreamState` allocates `_stream` the
            // moment the tree picks up `isStreamCollection` — Root only
            // tracks trees that reached that point, so `_stream` is
            // guaranteed defined here.
            const st = s._stream;
            const deletes = st.broadcastDeletes;
            const pending = st.broadcastPending;
            const sent = st.sentBroadcast;
            const hasDeletes = deletes.size > 0;
            const hasAdds = pending.size > 0;
            const desc = tree.encDescriptor;
            const streamEncoder = desc.encoder;
            const streamMetadata = desc.metadata;
            // Emit stream ADD/DELETE ops for this tick, if any.
            if (hasDeletes || hasAdds) {
                buffer[it.offset++] = SWITCH_TO_STRUCTURE & 255;
                encode.number(buffer, streamRefId, it);
                // DELETEs first (flush all).
                if (hasDeletes) {
                    for (const pos of deletes) {
                        streamEncoder(this, buffer, tree, pos, OPERATION.DELETE, it, false, false, streamMetadata);
                    }
                    deletes.clear();
                }
                // ADDs up to maxPerTick.
                const max = st.maxPerTick;
                const emittedElements = [];
                let count = 0;
                const toDelete = [];
                for (const pos of pending) {
                    if (count >= max)
                        break;
                    // `$getByIndex` works for any streamable collection:
                    // StreamSchema (Map<number, V>) and MapSchema (string-keyed
                    // via journal index) both route through the same symbol.
                    const element = s[$getByIndex](pos);
                    if (element === undefined) {
                        toDelete.push(pos);
                        continue;
                    }
                    streamEncoder(this, buffer, tree, pos, OPERATION.ADD, it, false, false, streamMetadata);
                    sent.add(pos);
                    emittedElements.push(element);
                    toDelete.push(pos);
                    count++;
                }
                for (const pos of toDelete)
                    pending.delete(pos);
                // Emit each element's full state — forEachLive walks populated
                // fields structurally, mirroring encodeAllView's bootstrap.
                // Covers both static elements (dirty state was reset by
                // inheritedFlags' becameStatic branch) and non-static (still
                // has dirty state but the main loop skipped them because
                // they're filtered).
                for (const element of emittedElements) {
                    const elTree = element[$changes];
                    if (elTree === undefined)
                        continue;
                    const elRefId = element[$refId];
                    if (elRefId === undefined)
                        continue;
                    buffer[it.offset++] = SWITCH_TO_STRUCTURE & 255;
                    encode.number(buffer, elRefId, it);
                    const elDesc = elTree.encDescriptor;
                    const elEncoder = elDesc.encoder;
                    const elMetadata = elDesc.metadata;
                    elTree.forEachLive((idx) => {
                        // @unreliable fields ship on the unreliable channel only.
                        if (Metadata.hasUnreliableAtIndex(elMetadata, idx))
                            return;
                        elEncoder(this, buffer, elTree, idx, OPERATION.ADD, it, false, false, elMetadata);
                    });
                }
            }
            // Emit mutation updates for already-sent elements. Element
            // trees are `isFiltered=true` (inherited from stream field),
            // so the main loop skips them. We pick up their dirty state
            // here so broadcast mode sees post-send field mutations.
            for (const pos of sent) {
                const element = s[$getByIndex](pos);
                if (element === undefined)
                    continue;
                const elTree = element[$changes];
                if (elTree === undefined || !elTree.has())
                    continue;
                const elRefId = element[$refId];
                if (elRefId === undefined)
                    continue;
                buffer[it.offset++] = SWITCH_TO_STRUCTURE & 255;
                encode.number(buffer, elRefId, it);
                const elDesc = elTree.encDescriptor;
                const elEncoder = elDesc.encoder;
                const elMetadata = elDesc.metadata;
                elTree.forEach((idx, op) => {
                    if (idx < 0)
                        return; // pure ops (collection only)
                    if (Metadata.hasUnreliableAtIndex(elMetadata, idx))
                        return;
                    elEncoder(this, buffer, elTree, idx, op, it, false, false, elMetadata);
                });
            }
        }
    }
    /**
     * Walk every registered stream, pick up to `maxPerTick` positions from
     * this view's pending backlog (priority-sorted when the view supplies a
     * `streamPriority` callback), and hand each element to `view.add()`.
     * `view.add()` seeds `view.changes` so the subsequent drain emits both
     * the stream-link (position → refId) and the element's field data.
     *
     * Designed to run at the very top of `encodeView`, BEFORE the
     * view.changes drain loop.
     */
    _emitStreamPriority(view) {
        const streams = this.root.streamTrees;
        if (streams.size === 0)
            return;
        const viewId = view.id;
        for (const stream of streams) {
            const s = stream;
            // Guaranteed non-undefined: `inheritedFlags.ensureStreamState`
            // runs before Root.registerStream.
            const st = s._stream;
            const pending = st.pendingByView.get(viewId);
            if (pending === undefined || pending.size === 0)
                continue;
            // Per-stream priority callback: declared at schema time (via
            // `t.stream(X).priority(fn)` or the decorator form) and seeded
            // into `_stream.priority` when the stream was attached. Users
            // can also override per-instance by assigning to the setter.
            const priority = st.priority;
            // Materialize pending into an array so we can sort + slice.
            // Small sets (typical: tens to low hundreds) — allocation is
            // negligible compared to the priority sort and element walk.
            const positions = [];
            for (const p of pending)
                positions.push(p);
            if (priority !== undefined) {
                // Use the symbol-keyed accessor so Map/Set/Stream all route
                // through the same lookup regardless of $items layout.
                positions.sort((a, b) => priority(view, s[$getByIndex](b)) - priority(view, s[$getByIndex](a)));
            }
            const max = st.maxPerTick;
            const count = Math.min(positions.length, max);
            let sent = st.sentByView.get(viewId);
            if (sent === undefined) {
                sent = new Set();
                st.sentByView.set(viewId, sent);
            }
            for (let i = 0; i < count; i++) {
                const pos = positions[i];
                const element = s[$getByIndex](pos);
                if (element === undefined) {
                    // Element was removed after being queued but before emit.
                    pending.delete(pos);
                    continue;
                }
                // `_addImmediate` force-ships the element through view.changes
                // (markVisible + addParentOf + forEachChild recursion) WITHOUT
                // routing stream elements back into pending — we're already
                // draining pending here, so the normal `add()` path would
                // infinite-loop. addParentOf seeds
                // `view.changes[stream.refId][pos] = ADD` (stream-link emit).
                view._addImmediate(element);
                // Force-seed element fields even when view.add skipped
                // forEachLive (isNew && !isChildAdded). Matches the
                // bootstrap emission encodeAllView does for filtered
                // refs. `@unreliable` fields are excluded — they ship
                // on the unreliable channel and force-seeding here
                // would leak onto the reliable view pass.
                const elTree = element[$changes];
                if (elTree !== undefined) {
                    const elRefId = element[$refId];
                    let elChanges = view.changes.get(elRefId);
                    if (elChanges === undefined) {
                        elChanges = new Map();
                        view.changes.set(elRefId, elChanges);
                    }
                    const elMetadata = elTree.metadata;
                    elTree.forEachLive((index) => {
                        if (Metadata.hasUnreliableAtIndex(elMetadata, index))
                            return;
                        elChanges.set(index, OPERATION.ADD);
                    });
                }
                pending.delete(pos);
                sent.add(pos);
            }
        }
    }
    discardChanges() {
        const list = this.root.changes;
        let current = list.next;
        const root = this.root;
        while (current) {
            const next = current.next;
            current.changeTree.endEncode(); // clears changesNode internally
            root.releaseNode(current);
            current = next;
        }
        list.next = undefined;
        list.tail = undefined;
    }
    discardUnreliableChanges() {
        const list = this.root.unreliableChanges;
        let current = list.next;
        const root = this.root;
        while (current) {
            const next = current.next;
            current.changeTree.endEncodeUnreliable(); // clears unreliableChangesNode internally
            root.releaseNode(current);
            current = next;
        }
        list.next = undefined;
        list.tail = undefined;
    }
    tryEncodeTypeId(bytes, baseType, targetType, it) {
        const baseTypeId = this.context.getTypeId(baseType);
        const targetTypeId = this.context.getTypeId(targetType);
        if (targetTypeId === undefined) {
            console.warn(`@colyseus/schema WARNING: Class "${targetType.name}" is not registered on TypeRegistry - Please either tag the class with @entity or define a @type() field.`);
            return;
        }
        if (baseTypeId !== targetTypeId) {
            bytes[it.offset++] = TYPE_ID & 255;
            encode.number(bytes, targetTypeId, it);
        }
    }
    get hasChanges() {
        return this.root.changes.next !== undefined;
    }
    get hasUnreliableChanges() {
        return this.root.unreliableChanges.next !== undefined;
    }
}

function spliceOne(arr, index) {
    // manually splice an array
    if (index === -1 || index >= arr.length) {
        return false;
    }
    const len = arr.length - 1;
    for (let i = index; i < len; i++) {
        arr[i] = arr[i + 1];
    }
    arr.length = len;
    return true;
}

class DecodingWarning extends Error {
    constructor(message) {
        super(message);
        this.name = "DecodingWarning";
    }
}
// Reused across addRef calls — saves a descriptor object per decoded ref.
const $refIdDescriptor = { value: 0, enumerable: false, writable: true };
class ReferenceTracker {
    //
    // Relation of refId => Schema structure
    // For direct access of structures during decoding time.
    //
    refs = new Map();
    refCount = {};
    deletedRefs = new Set();
    callbacks = {};
    nextUniqueId = 0;
    getNextUniqueId() {
        return this.nextUniqueId++;
    }
    // for decoding
    addRef(refId, ref, incrementCount = true) {
        this.refs.set(refId, ref);
        // `enumerable: false` is load-bearing: tests use `deepStrictEqual`
        // on decoded instances, which WOULD walk enumerable Symbol-keyed
        // properties and include `$refId` in the comparison. Keep the
        // descriptor dance for semantic compatibility.
        if (ref[$refId] === undefined) {
            $refIdDescriptor.value = refId;
            Object.defineProperty(ref, $refId, $refIdDescriptor);
        }
        else if (ref[$refId] !== refId) {
            ref[$refId] = refId; // property exists (writable) — plain write keeps flags
        }
        if (incrementCount) {
            this.refCount[refId] = (this.refCount[refId] || 0) + 1;
        }
        if (this.deletedRefs.has(refId)) {
            this.deletedRefs.delete(refId);
        }
    }
    // for decoding
    removeRef(refId) {
        const refCount = this.refCount[refId];
        if (refCount === undefined) {
            try {
                throw new DecodingWarning("trying to remove refId that doesn't exist: " + refId);
            }
            catch (e) {
                console.warn(e);
            }
            return;
        }
        if (refCount === 0) {
            try {
                const ref = this.refs.get(refId);
                throw new DecodingWarning(`trying to remove refId '${refId}' with 0 refCount (${ref.constructor.name}: ${JSON.stringify(ref)})`);
            }
            catch (e) {
                console.warn(e);
            }
            return;
        }
        if ((this.refCount[refId] = refCount - 1) <= 0) {
            this.deletedRefs.add(refId);
        }
    }
    clearRefs() {
        this.refs.clear();
        this.deletedRefs.clear();
        this.callbacks = {};
        this.refCount = {};
    }
    // for decoding
    garbageCollectDeletedRefs() {
        this.deletedRefs.forEach((refId) => {
            //
            // Skip active references.
            //
            if (this.refCount[refId] > 0) {
                return;
            }
            const ref = this.refs.get(refId);
            //
            // Ensure child schema instances have their references removed as well.
            //
            if (ref.constructor[Symbol.metadata] !== undefined) {
                const metadata = ref.constructor[Symbol.metadata];
                for (const index in metadata) {
                    const field = metadata[index].name;
                    const child = ref[field];
                    if (typeof (child) === "object" && child) {
                        const childRefId = child[$refId];
                        if (childRefId !== undefined && !this.deletedRefs.has(childRefId)) {
                            this.removeRef(childRefId);
                        }
                    }
                }
            }
            else {
                if (typeof (ref[$childType]) === "function") {
                    Array.from(ref.values())
                        .forEach((child) => {
                        const childRefId = child[$refId];
                        if (childRefId !== undefined && !this.deletedRefs.has(childRefId)) {
                            this.removeRef(childRefId);
                        }
                    });
                }
            }
            this.refs.delete(refId); // remove ref
            delete this.refCount[refId]; // remove ref count
            delete this.callbacks[refId]; // remove callbacks
        });
        // clear deleted refs.
        this.deletedRefs.clear();
    }
    addCallback(refId, fieldOrOperation, callback) {
        if (refId === undefined) {
            const name = (typeof (fieldOrOperation) === "number")
                ? OPERATION[fieldOrOperation]
                : fieldOrOperation;
            throw new Error(`Can't addCallback on '${name}' (refId is undefined)`);
        }
        if (!this.callbacks[refId]) {
            this.callbacks[refId] = {};
        }
        if (!this.callbacks[refId][fieldOrOperation]) {
            this.callbacks[refId][fieldOrOperation] = [];
        }
        this.callbacks[refId][fieldOrOperation].push(callback);
        return () => this.removeCallback(refId, fieldOrOperation, callback);
    }
    removeCallback(refId, field, callback) {
        const index = this.callbacks?.[refId]?.[field]?.indexOf(callback);
        if (index !== undefined && index !== -1) {
            spliceOne(this.callbacks[refId][field], index);
        }
    }
}

class Decoder {
    context;
    state;
    root;
    currentRefId = 0;
    triggerChanges;
    /**
     * @internal Non-null only while a `decodeResync()` walk is in progress:
     * collection refId → entry identities the payload visited (map string
     * keys; array/set/collection/stream indexes). Written by the collection
     * DecodeOperation functions, read by the post-decode sweep.
     */
    resyncVisited = null;
    /**
     * @internal Set when a structure had to be skipped during a resync
     * decode — visited data is incomplete, so the sweep must not delete.
     */
    resyncDamaged = false;
    constructor(root, context) {
        this.setState(root);
        this.context = context || new TypeContext(root.constructor);
        // console.log(">>>>>>>>>>>>>>>> Decoder types");
        // this.context.schemas.forEach((id, schema) => {
        //     console.log("type:", id, schema.name, Object.keys(schema[Symbol.metadata]));
        // });
    }
    setState(root) {
        this.state = root;
        this.root = new ReferenceTracker();
        this.root.addRef(0, root);
    }
    decode(bytes, it = { offset: 0 }, ref = this.state) {
        // Only allocate a collection array when there's a subscriber. Every
        // decode-op push site uses `allChanges?.push(...)` — optional
        // chaining short-circuits the object literal too, so a listener-
        // free decoder does zero per-field allocation.
        const allChanges = (this.triggerChanges !== undefined)
            ? []
            : null;
        const $root = this.root;
        const totalBytes = bytes.byteLength;
        let decoder = ref['constructor'][$decoder];
        this.currentRefId = 0;
        while (it.offset < totalBytes) {
            //
            // Peek ahead, check if it's a switch to a different structure
            //
            if (bytes[it.offset] == SWITCH_TO_STRUCTURE) {
                it.offset++;
                ref[$onDecodeEnd]?.();
                const nextRefId = decode.number(bytes, it);
                const nextRef = $root.refs.get(nextRefId);
                //
                // Trying to access a reference that haven't been decoded yet.
                //
                if (!nextRef) {
                    // throw new Error(`"refId" not found: ${nextRefId}`);
                    console.error(`"refId" not found: ${nextRefId}`, { previousRef: ref, previousRefId: this.currentRefId });
                    console.warn("Please report this issue to the developers.");
                    this.skipCurrentStructure(bytes, it, totalBytes);
                }
                else {
                    ref = nextRef;
                    decoder = ref.constructor[$decoder];
                    this.currentRefId = nextRefId;
                }
                continue;
            }
            const result = decoder(this, bytes, it, ref, allChanges);
            if (result === DEFINITION_MISMATCH) {
                console.warn("@colyseus/schema: definition mismatch");
                this.skipCurrentStructure(bytes, it, totalBytes);
                continue;
            }
        }
        // Close out the last ref's decode session — mirrors the
        // SWITCH_TO_STRUCTURE block above, which fires it at every
        // intra-loop structure transition. ArraySchema uses this to
        // compact `items` after a tick's deletes. No other consumer
        // currently hooks it; the dual call sites stay as-is rather
        // than being extracted into a helper for a one-line body.
        ref[$onDecodeEnd]?.();
        // resync mode: prune everything the snapshot didn't visit. Runs
        // before triggerChanges (DELETE changes fire onRemove with the real
        // previousValue) and before GC (removeRef feeds deletedRefs).
        if (this.resyncVisited !== null) {
            resyncSweep(this, allChanges);
        }
        // trigger changes
        if (allChanges !== null)
            this.triggerChanges?.(allChanges);
        // drop references of unused schemas
        $root.garbageCollectDeletedRefs();
        return allChanges;
    }
    /**
     * Full-snapshot reconciliation ("resync") decode.
     *
     * Behaves exactly like {@link decode}, plus: every collection entry the
     * payload does NOT mention is removed through the regular DELETE path —
     * `onRemove` callbacks fire with the real previous value and released
     * refs are garbage-collected. Use it to apply a rejoin/reconnect full
     * state over an existing decoded tree: DELETEs that happened while the
     * client was off the wire are reconciled as if they had been received,
     * while surviving entries keep their instance identity and callbacks.
     *
     * ONLY valid for full-snapshot payloads (`encodeAll` / `encodeAllView`
     * output). Calling it on an incremental patch would prune everything
     * the patch doesn't touch.
     */
    decodeResync(bytes, it = { offset: 0 }) {
        this.resyncVisited = new Map();
        this.resyncDamaged = false;
        try {
            return this.decode(bytes, it);
        }
        finally {
            this.resyncVisited = null;
        }
    }
    skipCurrentStructure(bytes, it, totalBytes) {
        // A skipped range can swallow other structures' ops (their ADDs are
        // never applied), so resync visited data is no longer trustworthy.
        if (this.resyncVisited !== null) {
            this.resyncDamaged = true;
        }
        //
        // keep skipping next bytes until reaches a known structure
        // by local decoder.
        //
        const nextIterator = { offset: it.offset };
        while (it.offset < totalBytes) {
            if (bytes[it.offset] === SWITCH_TO_STRUCTURE) {
                nextIterator.offset = it.offset + 1;
                if (this.root.refs.has(decode.number(bytes, nextIterator))) {
                    break;
                }
            }
            it.offset++;
        }
    }
    getInstanceType(bytes, it, defaultType) {
        let type;
        if (bytes[it.offset] === TYPE_ID) {
            it.offset++;
            const type_id = decode.number(bytes, it);
            type = this.context.get(type_id);
        }
        return type || defaultType;
    }
    createInstanceOfType(type) {
        return type.initializeForDecoder();
    }
    removeChildRefs(ref, allChanges) {
        const needRemoveRef = typeof (ref[$childType]) !== "string";
        const refId = ref[$refId];
        ref.forEach((value, key) => {
            allChanges?.push({
                ref: ref,
                refId,
                op: OPERATION.DELETE,
                field: key,
                value: undefined,
                previousValue: value
            });
            if (needRemoveRef) {
                this.root.removeRef(value[$refId]);
            }
        });
    }
}

/**
 * Reflection
 */
/**
 * `t.quantized()` field descriptor as it rides the reflection handshake —
 * schema-typed (bit-exact float64 bounds), NOT a string grammar, so every
 * language port decodes it with the schema decoder it already has.
 */
const QuantizedDescriptor = schema({
    min: t.float64(),
    max: t.float64(),
    bits: t.uint8(),
    mode: t.uint8(), // 0 = clamp, 1 = wrap
}, "QuantizedDescriptor");
const ReflectionField = schema({
    name: t.string(),
    type: t.string(),
    referencedType: t.number(),
    /** Primitive child of a collection (`array`/`map`/... of "string" etc.) —
     *  its own slot, replacing the legacy `"array:string"` colon packing. */
    childPrimitive: t.string(),
    /** Set only on `t.quantized()` fields (`.optional()` — no auto-instantiated
     *  default; its absence is the "not quantized" signal on decode). */
    quantized: t.ref(QuantizedDescriptor).optional(),
}, "ReflectionField");
const ReflectionType = schema({
    id: t.number(),
    extendsId: t.number(),
    fields: t.array(ReflectionField),
}, "ReflectionType");
const Reflection = schema({
    types: t.array(ReflectionType),
    rootType: t.number(),
}, "Reflection");
Reflection.encode = function (encoder, it = { offset: 0 }) {
    const context = encoder.context;
    const reflection = new Reflection();
    const reflectionEncoder = new Encoder(reflection);
    // rootType is usually the first schema passed to the Encoder
    // (unless it inherits from another schema)
    const rootType = context.schemas.get(encoder.state.constructor);
    if (rootType > 0) {
        reflection.rootType = rootType;
    }
    const includedTypeIds = new Set();
    const pendingReflectionTypes = {};
    // add type to reflection in a way that respects inheritance
    // (parent types should be added before their children)
    const addType = (type) => {
        if (type.extendsId === undefined || includedTypeIds.has(type.extendsId)) {
            includedTypeIds.add(type.id);
            reflection.types.push(type);
            const deps = pendingReflectionTypes[type.id];
            if (deps !== undefined) {
                delete pendingReflectionTypes[type.id];
                deps.forEach((childType) => addType(childType));
            }
        }
        else {
            if (pendingReflectionTypes[type.extendsId] === undefined) {
                pendingReflectionTypes[type.extendsId] = [];
            }
            pendingReflectionTypes[type.extendsId].push(type);
        }
    };
    context.schemas.forEach((typeid, klass) => {
        const type = new ReflectionType();
        type.id = Number(typeid);
        // support inheritance
        const inheritFrom = Object.getPrototypeOf(klass);
        if (inheritFrom !== Schema) {
            type.extendsId = context.schemas.get(inheritFrom);
        }
        const metadata = klass[Symbol.metadata];
        //
        // FIXME: this is a workaround for inherited types without additional fields
        // if metadata is the same reference as the parent class - it means the class has no own metadata
        //
        if (metadata !== inheritFrom[Symbol.metadata]) {
            for (const fieldIndex in metadata) {
                const index = Number(fieldIndex);
                const fieldName = metadata[index].name;
                // skip fields from parent classes
                if (!Object.prototype.hasOwnProperty.call(metadata, fieldName)) {
                    continue;
                }
                const reflectionField = new ReflectionField();
                reflectionField.name = fieldName;
                let fieldType;
                const field = metadata[index];
                if (typeof (field.type) === "string") {
                    fieldType = field.type;
                }
                else if (isQuantizedType(field.type)) {
                    // Params ride as a schema-typed descriptor (bit-exact float64) —
                    // no string grammar for the peer (or a language port) to parse.
                    const d = field.type.quantized;
                    fieldType = "quantized";
                    const desc = new QuantizedDescriptor();
                    desc.min = d.min;
                    desc.max = d.max;
                    desc.bits = d.bits;
                    desc.mode = d.wrap ? 1 : 0;
                    reflectionField.quantized = desc;
                }
                else {
                    let childTypeSchema;
                    //
                    // TODO: refactor below.
                    //
                    if (Schema.is(field.type)) {
                        fieldType = "ref";
                        childTypeSchema = field.type;
                    }
                    else {
                        fieldType = Object.keys(field.type)[0];
                        if (typeof (field.type[fieldType]) === "string") {
                            // primitive child gets its own slot (was packed as "array:string")
                            reflectionField.childPrimitive = field.type[fieldType];
                        }
                        else {
                            childTypeSchema = field.type[fieldType];
                        }
                    }
                    reflectionField.referencedType = (childTypeSchema)
                        ? context.getTypeId(childTypeSchema)
                        : -1;
                }
                reflectionField.type = fieldType;
                type.fields.push(reflectionField);
            }
        }
        addType(type);
    });
    // in case there are types that were not added due to inheritance
    for (const typeid in pendingReflectionTypes) {
        pendingReflectionTypes[typeid].forEach((type) => reflection.types.push(type));
    }
    const buf = reflectionEncoder.encodeAll(it);
    return buf.slice(0, it.offset);
};
Reflection.decode = function (bytes, it) {
    const reflection = new Reflection();
    const reflectionDecoder = new Decoder(reflection);
    reflectionDecoder.decode(bytes, it);
    const typeContext = new TypeContext();
    // 1st pass, initialize metadata + inheritance
    reflection.types.forEach((reflectionType) => {
        const parentClass = typeContext.get(reflectionType.extendsId) ?? Schema;
        const schema = class _ extends parentClass {
        };
        // register for inheritance support
        TypeContext.register(schema);
        typeContext.add(schema, reflectionType.id);
    }, {});
    // define fields
    const addFields = (metadata, reflectionType, parentFieldIndex) => {
        reflectionType.fields.forEach((field, i) => {
            const fieldIndex = parentFieldIndex + i;
            if (field.quantized !== undefined) {
                // Schema-typed descriptor → resolved codec (validation stays in
                // resolveQuantize, same as the builder path).
                const q = field.quantized;
                Metadata.addField(metadata, fieldIndex, field.name, {
                    quantized: resolveQuantize({ min: q.min, max: q.max, bits: q.bits, mode: q.mode === 1 ? "wrap" : "clamp" }),
                });
            }
            else if (field.referencedType !== undefined) {
                const fieldType = field.type;
                // Schema child by type id; a primitive child (referencedType -1)
                // rides its own childPrimitive slot.
                const refType = typeContext.get(field.referencedType)
                    ?? field.childPrimitive;
                if (fieldType === "ref") {
                    Metadata.addField(metadata, fieldIndex, field.name, refType);
                }
                else {
                    Metadata.addField(metadata, fieldIndex, field.name, { [fieldType]: refType });
                }
            }
            else {
                Metadata.addField(metadata, fieldIndex, field.name, field.type);
            }
        });
    };
    // 2nd pass, set fields
    reflection.types.forEach((reflectionType) => {
        const schema = typeContext.get(reflectionType.id);
        // for inheritance support
        const metadata = Metadata.initialize(schema);
        const inheritedTypes = [];
        let parentType = reflectionType;
        do {
            inheritedTypes.push(parentType);
            parentType = reflection.types.find((t) => t.id === parentType.extendsId);
        } while (parentType);
        let parentFieldIndex = 0;
        inheritedTypes.reverse().forEach((reflectionType) => {
            // add fields from all inherited classes
            // TODO: refactor this to avoid adding fields from parent classes
            addFields(metadata, reflectionType, parentFieldIndex);
            parentFieldIndex += reflectionType.fields.length;
        });
    });
    const state = new (typeContext.get(reflection.rootType || 0))();
    return new Decoder(state, typeContext);
};
Reflection.makeEncodable = function (ctor) {
    const metadata = ctor[Symbol.metadata];
    if (!metadata)
        return ctor;
    const numFields = metadata[$numFields];
    if (numFields === undefined)
        return ctor;
    // Walk every field index across the inheritance chain. Repeat calls
    // are cheap: defineField overwrites the same descriptor and re-stamps
    // the same `metadata[$encoders]` slot (idempotent).
    for (let i = 0; i <= numFields; i++) {
        const field = metadata[i];
        if (!field)
            continue;
        Metadata.defineField(ctor, metadata, i, field.name, field.type);
    }
    // Invalidate any cached encode descriptor — `getEncodeDescriptor`
    // memoizes on the constructor. If something already constructed it
    // (e.g. a prior `InputEncoder(...)` call that threw), drop the stale
    // entry so the next read sees the upgraded metadata.
    if (Object.prototype.hasOwnProperty.call(ctor, $encodeDescriptor)) {
        delete ctor[$encodeDescriptor];
    }
    return ctor;
};

/**
 * Legacy callback system
 *
 * @param decoder
 * @returns
 */
function getDecoderStateCallbacks(decoder) {
    const $root = decoder.root;
    const callbacks = $root.callbacks;
    const onAddCalls = new WeakMap();
    let currentOnAddCallback;
    decoder.triggerChanges = function (allChanges) {
        const uniqueRefIds = new Set();
        for (let i = 0, l = allChanges.length; i < l; i++) {
            const change = allChanges[i];
            const refId = change.refId;
            const ref = change.ref;
            const $callbacks = callbacks[refId];
            if (!$callbacks) {
                continue;
            }
            //
            // trigger onRemove on child structure.
            //
            if ((change.op & OPERATION.DELETE) === OPERATION.DELETE &&
                Schema.isSchema(change.previousValue)) {
                const deleteCallbacks = callbacks[change.previousValue[$refId]]?.[OPERATION.DELETE];
                for (let i = deleteCallbacks?.length - 1; i >= 0; i--) {
                    deleteCallbacks[i]();
                }
            }
            if (Schema.isSchema(ref)) {
                //
                // Handle schema instance
                //
                if (!uniqueRefIds.has(refId)) {
                    // trigger onChange
                    const replaceCallbacks = $callbacks?.[OPERATION.REPLACE];
                    for (let i = replaceCallbacks?.length - 1; i >= 0; i--) {
                        replaceCallbacks[i]();
                    }
                }
                if ($callbacks.hasOwnProperty(change.field)) {
                    const fieldCallbacks = $callbacks[change.field];
                    for (let i = fieldCallbacks?.length - 1; i >= 0; i--) {
                        fieldCallbacks[i](change.value, change.previousValue);
                    }
                }
            }
            else {
                //
                // Handle collection of items
                //
                if ((change.op & OPERATION.DELETE) === OPERATION.DELETE) {
                    // DELETE can arrive with `previousValue === undefined` in
                    // two legitimate cases — neither is fixable decoder-side:
                    //   1. DELETE_AND_ADD (op byte 192) for an index/refId the
                    //      decoder never held (e.g. a client whose @view
                    //      subscription just began sees the replacement op
                    //      first). The ADD half still fires below.
                    //   2. DELETE_BY_REFID (decodeArray) for a filtered
                    //      ArraySchema ref that was never ADDed on this
                    //      decoder; that push site is unconditional.
                    // The guard prevents `onRemove(undefined, key)` from firing.
                    if (change.previousValue !== undefined) {
                        // triger onRemove
                        const deleteCallbacks = $callbacks[OPERATION.DELETE];
                        for (let i = deleteCallbacks?.length - 1; i >= 0; i--) {
                            deleteCallbacks[i](change.previousValue, change.dynamicIndex ?? change.field);
                        }
                    }
                    // Handle DELETE_AND_ADD operations
                    if ((change.op & OPERATION.ADD) === OPERATION.ADD) {
                        const addCallbacks = $callbacks[OPERATION.ADD];
                        for (let i = addCallbacks?.length - 1; i >= 0; i--) {
                            addCallbacks[i](change.value, change.dynamicIndex ?? change.field);
                        }
                    }
                }
                else if ((change.op & OPERATION.ADD) === OPERATION.ADD &&
                    change.previousValue !== change.value) {
                    // triger onAdd
                    const addCallbacks = $callbacks[OPERATION.ADD];
                    for (let i = addCallbacks?.length - 1; i >= 0; i--) {
                        addCallbacks[i](change.value, change.dynamicIndex ?? change.field);
                    }
                }
                // trigger onChange
                // The `value !== undefined || previousValue !== undefined` half
                // suppresses spurious onChange calls for DELETEs the decoder
                // never had context for — same two cases documented above
                // (DELETE_AND_ADD post-view-grant, DELETE_BY_REFID for unseen
                // refIds), plus the historical "ADD+DELETE collapsed to DELETE
                // on the wire" path now neutralized at the push site.
                if (change.value !== change.previousValue &&
                    (change.value !== undefined || change.previousValue !== undefined)) {
                    const replaceCallbacks = $callbacks[OPERATION.REPLACE];
                    for (let i = replaceCallbacks?.length - 1; i >= 0; i--) {
                        replaceCallbacks[i](change.value, change.dynamicIndex ?? change.field);
                    }
                }
            }
            uniqueRefIds.add(refId);
        }
    };
    function getProxy(metadataOrType, context) {
        let metadata = context.instance?.constructor[Symbol.metadata] || metadataOrType;
        let isCollection = ((context.instance && typeof (context.instance['forEach']) === "function") ||
            (metadataOrType && typeof (metadataOrType[Symbol.metadata]) === "undefined"));
        if (metadata && !isCollection) {
            const onAddListen = function (ref, prop, callback, immediate) {
                // immediate trigger
                if (immediate &&
                    context.instance[prop] !== undefined &&
                    !onAddCalls.has(currentOnAddCallback) // Workaround for https://github.com/colyseus/schema/issues/147
                ) {
                    callback(context.instance[prop], undefined);
                }
                return $root.addCallback(ref[$refId], prop, callback);
            };
            /**
             * Schema instances
             */
            return new Proxy({
                listen: function listen(prop, callback, immediate = true) {
                    if (context.instance) {
                        return onAddListen(context.instance, prop, callback, immediate);
                    }
                    else {
                        // collection instance not received yet
                        let detachCallback = () => { };
                        context.onInstanceAvailable((ref, existing) => {
                            detachCallback = onAddListen(ref, prop, callback, immediate && existing && !onAddCalls.has(currentOnAddCallback));
                        });
                        return () => detachCallback();
                    }
                },
                onChange: function onChange(callback) {
                    return $root.addCallback(context.instance[$refId], OPERATION.REPLACE, callback);
                },
                //
                // TODO: refactor `bindTo()` implementation.
                // There is room for improvement.
                //
                bindTo: function bindTo(targetObject, properties) {
                    if (!properties) {
                        properties = Object.keys(metadata).map((index) => metadata[index].name);
                    }
                    return $root.addCallback(context.instance[$refId], OPERATION.REPLACE, () => {
                        properties.forEach((prop) => targetObject[prop] = context.instance[prop]);
                    });
                }
            }, {
                get(target, prop) {
                    const metadataField = metadata[metadata[prop]];
                    if (metadataField) {
                        const instance = context.instance?.[prop];
                        const onInstanceAvailable = ((callback) => {
                            const unbind = $(context.instance).listen(prop, (value, _) => {
                                callback(value, false);
                                // FIXME: by "unbinding" the callback here,
                                // it will not support when the server
                                // re-instantiates the instance.
                                //
                                unbind?.();
                            }, false);
                            // has existing value
                            if (instance?.[$refId] !== undefined) {
                                callback(instance, true);
                            }
                        });
                        return getProxy(metadataField.type, {
                            // make sure refId is available, otherwise need to wait for the instance to be available.
                            instance: (instance?.[$refId] !== undefined && instance),
                            parentInstance: context.instance,
                            onInstanceAvailable,
                        });
                    }
                    else {
                        // accessing the function
                        return target[prop];
                    }
                },
                has(target, prop) { return metadata[prop] !== undefined; },
                set(_, _1, _2) { throw new Error("not allowed"); },
                deleteProperty(_, _1) { throw new Error("not allowed"); },
            });
        }
        else {
            /**
             * Collection instances
             */
            const onAdd = function (ref, callback, immediate) {
                // Trigger callback on existing items
                if (immediate) {
                    ref.forEach((v, k) => callback(v, k));
                }
                return $root.addCallback(ref[$refId], OPERATION.ADD, (value, key) => {
                    onAddCalls.set(callback, true);
                    currentOnAddCallback = callback;
                    callback(value, key);
                    onAddCalls.delete(callback);
                    currentOnAddCallback = undefined;
                });
            };
            const onRemove = function (ref, callback) {
                return $root.addCallback(ref[$refId], OPERATION.DELETE, callback);
            };
            const onChange = function (ref, callback) {
                return $root.addCallback(ref[$refId], OPERATION.REPLACE, callback);
            };
            return new Proxy({
                onAdd: function (callback, immediate = true) {
                    //
                    // https://github.com/colyseus/schema/issues/147
                    // If parent instance has "onAdd" registered, avoid triggering immediate callback.
                    //
                    if (context.instance) {
                        return onAdd(context.instance, callback, immediate && !onAddCalls.has(currentOnAddCallback));
                    }
                    else if (context.onInstanceAvailable) {
                        // collection instance not received yet
                        let detachCallback = () => { };
                        context.onInstanceAvailable((ref, existing) => {
                            detachCallback = onAdd(ref, callback, immediate && existing && !onAddCalls.has(currentOnAddCallback));
                        });
                        return () => detachCallback();
                    }
                },
                onRemove: function (callback) {
                    if (context.instance) {
                        return onRemove(context.instance, callback);
                    }
                    else if (context.onInstanceAvailable) {
                        // collection instance not received yet
                        let detachCallback = () => { };
                        context.onInstanceAvailable((ref) => {
                            detachCallback = onRemove(ref, callback);
                        });
                        return () => detachCallback();
                    }
                },
                onChange: function (callback) {
                    if (context.instance) {
                        return onChange(context.instance, callback);
                    }
                    else if (context.onInstanceAvailable) {
                        // collection instance not received yet
                        let detachCallback = () => { };
                        context.onInstanceAvailable((ref) => {
                            detachCallback = onChange(ref, callback);
                        });
                        return () => detachCallback();
                    }
                },
            }, {
                get(target, prop) {
                    if (!target[prop]) {
                        throw new Error(`Can't access '${prop}' through callback proxy. access the instance directly.`);
                    }
                    return target[prop];
                },
                has(target, prop) { return target[prop] !== undefined; },
                set(_, _1, _2) { throw new Error("not allowed"); },
                deleteProperty(_, _1) { throw new Error("not allowed"); },
            });
        }
    }
    function $(instance) {
        return getProxy(undefined, { instance });
    }
    return $;
}

function getRawChangesCallback(decoder, callback) {
    decoder.triggerChanges = callback;
}

class StateCallbackStrategy {
    decoder;
    uniqueRefIds = new Set();
    isTriggering = false;
    constructor(decoder) {
        this.decoder = decoder;
        this.decoder.triggerChanges = this.triggerChanges.bind(this);
    }
    get callbacks() {
        return this.decoder.root.callbacks;
    }
    get state() {
        return this.decoder.state;
    }
    addCallback(refId, operationOrProperty, handler) {
        const $root = this.decoder.root;
        return $root.addCallback(refId, operationOrProperty, handler);
    }
    addCallbackOrWaitCollectionAvailable(instance, propertyName, operation, handler, immediate = true) {
        let removeHandler = () => { };
        const removeOnAdd = () => removeHandler();
        const collection = instance[propertyName];
        // Collection not available yet. Listen for its availability before attaching the handler.
        if (!collection || collection[$refId] === undefined) {
            let removePropertyCallback;
            removePropertyCallback = this.addCallback(instance[$refId], propertyName, (value, _) => {
                if (value !== null && value !== undefined) {
                    // Remove the property listener now that collection is available
                    removePropertyCallback();
                    removeHandler = this.addCallback(value[$refId], operation, handler);
                }
            });
            removeHandler = removePropertyCallback;
            return removeOnAdd;
        }
        else {
            //
            // Call immediately if collection is already available, if it's an ADD operation.
            //
            immediate = immediate && this.isTriggering === false;
            if (operation === OPERATION.ADD && immediate) {
                collection.forEach((value, key) => {
                    handler(value, key);
                });
            }
            return this.addCallback(collection[$refId], operation, handler);
        }
    }
    listen(...args) {
        if (typeof args[0] === 'string') {
            // listen(property, handler, immediate?)
            return this.listenInstance(this.state, args[0], args[1], args[2]);
        }
        else {
            // listen(instance, property, handler, immediate?)
            return this.listenInstance(args[0], args[1], args[2], args[3]);
        }
    }
    listenInstance(instance, propertyName, handler, immediate = true) {
        immediate = immediate && this.isTriggering === false;
        //
        // Call handler immediately if property is already available.
        //
        const currentValue = instance[propertyName];
        if (immediate && currentValue !== null && currentValue !== undefined) {
            handler(currentValue, undefined);
        }
        return this.addCallback(instance[$refId], propertyName, handler);
    }
    onChange(...args) {
        if (args.length === 2 && typeof args[0] !== 'string') {
            // onChange(instance, handler) - instance change
            const instance = args[0];
            const handler = args[1];
            return this.addCallback(instance[$refId], OPERATION.REPLACE, handler);
        }
        if (typeof args[0] === 'string') {
            // onChange(property, handler) - collection on root state
            return this.addCallbackOrWaitCollectionAvailable(this.state, args[0], OPERATION.REPLACE, args[1]);
        }
        else {
            // onChange(instance, property, handler) - nested collection
            return this.addCallbackOrWaitCollectionAvailable(args[0], args[1], OPERATION.REPLACE, args[2]);
        }
    }
    onAdd(...args) {
        if (typeof args[0] === 'string') {
            // onAdd(property, handler, immediate?) - collection on root state
            return this.addCallbackOrWaitCollectionAvailable(this.state, args[0], OPERATION.ADD, args[1], args[2] !== false);
        }
        else {
            // onAdd(instance, property, handler, immediate?) - nested collection
            return this.addCallbackOrWaitCollectionAvailable(args[0], args[1], OPERATION.ADD, args[2], args[3] !== false);
        }
    }
    onRemove(...args) {
        if (typeof args[0] === 'string') {
            // onRemove(property, handler) - collection on root state
            return this.addCallbackOrWaitCollectionAvailable(this.state, args[0], OPERATION.DELETE, args[1]);
        }
        else {
            // onRemove(instance, property, handler) - nested collection
            return this.addCallbackOrWaitCollectionAvailable(args[0], args[1], OPERATION.DELETE, args[2]);
        }
    }
    /**
     * Bind properties from a Schema instance to a target object.
     * Changes will be automatically reflected on the target object.
     */
    bindTo(from, to, properties, immediate = true) {
        const metadata = from.constructor[Symbol.metadata];
        // If no properties specified, bind all properties
        if (!properties) {
            properties = Object.keys(metadata)
                .filter(key => !isNaN(Number(key)))
                .map((index) => metadata[index].name);
        }
        const action = () => {
            for (const prop of properties) {
                const fromValue = from[prop];
                if (fromValue !== undefined) {
                    to[prop] = fromValue;
                }
            }
        };
        if (immediate) {
            action();
        }
        return this.addCallback(from[$refId], OPERATION.REPLACE, action);
    }
    triggerChanges(allChanges) {
        this.uniqueRefIds.clear();
        // Flag stays set for the whole dispatch pass — any `listen()` /
        // `onAdd(...)` registered while a callback is firing needs to
        // suppress its immediate-trigger. One toggle per pass is enough;
        // every callback invocation below is wrapped in try/catch so
        // nothing bubbles out to leave the flag stuck.
        this.isTriggering = true;
        for (let i = 0, l = allChanges.length; i < l; i++) {
            const change = allChanges[i];
            const refId = change.refId;
            const ref = change.ref;
            const $callbacks = this.callbacks[refId];
            if (!$callbacks) {
                continue;
            }
            //
            // trigger onRemove on child structure.
            //
            if ((change.op & OPERATION.DELETE) === OPERATION.DELETE &&
                Schema.isSchema(change.previousValue)) {
                const childRefId = change.previousValue[$refId];
                const deleteCallbacks = this.callbacks[childRefId]?.[OPERATION.DELETE];
                if (deleteCallbacks) {
                    for (let j = deleteCallbacks.length - 1; j >= 0; j--) {
                        try {
                            deleteCallbacks[j]();
                        }
                        catch (e) {
                            console.error(e);
                        }
                    }
                }
            }
            if (Schema.isSchema(ref)) {
                //
                // Handle Schema instance
                //
                if (!this.uniqueRefIds.has(refId)) {
                    // trigger onChange
                    const replaceCallbacks = $callbacks[OPERATION.REPLACE];
                    if (replaceCallbacks) {
                        for (let j = replaceCallbacks.length - 1; j >= 0; j--) {
                            try {
                                replaceCallbacks[j]();
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                }
                // trigger field callbacks
                const fieldCallbacks = $callbacks[change.field];
                if (fieldCallbacks) {
                    for (let j = fieldCallbacks.length - 1; j >= 0; j--) {
                        try {
                            fieldCallbacks[j](change.value, change.previousValue);
                        }
                        catch (e) {
                            console.error(e);
                        }
                    }
                }
            }
            else {
                //
                // Handle collection of items
                //
                const dynamicIndex = change.dynamicIndex ?? change.field;
                if ((change.op & OPERATION.DELETE) === OPERATION.DELETE) {
                    // DELETE can arrive with `previousValue === undefined` in two
                    // legitimate cases — neither is fixable decoder-side:
                    //   1. DELETE_AND_ADD (op byte 192) for an index/refId the
                    //      decoder never held — e.g. a client whose @view
                    //      subscription just began sees the replacement op
                    //      first. `previousValue` is undefined; `value` is the
                    //      newly-decoded instance. The ADD half still fires below.
                    //   2. DELETE_BY_REFID (decodeArray, DecodeOperation.ts) for
                    //      a filtered ArraySchema ref that was never ADDed on
                    //      this decoder. That push site is unconditional because
                    //      `removeRef` has already run; raw-change observers
                    //      still want the event even with unknown previousValue.
                    // The guard prevents `onRemove(undefined, key)` from firing.
                    if (change.previousValue !== undefined) {
                        // trigger onRemove (value, key)
                        const deleteCallbacks = $callbacks[OPERATION.DELETE];
                        if (deleteCallbacks) {
                            for (let j = deleteCallbacks.length - 1; j >= 0; j--) {
                                try {
                                    deleteCallbacks[j](change.previousValue, dynamicIndex);
                                }
                                catch (e) {
                                    console.error(e);
                                }
                            }
                        }
                    }
                    // Handle DELETE_AND_ADD operation
                    if ((change.op & OPERATION.ADD) === OPERATION.ADD) {
                        const addCallbacks = $callbacks[OPERATION.ADD];
                        if (addCallbacks) {
                            for (let j = addCallbacks.length - 1; j >= 0; j--) {
                                try {
                                    addCallbacks[j](change.value, dynamicIndex);
                                }
                                catch (e) {
                                    console.error(e);
                                }
                            }
                        }
                    }
                }
                else if ((change.op & OPERATION.ADD) === OPERATION.ADD &&
                    change.previousValue !== change.value) {
                    // trigger onAdd (value, key)
                    const addCallbacks = $callbacks[OPERATION.ADD];
                    if (addCallbacks) {
                        for (let j = addCallbacks.length - 1; j >= 0; j--) {
                            try {
                                addCallbacks[j](change.value, dynamicIndex);
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                }
                // trigger onChange (key, value)
                if (change.value !== change.previousValue) {
                    const replaceCallbacks = $callbacks[OPERATION.REPLACE];
                    if (replaceCallbacks) {
                        for (let j = replaceCallbacks.length - 1; j >= 0; j--) {
                            try {
                                replaceCallbacks[j](dynamicIndex, change.value);
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                }
            }
            this.uniqueRefIds.add(refId);
        }
        this.isTriggering = false;
    }
}
/**
 * Factory class for retrieving the callbacks API.
 */
const Callbacks = {
    /**
     * Get the new callbacks standard API.
     *
     * Usage:
     * ```ts
     * const callbacks = Callbacks.get(roomOrDecoder);
     *
     * // Listen to property changes
     * callbacks.listen("currentTurn", (currentValue, previousValue) => { ... });
     *
     * // Listen to collection additions
     * callbacks.onAdd("entities", (entity, sessionId) => {
     *     // Nested property listening
     *     callbacks.listen(entity, "hp", (currentHp, previousHp) => { ... });
     * });
     *
     * // Listen to collection removals
     * callbacks.onRemove("entities", (entity, sessionId) => { ... });
     *
     * // Listen to any property change on an instance
     * callbacks.onChange(entity, () => { ... });
     *
     * // Bind properties to another object
     * callbacks.bindTo(player, playerVisual);
     * ```
     *
     * @param roomOrDecoder - Room or Decoder instance to get the callbacks for.
     * @returns the new callbacks standard API.
     */
    get(roomOrDecoder) {
        if (roomOrDecoder instanceof Decoder) {
            return new StateCallbackStrategy(roomOrDecoder);
        }
        else if ('decoder' in roomOrDecoder.serializer) {
            return new StateCallbackStrategy(roomOrDecoder.serializer.decoder);
        }
        else {
            throw new Error('Invalid room or decoder');
        }
    },
    /**
     * Get the legacy callbacks API.
     *
     * We aim to deprecate this API on 1.0, and iterate on improving Callbacks.get() API.
     *
     * @param roomOrDecoder - Room or Decoder instance to get the legacy callbacks for.
     * @returns the legacy callbacks API.
     */
    getLegacy(roomOrDecoder) {
        if (roomOrDecoder instanceof Decoder) {
            return getDecoderStateCallbacks(roomOrDecoder);
        }
        else if ('decoder' in roomOrDecoder.serializer) {
            return getDecoderStateCallbacks(roomOrDecoder.serializer.decoder);
        }
        throw new Error('Invalid room or decoder');
    },
    getRawChanges(decoder, callback) {
        return getRawChangesCallback(decoder, callback);
    }
};

/**
 * Object pool for Schema instances. Exported as a **type only** — construct one
 * via {@link createPool}, which is the public entry point. The class is public
 * for typing (`SchemaPool<Entity>` annotations) and `instanceof` checks.
 */
class SchemaPool {
    _free = [];
    _factory;
    _maxSize;
    constructor(factory, opts = {}) {
        this._factory = factory;
        this._maxSize = opts.maxSize ?? Infinity;
        const preallocate = opts.preallocate ?? 0;
        for (let i = 0; i < preallocate; i++) {
            this._free.push(factory());
        }
    }
    /** Pop a pre-reset free instance, or construct a fresh one. */
    acquire() {
        return this._free.length > 0 ? this._free.pop() : this._factory();
    }
    /**
     * Reset `instance` to construction defaults and return it to the pool.
     * PRECONDITION: the instance must already be detached from the state tree
     * (removed from its parent collection/field, so the encoder released it).
     */
    release(instance) {
        Schema.reset(instance);
        if (this._free.length < this._maxSize) {
            this._free.push(instance);
        }
    }
    /** Number of instances currently available for reuse. */
    get size() {
        return this._free.length;
    }
}
/** Convenience factory: `createPool(Entity, { preallocate: 64 })`. */
function createPool(ctor, opts = {}) {
    return new SchemaPool(() => new ctor(), opts);
}

/**
 * Clear the bit for `(slot, bit)` on every ChangeTree in `root`. Called
 * from `dispose()` and from the FinalizationRegistry callback so a view's
 * leftover visibility bits don't leak to whoever next acquires its ID.
 *
 * Cost: O(N trees) per dispose. dispose is rare (once per view lifecycle,
 * typically once per client disconnect), so the per-tick encode hot path
 * is unaffected.
 */
function _clearViewBitFromAllTrees(root, slot, bit) {
    const clearMask = ~bit;
    const trees = root.changeTrees;
    for (const refId in trees) {
        const tree = trees[refId];
        const v = tree.visibleViews;
        if (v !== undefined && slot < v.length)
            v[slot] &= clearMask;
        const i = tree.invisibleViews;
        if (i !== undefined && slot < i.length)
            i[slot] &= clearMask;
        const s = tree.subscribedViews;
        if (s !== undefined && slot < s.length)
            s[slot] &= clearMask;
        const t = tree.tagViews;
        if (t !== undefined) {
            t.forEach((bitmap) => {
                if (slot < bitmap.length)
                    bitmap[slot] &= clearMask;
            });
        }
    }
}
/**
 * `FinalizationRegistry` returns a view's ID to its Root's freelist AND
 * clears the view's leftover bits from every ChangeTree. Backstop for
 * forgotten `view.dispose()` calls; timing is non-deterministic but bounded.
 */
const _disposeRegistry = new FinalizationRegistry(({ root, id, slot, bit }) => {
    _clearViewBitFromAllTrees(root, slot, bit);
    root.releaseViewId(id);
});
class StateView {
    iterable;
    /**
     * Iterable list of items that are visible to this view
     * (Available only if constructed with `iterable: true`)
     */
    items;
    /**
     * Unique ID assigned by the Root that owns this view's encoder. Used
     * to address per-StateView visibility bits stored on each ChangeTree.
     * Lazily allocated on first `add()` because the StateView itself
     * doesn't know its Root until then.
     */
    id = -1;
    _root;
    /** Cached `id >> 5` and `1 << (id & 31)` for the hot encode-loop check. */
    _slot = 0;
    _bit = 0;
    /**
     * Per-tree custom-tag membership lives on each ChangeTree's `tagViews`
     * map (keyed by tag, value is a per-view bitmap). The StateView only
     * needs its slot/bit pair to read/write it. Replaces the legacy
     * `tags: WeakMap<ChangeTree, Set<number>>` allocation per (view, tree).
     */
    /**
     * Manual "ADD" operations for changes per ChangeTree, specific to this view.
     * (Used to force encoding a property even if it was not changed.)
     *
     * Inner storage is a Map so the encode loop in `encodeView` can iterate
     * directly with numeric keys — the legacy `{[index]: OPERATION}` shape
     * forced an `Object.keys(...)` allocation + `Number(key)` parse per ref.
     */
    changes = new Map();
    constructor(iterable = false) {
        this.iterable = iterable;
        if (iterable) {
            this.items = [];
        }
    }
    /**
     * Lazily bind this view to a Root and acquire a view ID. Called on
     * the first add() because StateView is constructed before its target
     * Root is known.
     */
    _bindRoot(root) {
        if (this._root !== undefined)
            return;
        this._root = root;
        this.id = root.acquireViewId();
        this._slot = this.id >> 5;
        this._bit = 1 << (this.id & 31);
        root.registerView(this);
        _disposeRegistry.register(this, { root, id: this.id, slot: this._slot, bit: this._bit }, this);
    }
    /**
     * Release this view's ID back to the Root for reuse, AND clear all
     * visibility bits this view set on any ChangeTree. The clear is
     * essential — without it, a future view that acquires this same ID
     * would inherit our visibility state and see things it shouldn't
     * (privacy bug). Documented in StateViewInternals.test.ts.
     *
     * Optional API but strongly recommended on client-leave; otherwise
     * the FinalizationRegistry backstop runs at GC (non-deterministic).
     */
    dispose() {
        if (this._root === undefined)
            return;
        this._root.unregisterView(this);
        _clearViewBitFromAllTrees(this._root, this._slot, this._bit);
        this._root.releaseViewId(this.id);
        _disposeRegistry.unregister(this);
        this._root = undefined;
        this.id = -1;
    }
    // ──────────────────────────────────────────────────────────────────
    // Per-tree visibility bitmap helpers. Replace the old WeakSet ops
    // with O(1) bitwise ops on a chunked number[] stored on each tree.
    // ──────────────────────────────────────────────────────────────────
    /** True iff this view can see `tree`. */
    isVisible(tree) {
        const arr = tree.visibleViews;
        const slot = this._slot;
        return arr !== undefined && slot < arr.length && (arr[slot] & this._bit) !== 0;
    }
    /** Mark `tree` as visible to this view. */
    markVisible(tree) {
        const slot = this._slot;
        let arr = tree.visibleViews;
        if (arr === undefined) {
            arr = tree.visibleViews = [];
        }
        while (arr.length <= slot)
            arr.push(0);
        arr[slot] |= this._bit;
    }
    /** Clear visibility bit. */
    unmarkVisible(tree) {
        const arr = tree.visibleViews;
        if (arr === undefined)
            return;
        const slot = this._slot;
        if (slot < arr.length)
            arr[slot] &= ~this._bit;
    }
    /** True iff this view is subscribed to `tree`. */
    isSubscribed(tree) {
        const arr = tree.subscribedViews;
        const slot = this._slot;
        return arr !== undefined && slot < arr.length && (arr[slot] & this._bit) !== 0;
    }
    /** Set the subscription bit on `tree`. */
    _setSubscribed(tree) {
        const slot = this._slot;
        let arr = tree.subscribedViews;
        if (arr === undefined) {
            arr = tree.subscribedViews = [];
        }
        while (arr.length <= slot)
            arr.push(0);
        arr[slot] |= this._bit;
    }
    /** Clear the subscription bit on `tree`. */
    _clearSubscribed(tree) {
        const arr = tree.subscribedViews;
        if (arr === undefined)
            return;
        const slot = this._slot;
        if (slot < arr.length)
            arr[slot] &= ~this._bit;
    }
    /** True iff this view has previously marked `tree` as invisible. */
    isInvisible(tree) {
        const arr = tree.invisibleViews;
        const slot = this._slot;
        return arr !== undefined && slot < arr.length && (arr[slot] & this._bit) !== 0;
    }
    /** Mark `tree` as invisible to this view (used by encode loop). */
    markInvisible(tree) {
        const slot = this._slot;
        let arr = tree.invisibleViews;
        if (arr === undefined) {
            arr = tree.invisibleViews = [];
        }
        while (arr.length <= slot)
            arr.push(0);
        arr[slot] |= this._bit;
    }
    /** Clear invisible bit. */
    unmarkInvisible(tree) {
        const arr = tree.invisibleViews;
        if (arr === undefined)
            return;
        const slot = this._slot;
        if (slot < arr.length)
            arr[slot] &= ~this._bit;
    }
    // ──────────────────────────────────────────────────────────────────
    // Per-tag, per-view bitmap. Replaces the legacy
    // `tags: WeakMap<ChangeTree, Set<number>>` storage. Hot read site is
    // `Schema.ts` filter check — `hasTagOnTree` is O(1) bitwise.
    // ──────────────────────────────────────────────────────────────────
    /**
     * True iff this view shares at least one tag bit with `tree`.
     *
     * `tagViews` is keyed by individual power-of-two bits (custom tags must
     * be powers of two; `@view(A|B)` field masks are decomposed on store).
     * A field whose mask is `tag` is visible if the view was `add()`ed with
     * any overlapping bit — so we walk `tag`'s set bits and return on the
     * first match. Passing DEFAULT_VIEW_TAG (-1, all bits) answers "does
     * this view hold ANY custom tag on the tree".
     */
    hasTagOnTree(tree, tag) {
        const map = tree.tagViews;
        if (map === undefined)
            return false;
        const slot = this._slot;
        const bit = this._bit;
        for (let bits = tag; bits !== 0; bits &= bits - 1) {
            const arr = map.get(bits & -bits); // isolate lowest set bit
            if (arr !== undefined && slot < arr.length && (arr[slot] & bit) !== 0)
                return true;
        }
        return false;
    }
    /** Mark `tree` as carrying `tag` (each of its bits) for this view. */
    addTag(tree, tag) {
        // DEFAULT_VIEW_TAG visibility lives in `visibleViews`, not here.
        if (tag === DEFAULT_VIEW_TAG)
            return;
        let map = tree.tagViews;
        if (map === undefined) {
            map = tree.tagViews = new Map();
        }
        const slot = this._slot;
        const bit = this._bit;
        for (let bits = tag; bits > 0; bits &= bits - 1) {
            const b = bits & -bits; // isolate lowest set bit
            let arr = map.get(b);
            if (arr === undefined) {
                arr = [];
                map.set(b, arr);
            }
            while (arr.length <= slot)
                arr.push(0);
            arr[slot] |= bit;
        }
    }
    /** Clear each of `tag`'s bits for this view on `tree`. */
    removeTag(tree, tag) {
        if (tag === DEFAULT_VIEW_TAG)
            return;
        const map = tree.tagViews;
        if (map === undefined)
            return;
        const slot = this._slot;
        const clearMask = ~this._bit;
        for (let bits = tag; bits > 0; bits &= bits - 1) {
            const arr = map.get(bits & -bits);
            if (arr !== undefined && slot < arr.length)
                arr[slot] &= clearMask;
        }
    }
    /** Clear ALL tag bits this view holds on `tree` (used when the per-tag isn't known). */
    removeAllTagsOnTree(tree) {
        const map = tree.tagViews;
        if (map === undefined)
            return;
        const slot = this._slot;
        const clearMask = ~this._bit;
        map.forEach((arr) => {
            if (slot < arr.length)
                arr[slot] &= clearMask;
        });
    }
    // TODO: allow to set multiple tags at once
    add(obj, tag = DEFAULT_VIEW_TAG, checkIncludeParent = true) {
        return this._add(obj, tag, checkIncludeParent, /* _skipStreamRouting */ false);
    }
    /**
     * Internal: force-ship an object through `view.changes` without
     * applying stream-element routing. Called by `Encoder._emitStreamPriority`
     * when it's draining `_pendingByView` — the element is already out of
     * pending at that point, so re-routing back into pending would be a
     * loop. User code should always call `add()`.
     */
    _addImmediate(obj, tag = DEFAULT_VIEW_TAG) {
        this._add(obj, tag, /* checkIncludeParent */ true, /* _skipStreamRouting */ true);
    }
    _add(obj, tag, checkIncludeParent, _skipStreamRouting) {
        const changeTree = obj?.[$changes];
        const parentChangeTree = changeTree.parent;
        if (!changeTree) {
            console.warn("StateView#add(), invalid object:", obj);
            return false;
        }
        else if (!parentChangeTree &&
            obj[$refId] !== 0 // allow root object
        ) {
            /**
             * Detached adds are refused: addParentOf() walks the parent
             * chain to propagate visibility upward, which requires a real
             * parent reference. A detached instance has neither a parent
             * ChangeTree nor a parentIndex, so we can't decide whether an
             * ancestor carries a @view tag that should bring the subtree
             * along. Users must assign the ref into the state tree before
             * calling view.add().
             */
            throw new Error(`Cannot add a detached instance to the StateView. Make sure to assign the "${changeTree.ref.constructor.name}" instance to the state before calling view.add()`);
        }
        // Bind to Root + acquire view ID on first add(). Until then, we have
        // no per-tree bit position to write into.
        if (this._root === undefined && changeTree.root !== undefined) {
            this._bindRoot(changeTree.root);
        }
        // Streamable-element routing: when `obj` is a child of a streamable
        // collection (StreamSchema element, or an entry in a .stream()
        // MapSchema), subscribe this element to the stream's per-view
        // pending. The element is NOT marked visible here — visibility is
        // flipped on by the encoder's priority pass (`_addImmediate`) when
        // it actually ships the element. This is load-bearing: if the
        // element were visible before the priority pass, `encodeAllView`
        // would full-sync-emit it on bootstrap and `encodeView`'s normal
        // pass would emit its dirty state — both bypass `maxPerTick`.
        //
        // StateView mode is imperative by design — users call
        // `view.add(entity)` per-entity as the game loop's AOI / interest
        // logic discovers visibility. This matches the rationale that led
        // to StateView in the first place: per-client visibility as a
        // game-loop-cadence operation, not an encode-time predicate.
        const parentStreamTree = parentChangeTree?.[$changes];
        if (!_skipStreamRouting && parentStreamTree?.isStreamCollection) {
            streamEnqueueForView(parentChangeTree, this.id, changeTree.parentIndex);
            return true;
        }
        // Collection types (ArraySchema / MapSchema / etc.) have no
        // `Symbol.metadata` — `metadata` is undefined here and consumers
        // below use `metadata?.[...]` null-safe access. Only Schema
        // subclasses yield a real Metadata object.
        const metadata = obj.constructor[Symbol.metadata];
        this.markVisible(changeTree);
        // add to iterable list (only the explicitly added items)
        if (this.iterable && checkIncludeParent) {
            this.items.push(obj);
        }
        // add parent ChangeTree's
        // - if it was invisible to this view
        // - if it were previously filtered out
        if (checkIncludeParent && parentChangeTree) {
            this.addParentOf(changeTree, tag);
        }
        // Streamable-collection (the stream itself, not an element): mark
        // visible only. No auto-seed of elements — users must explicitly
        // `view.add(entity)` per element (see rationale above).
        if (!_skipStreamRouting && changeTree.isStreamCollection) {
            return true;
        }
        // Fast path: fresh (isNew) subtree added with default tag. The
        // shared encode pass walks the whole subtree and emits ADDs for
        // every field, so the view pass only needs visibility bits — no
        // `view.changes` entries are needed for this subtree itself.
        // `addParentOf` above already emitted the parent collection's
        // ADD. Skipping the full `_add` cascade avoids ~N empty Map
        // allocations per bootstrap where N = descendant count.
        //
        // Safe against the insertion-order invariant below because this
        // path performs no writes — there is no order to preserve.
        if (tag === DEFAULT_VIEW_TAG && changeTree.isNew) {
            this._markSubtreeVisible(changeTree, tag);
            return false;
        }
        // Insertion order here is load-bearing: the encoder drains
        // `view.changes` in Map iteration order, and the decoder needs the
        // parent's SWITCH_TO_STRUCTURE to register its refId before any
        // entries for nested refs arrive. `forEachChild` below recurses
        // into `this.add(child, ...)`, which inserts child refIds — if we
        // deferred this insert past that point, children would be emitted
        // first and the decoder would see "refId not found".
        let changes = this.changes.get(obj[$refId]);
        if (changes === undefined) {
            changes = new Map();
            this.changes.set(obj[$refId], changes);
        }
        let isChildAdded = false;
        //
        // Add children of this ChangeTree first.
        // If successful, we must link the current ChangeTree to the child.
        //
        // Read per-field tags from the class's precomputed `tags[]` array
        // rather than chasing `metadata[index].tag` — same source, but a
        // direct array index instead of a per-field-object hop.
        const tags = changeTree.encDescriptor.tags;
        changeTree.forEachChild((change, index) => {
            // Do not ADD children whose field tag shares no bit with `tag`.
            // DEFAULT_VIEW_TAG fields are visible to all clients; custom-tag
            // fields only when bits overlap, and never to default-tag clients.
            const fieldTag = tags[index];
            if (fieldTag !== undefined) {
                const tagMatch = fieldTag === DEFAULT_VIEW_TAG ||
                    (tag !== DEFAULT_VIEW_TAG && (fieldTag & tag) !== 0);
                if (!tagMatch) {
                    return;
                }
            }
            if (this.add(change.ref, tag, false)) {
                isChildAdded = true;
            }
        });
        // set tag
        if (tag !== DEFAULT_VIEW_TAG) {
            this.addTag(changeTree, tag);
            // Ref: add tagged properties. `$fieldIndexesByViewTag` is keyed
            // per-bit, so a combined add-tag (`view.add(obj, A|B)`) must look
            // up each set bit to force-ADD every field that shares a bit.
            const byTag = metadata?.[$fieldIndexesByViewTag];
            if (byTag !== undefined) {
                for (let bits = tag; bits > 0; bits &= bits - 1) {
                    byTag[bits & -bits]?.forEach((index) => {
                        if (changeTree.getChange(index) !== OPERATION.DELETE) {
                            changes.set(index, OPERATION.ADD);
                        }
                    });
                }
            }
        }
        else if (!changeTree.isNew || isChildAdded) {
            // new structures will be added as part of .encode() call, no need to force it to .encodeView()
            const isInvisible = this.isInvisible(changeTree);
            // Full-sync snapshot: walk the live ref structurally instead of
            // iterating a cumulative recorder bucket. Every populated index
            // is emitted as ADD (matching the op-coercion previously done
            // at encode time). Per-field tags come from the descriptor's
            // precomputed `tags[]` array — direct index vs a metadata[i].tag
            // object hop.
            const tags = changeTree.encDescriptor.tags;
            changeTree.forEachLive((index) => {
                const tagAtIndex = tags[index];
                if (isInvisible || // if "invisible", include all
                    tagAtIndex === undefined || // "all change" with no tag
                    tagAtIndex === DEFAULT_VIEW_TAG || // visible to all clients
                    (tag !== DEFAULT_VIEW_TAG && (tagAtIndex & tag) !== 0) // tag bits overlap
                ) {
                    changes.set(index, OPERATION.ADD);
                    isChildAdded = true;
                }
            });
        }
        return isChildAdded;
    }
    /**
     * Walk an isNew subtree marking each descendant visible. Counterpart
     * to the `_add()` fast path: skips `view.changes` allocations because
     * the shared encode pass emits the whole fresh subtree structurally
     * — the view pass just needs visibility bits to let those emissions
     * through the per-tree filter.
     *
     * Preserves the `@view()`-tag filter from `_add`'s forEachChild: a
     * Schema descendant behind a non-matching field tag is skipped so
     * tagged fields don't leak into a default-tag view. Collections have
     * no per-field tags (`encDescriptor.tags` is empty), so the filter
     * is a no-op for collection children.
     *
     * If a descendant has `isNew=false` (rare: a detached sub-collection
     * was re-attached to a fresh parent), fall back to the full `_add`
     * path for that branch so its cumulative state is emitted correctly.
     */
    _markSubtreeVisible(tree, tag) {
        const tags = tree.encDescriptor.tags;
        tree.forEachChild((child, index) => {
            const fieldTag = tags[index];
            if (fieldTag !== undefined) {
                const tagMatch = fieldTag === DEFAULT_VIEW_TAG ||
                    (tag !== DEFAULT_VIEW_TAG && (fieldTag & tag) !== 0);
                if (!tagMatch)
                    return;
            }
            if (child.isNew) {
                this.markVisible(child);
                this._markSubtreeVisible(child, tag);
            }
            else {
                this._add(child.ref, tag, false, false);
            }
        });
    }
    addParentOf(childChangeTree, tag) {
        const changeTree = childChangeTree.parent[$changes];
        const parentIndex = childChangeTree.parentIndex;
        if (!this.isVisible(changeTree)) {
            // view must have all "changeTree" parent tree
            this.markVisible(changeTree);
        }
        // Recurse all the way to the root REGARDLESS of whether this parent
        // is already visible. Walking the full chain keeps `view.changes`
        // topologically ordered by construction (ancestors touched before
        // the descendant's entry), and — crucially — re-queues the ancestor
        // binding ops every time: visibility bits are per-VIEW, but the ADD
        // ops they once queued are consumed per-ENCODE. With a shared view,
        // an earlier encode (for other clients) or a dropped backlog leaves
        // an already-visible ancestor whose binding a late-attached client
        // never received — its filtered-container refId would then arrive
        // unbound ("refId not found"). Re-writing the entry ops is cheap
        // (Map.set dedupes within a patch) and decodes as a no-op for
        // clients that already hold the refs. The entry-write below is
        // still gated on `hasFilteredFields` so non-filtered ancestors
        // don't emit redundant wire bytes (the decoder already knows them
        // via the shared encode pass).
        const parentChangeTree = changeTree.parent?.[$changes];
        if (parentChangeTree) {
            this.addParentOf(changeTree, tag);
        }
        // Skip the entry-write for non-filtered ancestors: their refIds
        // are already known to the decoder through the shared pass, and
        // an extra ADD on a non-filtered field's index would only emit
        // bytes for a no-op (`value === previousValue` on the decoder).
        if (!changeTree.hasFilteredFields)
            return;
        // add parent's tag properties
        if (changeTree.getChange(parentIndex) !== OPERATION.DELETE) {
            let changes = this.changes.get(changeTree.ref[$refId]);
            if (changes === undefined) {
                changes = new Map();
                this.changes.set(changeTree.ref[$refId], changes);
            }
            this.addTag(changeTree, tag);
            changes.set(parentIndex, OPERATION.ADD);
        }
    }
    /**
     * Walk `tree`'s parent chain to root and insert an empty entry into
     * `view.changes` for any ancestor not already present. Empty entries
     * are skipped by `encodeView` (`changes.size === 0` continue), so no
     * wire bytes are emitted — but the Map's insertion order now puts
     * each ancestor BEFORE the descendant entry that the caller is about
     * to write. Combined with `addParentOf`'s full-recursion walk on
     * `view.add`, this preserves the global invariant that
     * `view.changes` iteration order is topological.
     *
     * Iterative (not recursive) so the stack is bounded by tree depth
     * regardless of call patterns. Stops the walk as soon as it hits an
     * ancestor that's already in `view.changes` — at that point the
     * remainder of the chain is guaranteed to also be present (invariant
     * upheld by every prior caller).
     */
    _touchAncestorsOf(tree) {
        let cursor = tree.parent?.[$changes];
        if (cursor === undefined)
            return;
        // Collect the missing prefix of the chain, deepest-first. Only
        // FILTERED ancestors need entries — non-filtered ones never
        // appear in `view.changes` (mirrors the addParentOf gate), so
        // they don't need a Map slot reserved either.
        const stack = [];
        while (cursor !== undefined) {
            if (cursor.hasFilteredFields) {
                const refId = cursor.ref[$refId];
                if (this.changes.has(refId))
                    break;
                stack.push(cursor);
            }
            cursor = cursor.parent?.[$changes];
        }
        // Insert root-first so Map order is topological.
        for (let i = stack.length - 1; i >= 0; i--) {
            this.changes.set(stack[i].ref[$refId], new Map());
        }
    }
    remove(obj, tag = DEFAULT_VIEW_TAG, _isClear = false) {
        const changeTree = obj[$changes];
        if (!changeTree) {
            console.warn("StateView#remove(), invalid object:", obj);
            return this;
        }
        // ── Streamable-element unsubscribe ─────────────────────────────
        // Symmetric to the `add(streamElement)` routing: pull the element
        // out of the stream's per-view state. If it never made it to the
        // wire (still in pending), silent drop; if already sent, queue
        // DELETE via `view.changes` for the next encodeView drain.
        const parentStreamTree = changeTree.parent?.[$changes];
        if (parentStreamTree?.isStreamCollection) {
            this.unmarkVisible(changeTree);
            if (this.iterable && !_isClear) {
                spliceOne(this.items, this.items.indexOf(obj));
            }
            streamDequeueForView(changeTree.parent, this.id, changeTree.parent[$refId], changeTree.parentIndex, this.changes);
            this._recursiveDeleteVisibleChangeTree(changeTree);
            return this;
        }
        // ── Streamable-collection unsubscribe (the stream itself) ─────
        // Flush DELETE for every sent position and drop pending. After
        // this, the stream is marked invisible to this view — any future
        // `stream.add()` would still seed broadcast pending (if no views)
        // but would NOT re-seed per-view pending (user must re-subscribe).
        if (changeTree.isStreamCollection) {
            this.unmarkVisible(changeTree);
            if (this.iterable && !_isClear) {
                spliceOne(this.items, this.items.indexOf(obj));
            }
            const streamRef = changeTree.ref;
            const st = streamRef._stream;
            if (st !== undefined) {
                st.pendingByView.get(this.id)?.clear();
                const sent = st.sentByView.get(this.id);
                if (sent !== undefined && sent.size > 0) {
                    const streamRefId = streamRef[$refId];
                    let changes = this.changes.get(streamRefId);
                    if (changes === undefined) {
                        changes = new Map();
                        this.changes.set(streamRefId, changes);
                    }
                    for (const pos of sent)
                        changes.set(pos, OPERATION.DELETE);
                    sent.clear();
                }
            }
            return this;
        }
        this.unmarkVisible(changeTree);
        // remove from iterable list
        if (this.iterable &&
            !_isClear // no need to remove during clear(), as it will be cleared entirely
        ) {
            spliceOne(this.items, this.items.indexOf(obj));
        }
        const ref = changeTree.ref;
        const metadata = ref.constructor[Symbol.metadata]; // ArraySchema/MapSchema do not have metadata
        const refId = ref[$refId];
        // Pre-insert any missing ancestors into view.changes so the Map's
        // iteration order stays topological — the entries we're about to
        // write (either on this obj, or on its parent collection below)
        // must come AFTER every ancestor in the chain on the wire.
        this._touchAncestorsOf(changeTree);
        let changes = this.changes.get(refId);
        if (changes === undefined) {
            changes = new Map();
            this.changes.set(refId, changes);
        }
        if (tag === DEFAULT_VIEW_TAG) {
            // parent is collection (Map/Array)
            const parent = changeTree.parent;
            if (parent && !Metadata.isValidInstance(parent) && changeTree.isFiltered) {
                const parentRefId = parent[$refId];
                let changes = this.changes.get(parentRefId);
                if (changes === undefined) {
                    changes = new Map();
                    this.changes.set(parentRefId, changes);
                }
                else if (changes.get(changeTree.parentIndex) === OPERATION.ADD) {
                    //
                    // SAME PATCH ADD + REMOVE:
                    // The 'changes' of deleted structure should be ignored.
                    //
                    this.changes.delete(refId);
                }
                // DELETE / DELETE BY REF ID
                changes.set(changeTree.parentIndex, OPERATION.DELETE);
                // Remove child schema from visible set
                this._recursiveDeleteVisibleChangeTree(changeTree);
            }
            else {
                // delete all "tagged" properties.
                const names = changeTree.encDescriptor.names;
                metadata?.[$viewFieldIndexes]?.forEach((index) => {
                    changes.set(index, OPERATION.DELETE);
                    // Remove child structures of @view() fields from visible set.
                    // (They were added during view.add() via forEachChild)
                    const value = changeTree.ref[names[index]];
                    if (value?.[$changes]) {
                        this.unmarkVisible(value[$changes]);
                        this._recursiveDeleteVisibleChangeTree(value[$changes]);
                    }
                });
            }
        }
        else {
            // delete only tagged properties. `$fieldIndexesByViewTag` is
            // keyed per-bit, so a combined tag iterates each set bit.
            const names = changeTree.encDescriptor.names;
            const byTag = metadata?.[$fieldIndexesByViewTag];
            if (byTag !== undefined) {
                for (let bits = tag; bits > 0; bits &= bits - 1) {
                    byTag[bits & -bits]?.forEach((index) => {
                        changes.set(index, OPERATION.DELETE);
                        // Remove child structures from visible set
                        const value = changeTree.ref[names[index]];
                        if (value?.[$changes]) {
                            this.unmarkVisible(value[$changes]);
                            this._recursiveDeleteVisibleChangeTree(value[$changes]);
                        }
                    });
                }
            }
        }
        // remove tag bits for this view
        if (tag === undefined) {
            this.removeAllTagsOnTree(changeTree);
        }
        else {
            this.removeTag(changeTree, tag);
        }
        return this;
    }
    has(obj) {
        return this.isVisible(obj[$changes]);
    }
    hasTag(ob, tag = DEFAULT_VIEW_TAG) {
        return this.hasTagOnTree(ob[$changes], tag);
    }
    /**
     * Persistent subscription to a collection's contents. Unlike `add()`,
     * which is a one-shot bootstrap, `subscribe()` enrolls this view in
     * future content changes — every subsequent push / set / add to the
     * collection automatically flows to this view, and every removal
     * queues a DELETE op. Works on every collection type:
     *
     * - `ArraySchema` / `MapSchema` / `SetSchema` / `CollectionSchema`:
     *   new children are force-shipped immediately (equivalent to
     *   `view.add(child)` per item).
     * - `StreamSchema` (or `.stream()` maps/sets): new positions are
     *   enqueued into `_pendingByView` so the priority pass drains them
     *   respecting `maxPerTick`.
     *
     * Idempotent on re-subscribe. Subscribing to an already-subscribed
     * collection is a no-op.
     */
    subscribe(collection) {
        const tree = collection?.[$changes];
        if (!tree) {
            console.warn("StateView#subscribe(), invalid collection:", collection);
            return this;
        }
        if (this._root === undefined && tree.root !== undefined) {
            this._bindRoot(tree.root);
        }
        if (this.isSubscribed(tree))
            return this;
        // Mark collection visible so its own ADD/DELETE ops emit in the
        // view pass. Also flip on the subscription bit.
        this.markVisible(tree);
        this._setSubscribed(tree);
        // Bootstrap: walk current children and mark them visible to this
        // view. We DO NOT force-seed via `_addImmediate` / view.changes
        // — the encoder's natural emission paths handle it:
        //
        //   - `encodeAllView` (first-tick bootstrap): walks the tree
        //     structurally and emits every visible child.
        //   - Normal `encodeView` pass: walks `root.changes` and emits
        //     dirty children + parent collection's ADD ops.
        //
        // Seeding view.changes ourselves would cause duplicate emission,
        // fine for idempotent collections (Array/Map/Set dedup by index
        // or value), but breaks `CollectionSchema` which appends on
        // every decode-side ADD (no dedup).
        //
        // Streams are the exception — they bypass the recorder flow, so
        // subscription must enqueue positions into `_pendingByView`
        // where the priority pass drains them per `maxPerTick`.
        if (tree.isStreamCollection) {
            const streamable = collection;
            tree.forEachChild((_child, index) => {
                streamEnqueueForView(streamable, this.id, index);
            });
        }
        else {
            tree.forEachChild((child) => {
                this.markVisible(child);
            });
        }
        return this;
    }
    /**
     * End a persistent subscription. Queues DELETE for every already-sent
     * child and clears any pending. After this call, future content
     * changes on the collection no longer auto-flow to this view (though
     * direct `view.add(element)` calls still work for per-entity use).
     */
    unsubscribe(collection) {
        const tree = collection?.[$changes];
        if (!tree) {
            console.warn("StateView#unsubscribe(), invalid collection:", collection);
            return this;
        }
        if (!this.isSubscribed(tree))
            return this;
        this._clearSubscribed(tree);
        const collectionRefId = tree.ref[$refId];
        if (tree.isStreamCollection) {
            // Streams: clear pending + queue DELETE for everything in sent.
            const st = collection._stream;
            if (st !== undefined) {
                st.pendingByView.get(this.id)?.clear();
                const sent = st.sentByView.get(this.id);
                if (sent !== undefined && sent.size > 0) {
                    let changes = this.changes.get(collectionRefId);
                    if (changes === undefined) {
                        changes = new Map();
                        this.changes.set(collectionRefId, changes);
                    }
                    for (const pos of sent)
                        changes.set(pos, OPERATION.DELETE);
                    sent.clear();
                }
            }
        }
        else {
            // Non-streams: queue DELETE for every current child and
            // unmark their visibility so subsequent mutations stop
            // reaching this view.
            let changes = this.changes.get(collectionRefId);
            tree.forEachChild((childTree, index) => {
                if (changes === undefined) {
                    changes = new Map();
                    this.changes.set(collectionRefId, changes);
                }
                changes.set(index, OPERATION.DELETE);
                this.unmarkVisible(childTree);
            });
        }
        // Unmark the collection itself so future ops don't emit to this
        // view (add() / subscribe() again re-marks it).
        this.unmarkVisible(tree);
        return this;
    }
    clear() {
        if (!this.iterable) {
            throw new Error("StateView#clear() is only available for iterable StateView's. Use StateView(iterable: true) constructor.");
        }
        for (let i = 0, l = this.items.length; i < l; i++) {
            this.remove(this.items[i], DEFAULT_VIEW_TAG, true);
        }
        // clear items array
        this.items.length = 0;
    }
    isChangeTreeVisible(changeTree) {
        let isVisible = this.isVisible(changeTree);
        // The parent-visibility fallback handles child collections without
        // their own @view tag (see StateView.test.ts "should not be required
        // to manually call view.add() items to child arrays..."). The
        // `isVisibilitySharedWithParent` flag — precomputed at attach-time in
        // inheritedFlags.ts — short-circuits for the common case, and
        // `markVisible` memoizes so the branch fires at most once per
        // (tree, view) pair.
        if (!isVisible && changeTree.isVisibilitySharedWithParent) {
            if (this.isVisible(changeTree.parent[$changes])) {
                this.markVisible(changeTree);
                isVisible = true;
            }
        }
        return isVisible;
    }
    _recursiveDeleteVisibleChangeTree(changeTree) {
        changeTree.forEachChild((childChangeTree) => {
            this.unmarkVisible(childChangeTree);
            this._recursiveDeleteVisibleChangeTree(childChangeTree);
        });
    }
}

registerType("map", { constructor: MapSchema });
registerType("array", { constructor: ArraySchema });
registerType("set", { constructor: SetSchema });
registerType("collection", { constructor: CollectionSchema, });

export { $changes, $childType, $decoder, $deleteByIndex, $encoder, $filter, $getByIndex, $numFields, $refId, $track, $values, ArraySchema, Callbacks, ChangeTree, CollectionSchema, Decoder, Encoder, FieldBuilder, MapSchema, Metadata, OPERATION, Reflection, ReflectionField, ReflectionType, Root, Schema, SetSchema, StateCallbackStrategy, StateView, StreamSchema, TypeContext, createPool, decode, decodeKeyValueOperation, decodeSchemaOperation, defineCustomTypes, deprecated, dumpChanges, encode, encodeArray, encodeIndexedEntry, encodeKeyValueOperation, encodeMapEntry, encodeSchemaOperation, entity, getDecoderStateCallbacks, getEncodeDescriptor, getRawChangesCallback, isBuilder, owned, registerType, schema, t, transient, type, unreliable, view };
//# sourceMappingURL=index.mjs.map
